/**
 * @author Rich Tibbett / https://github.com/richtr
 * @author mrdoob / http://mrdoob.com/
 * @author Tony Parisi / http://www.tonyparisi.com/
 * @author Takahiro / https://github.com/takahirox
 * @author Don McCurdy / https://www.donmccurdy.com
 */


module.exports = function(THREE) {

    var egmDecoder = function(t) {
        var e = {};

        function r(n) { if (e[n]) return e[n].exports; var i = e[n] = { i: n, l: !1, exports: {} }; return t[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports }
        return r.m = t, r.c = e, r.d = function(t, e, n) { r.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: n }) }, r.r = function(t) { "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 }) }, r.t = function(t, e) {
            if (1 & e && (t = r(t)), 8 & e) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", { enumerable: !0, value: t }), 2 & e && "string" != typeof t)
                for (var i in t) r.d(n, i, function(e) { return t[e] }.bind(null, i));
            return n
        }, r.n = function(t) { var e = t && t.__esModule ? function() { return t.default } : function() { return t }; return r.d(e, "a", e), e }, r.o = function(t, e) { return Object.prototype.hasOwnProperty.call(t, e) }, r.p = "", r(r.s = 31)
    }([function(t, e, r) {
        var n = r(7),
            i = n.Buffer;

        function o(t, e) { for (var r in t) e[r] = t[r] }

        function a(t, e, r) { return i(t, e, r) } i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = n : (o(n, e), e.Buffer = a), o(i, a), a.from = function(t, e, r) { if ("number" == typeof t) throw new TypeError("Argument must not be a number"); return i(t, e, r) }, a.alloc = function(t, e, r) { if ("number" != typeof t) throw new TypeError("Argument must be a number"); var n = i(t); return void 0 !== e ? "string" == typeof r ? n.fill(e, r) : n.fill(e) : n.fill(0), n }, a.allocUnsafe = function(t) { if ("number" != typeof t) throw new TypeError("Argument must be a number"); return i(t) }, a.allocUnsafeSlow = function(t) { if ("number" != typeof t) throw new TypeError("Argument must be a number"); return n.SlowBuffer(t) }
    }, function(t, e) {
        "function" == typeof Object.create ? t.exports = function(t, e) { t.super_ = e, t.prototype = Object.create(e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }) } : t.exports = function(t, e) {
            t.super_ = e;
            var r = function() {};
            r.prototype = e.prototype, t.prototype = new r, t.prototype.constructor = t
        }
    }, function(t, e, r) {
        "use strict";
        var n = r(9),
            i = Object.keys || function(t) { var e = []; for (var r in t) e.push(r); return e };
        t.exports = c;
        var o = r(5);
        o.inherits = r(1);
        var a = r(22),
            s = r(15);
        o.inherits(c, a);
        for (var f = i(s.prototype), u = 0; u < f.length; u++) {
            var h = f[u];
            c.prototype[h] || (c.prototype[h] = s.prototype[h])
        }

        function c(t) {
            if (!(this instanceof c)) return new c(t);
            a.call(this, t), s.call(this, t), t && !1 === t.readable && (this.readable = !1), t && !1 === t.writable && (this.writable = !1), this.allowHalfOpen = !0, t && !1 === t.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", l)
        }

        function l() { this.allowHalfOpen || this._writableState.ended || n.nextTick(d, this) }

        function d(t) { t.end() } Object.defineProperty(c.prototype, "writableHighWaterMark", { enumerable: !1, get: function() { return this._writableState.highWaterMark } }), Object.defineProperty(c.prototype, "destroyed", { get: function() { return void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed && this._writableState.destroyed) }, set: function(t) { void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = t, this._writableState.destroyed = t) } }), c.prototype._destroy = function(t, e) { this.push(null), this.end(), n.nextTick(e, t) }
    }, function(t, e) {
        var r;
        r = function() { return this }();
        try { r = r || new Function("return this")() } catch (t) { "object" == typeof window && (r = window) } t.exports = r
    }, function(t, e, r) {
        var n = r(0).Buffer,
            i = r(21).Transform,
            o = r(16).StringDecoder;

        function a(t) { i.call(this), this.hashMode = "string" == typeof t, this.hashMode ? this[t] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null } r(1)(a, i), a.prototype.update = function(t, e, r) { "string" == typeof t && (t = n.from(t, e)); var i = this._update(t); return this.hashMode ? this : (r && (i = this._toString(i, r)), i) }, a.prototype.setAutoPadding = function() {}, a.prototype.getAuthTag = function() { throw new Error("trying to get auth tag in unsupported state") }, a.prototype.setAuthTag = function() { throw new Error("trying to set auth tag in unsupported state") }, a.prototype.setAAD = function() { throw new Error("trying to set aad in unsupported state") }, a.prototype._transform = function(t, e, r) { var n; try { this.hashMode ? this._update(t) : this.push(this._update(t)) } catch (t) { n = t } finally { r(n) } }, a.prototype._flush = function(t) { var e; try { this.push(this.__final()) } catch (t) { e = t } t(e) }, a.prototype._finalOrDigest = function(t) { var e = this.__final() || n.alloc(0); return t && (e = this._toString(e, t, !0)), e }, a.prototype._toString = function(t, e, r) { if (this._decoder || (this._decoder = new o(e), this._encoding = e), this._encoding !== e) throw new Error("can't switch encodings"); var n = this._decoder.write(t); return r && (n += this._decoder.end()), n }, t.exports = a
    }, function(t, e, r) {
        (function(t) {
            function r(t) { return Object.prototype.toString.call(t) } e.isArray = function(t) { return Array.isArray ? Array.isArray(t) : "[object Array]" === r(t) }, e.isBoolean = function(t) { return "boolean" == typeof t }, e.isNull = function(t) { return null === t }, e.isNullOrUndefined = function(t) { return null == t }, e.isNumber = function(t) { return "number" == typeof t }, e.isString = function(t) { return "string" == typeof t }, e.isSymbol = function(t) { return "symbol" == typeof t }, e.isUndefined = function(t) { return void 0 === t }, e.isRegExp = function(t) { return "[object RegExp]" === r(t) }, e.isObject = function(t) { return "object" == typeof t && null !== t }, e.isDate = function(t) { return "[object Date]" === r(t) }, e.isError = function(t) { return "[object Error]" === r(t) || t instanceof Error }, e.isFunction = function(t) { return "function" == typeof t }, e.isPrimitive = function(t) { return null === t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || "symbol" == typeof t || void 0 === t }, e.isBuffer = t.isBuffer
        }).call(this, r(7).Buffer)
    }, function(t, e, r) {
        (function(e) { t.exports = function(t, r) { for (var n = Math.min(t.length, r.length), i = new e(n), o = 0; o < n; ++o) i[o] = t[o] ^ r[o]; return i } }).call(this, r(7).Buffer)
    }, function(t, e, r) {
        "use strict";
        (function(t) {
            /*!
             * The buffer module from node.js, for the browser.
             *
             * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
             * @license  MIT
             */
            var n = r(34),
                i = r(35),
                o = r(20);

            function a() { return f.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823 }

            function s(t, e) { if (a() < e) throw new RangeError("Invalid typed array length"); return f.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = f.prototype : (null === t && (t = new f(e)), t.length = e), t }

            function f(t, e, r) { if (!(f.TYPED_ARRAY_SUPPORT || this instanceof f)) return new f(t, e, r); if ("number" == typeof t) { if ("string" == typeof e) throw new Error("If encoding is specified then the first argument must be a string"); return c(this, t) } return u(this, t, e, r) }

            function u(t, e, r, n) {
                if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
                return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? function(t, e, r, n) {
                    if (e.byteLength, r < 0 || e.byteLength < r) throw new RangeError("'offset' is out of bounds");
                    if (e.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
                    e = void 0 === r && void 0 === n ? new Uint8Array(e) : void 0 === n ? new Uint8Array(e, r) : new Uint8Array(e, r, n);
                    f.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = f.prototype : t = l(t, e);
                    return t
                }(t, e, r, n) : "string" == typeof e ? function(t, e, r) {
                    "string" == typeof r && "" !== r || (r = "utf8");
                    if (!f.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
                    var n = 0 | p(e, r),
                        i = (t = s(t, n)).write(e, r);
                    i !== n && (t = t.slice(0, i));
                    return t
                }(t, e, r) : function(t, e) { if (f.isBuffer(e)) { var r = 0 | d(e.length); return 0 === (t = s(t, r)).length ? t : (e.copy(t, 0, 0, r), t) } if (e) { if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" != typeof e.length || (n = e.length) != n ? s(t, 0) : l(t, e); if ("Buffer" === e.type && o(e.data)) return l(t, e.data) } var n; throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.") }(t, e)
            }

            function h(t) { if ("number" != typeof t) throw new TypeError('"size" argument must be a number'); if (t < 0) throw new RangeError('"size" argument must not be negative') }

            function c(t, e) {
                if (h(e), t = s(t, e < 0 ? 0 : 0 | d(e)), !f.TYPED_ARRAY_SUPPORT)
                    for (var r = 0; r < e; ++r) t[r] = 0;
                return t
            }

            function l(t, e) {
                var r = e.length < 0 ? 0 : 0 | d(e.length);
                t = s(t, r);
                for (var n = 0; n < r; n += 1) t[n] = 255 & e[n];
                return t
            }

            function d(t) { if (t >= a()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a().toString(16) + " bytes"); return 0 | t }

            function p(t, e) {
                if (f.isBuffer(t)) return t.length;
                if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
                "string" != typeof t && (t = "" + t);
                var r = t.length;
                if (0 === r) return 0;
                for (var n = !1;;) switch (e) {
                    case "ascii":
                    case "latin1":
                    case "binary":
                        return r;
                    case "utf8":
                    case "utf-8":
                    case void 0:
                        return F(t).length;
                    case "ucs2":
                    case "ucs-2":
                    case "utf16le":
                    case "utf-16le":
                        return 2 * r;
                    case "hex":
                        return r >>> 1;
                    case "base64":
                        return z(t).length;
                    default:
                        if (n) return F(t).length;
                        e = ("" + e).toLowerCase(), n = !0
                }
            }

            function y(t, e, r) {
                var n = t[e];
                t[e] = t[r], t[r] = n
            }

            function g(t, e, r, n, i) {
                if (0 === t.length) return -1;
                if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = i ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
                    if (i) return -1;
                    r = t.length - 1
                } else if (r < 0) {
                    if (!i) return -1;
                    r = 0
                }
                if ("string" == typeof e && (e = f.from(e, n)), f.isBuffer(e)) return 0 === e.length ? -1 : v(t, e, r, n, i);
                if ("number" == typeof e) return e &= 255, f.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : v(t, [e], r, n, i);
                throw new TypeError("val must be string, number or Buffer")
            }

            function v(t, e, r, n, i) {
                var o, a = 1,
                    s = t.length,
                    f = e.length;
                if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
                    if (t.length < 2 || e.length < 2) return -1;
                    a = 2, s /= 2, f /= 2, r /= 2
                }

                function u(t, e) { return 1 === a ? t[e] : t.readUInt16BE(e * a) }
                if (i) {
                    var h = -1;
                    for (o = r; o < s; o++)
                        if (u(t, o) === u(e, -1 === h ? 0 : o - h)) { if (-1 === h && (h = o), o - h + 1 === f) return h * a } else -1 !== h && (o -= o - h), h = -1
                } else
                    for (r + f > s && (r = s - f), o = r; o >= 0; o--) {
                        for (var c = !0, l = 0; l < f; l++)
                            if (u(t, o + l) !== u(e, l)) { c = !1; break } if (c) return o
                    }
                return -1
            }

            function b(t, e, r, n) {
                r = Number(r) || 0;
                var i = t.length - r;
                n ? (n = Number(n)) > i && (n = i) : n = i;
                var o = e.length;
                if (o % 2 != 0) throw new TypeError("Invalid hex string");
                n > o / 2 && (n = o / 2);
                for (var a = 0; a < n; ++a) {
                    var s = parseInt(e.substr(2 * a, 2), 16);
                    if (isNaN(s)) return a;
                    t[r + a] = s
                }
                return a
            }

            function w(t, e, r, n) { return Y(F(e, t.length - r), t, r, n) }

            function _(t, e, r, n) { return Y(function(t) { for (var e = [], r = 0; r < t.length; ++r) e.push(255 & t.charCodeAt(r)); return e }(e), t, r, n) }

            function m(t, e, r, n) { return _(t, e, r, n) }

            function k(t, e, r, n) { return Y(z(e), t, r, n) }

            function E(t, e, r, n) { return Y(function(t, e) { for (var r, n, i, o = [], a = 0; a < t.length && !((e -= 2) < 0); ++a) r = t.charCodeAt(a), n = r >> 8, i = r % 256, o.push(i), o.push(n); return o }(e, t.length - r), t, r, n) }

            function S(t, e, r) { return 0 === e && r === t.length ? n.fromByteArray(t) : n.fromByteArray(t.slice(e, r)) }

            function B(t, e, r) {
                r = Math.min(t.length, r);
                for (var n = [], i = e; i < r;) {
                    var o, a, s, f, u = t[i],
                        h = null,
                        c = u > 239 ? 4 : u > 223 ? 3 : u > 191 ? 2 : 1;
                    if (i + c <= r) switch (c) {
                        case 1:
                            u < 128 && (h = u);
                            break;
                        case 2:
                            128 == (192 & (o = t[i + 1])) && (f = (31 & u) << 6 | 63 & o) > 127 && (h = f);
                            break;
                        case 3:
                            o = t[i + 1], a = t[i + 2], 128 == (192 & o) && 128 == (192 & a) && (f = (15 & u) << 12 | (63 & o) << 6 | 63 & a) > 2047 && (f < 55296 || f > 57343) && (h = f);
                            break;
                        case 4:
                            o = t[i + 1], a = t[i + 2], s = t[i + 3], 128 == (192 & o) && 128 == (192 & a) && 128 == (192 & s) && (f = (15 & u) << 18 | (63 & o) << 12 | (63 & a) << 6 | 63 & s) > 65535 && f < 1114112 && (h = f)
                    }
                    null === h ? (h = 65533, c = 1) : h > 65535 && (h -= 65536, n.push(h >>> 10 & 1023 | 55296), h = 56320 | 1023 & h), n.push(h), i += c
                }
                return function(t) {
                    var e = t.length;
                    if (e <= x) return String.fromCharCode.apply(String, t);
                    var r = "",
                        n = 0;
                    for (; n < e;) r += String.fromCharCode.apply(String, t.slice(n, n += x));
                    return r
                }(n)
            }
            e.Buffer = f, e.SlowBuffer = function(t) {+t != t && (t = 0); return f.alloc(+t) }, e.INSPECT_MAX_BYTES = 50, f.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : function() { try { var t = new Uint8Array(1); return t.__proto__ = { __proto__: Uint8Array.prototype, foo: function() { return 42 } }, 42 === t.foo() && "function" == typeof t.subarray && 0 === t.subarray(1, 1).byteLength } catch (t) { return !1 } }(), e.kMaxLength = a(), f.poolSize = 8192, f._augment = function(t) { return t.__proto__ = f.prototype, t }, f.from = function(t, e, r) { return u(null, t, e, r) }, f.TYPED_ARRAY_SUPPORT && (f.prototype.__proto__ = Uint8Array.prototype, f.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && f[Symbol.species] === f && Object.defineProperty(f, Symbol.species, { value: null, configurable: !0 })), f.alloc = function(t, e, r) { return function(t, e, r, n) { return h(e), e <= 0 ? s(t, e) : void 0 !== r ? "string" == typeof n ? s(t, e).fill(r, n) : s(t, e).fill(r) : s(t, e) }(null, t, e, r) }, f.allocUnsafe = function(t) { return c(null, t) }, f.allocUnsafeSlow = function(t) { return c(null, t) }, f.isBuffer = function(t) { return !(null == t || !t._isBuffer) }, f.compare = function(t, e) {
                if (!f.isBuffer(t) || !f.isBuffer(e)) throw new TypeError("Arguments must be Buffers");
                if (t === e) return 0;
                for (var r = t.length, n = e.length, i = 0, o = Math.min(r, n); i < o; ++i)
                    if (t[i] !== e[i]) { r = t[i], n = e[i]; break } return r < n ? -1 : n < r ? 1 : 0
            }, f.isEncoding = function(t) {
                switch (String(t).toLowerCase()) {
                    case "hex":
                    case "utf8":
                    case "utf-8":
                    case "ascii":
                    case "latin1":
                    case "binary":
                    case "base64":
                    case "ucs2":
                    case "ucs-2":
                    case "utf16le":
                    case "utf-16le":
                        return !0;
                    default:
                        return !1
                }
            }, f.concat = function(t, e) {
                if (!o(t)) throw new TypeError('"list" argument must be an Array of Buffers');
                if (0 === t.length) return f.alloc(0);
                var r;
                if (void 0 === e)
                    for (e = 0, r = 0; r < t.length; ++r) e += t[r].length;
                var n = f.allocUnsafe(e),
                    i = 0;
                for (r = 0; r < t.length; ++r) {
                    var a = t[r];
                    if (!f.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
                    a.copy(n, i), i += a.length
                }
                return n
            }, f.byteLength = p, f.prototype._isBuffer = !0, f.prototype.swap16 = function() { var t = this.length; if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits"); for (var e = 0; e < t; e += 2) y(this, e, e + 1); return this }, f.prototype.swap32 = function() { var t = this.length; if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits"); for (var e = 0; e < t; e += 4) y(this, e, e + 3), y(this, e + 1, e + 2); return this }, f.prototype.swap64 = function() { var t = this.length; if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits"); for (var e = 0; e < t; e += 8) y(this, e, e + 7), y(this, e + 1, e + 6), y(this, e + 2, e + 5), y(this, e + 3, e + 4); return this }, f.prototype.toString = function() {
                var t = 0 | this.length;
                return 0 === t ? "" : 0 === arguments.length ? B(this, 0, t) : function(t, e, r) {
                    var n = !1;
                    if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
                    if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
                    if ((r >>>= 0) <= (e >>>= 0)) return "";
                    for (t || (t = "utf8");;) switch (t) {
                        case "hex":
                            return C(this, e, r);
                        case "utf8":
                        case "utf-8":
                            return B(this, e, r);
                        case "ascii":
                            return A(this, e, r);
                        case "latin1":
                        case "binary":
                            return T(this, e, r);
                        case "base64":
                            return S(this, e, r);
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return R(this, e, r);
                        default:
                            if (n) throw new TypeError("Unknown encoding: " + t);
                            t = (t + "").toLowerCase(), n = !0
                    }
                }.apply(this, arguments)
            }, f.prototype.equals = function(t) { if (!f.isBuffer(t)) throw new TypeError("Argument must be a Buffer"); return this === t || 0 === f.compare(this, t) }, f.prototype.inspect = function() {
                var t = "",
                    r = e.INSPECT_MAX_BYTES;
                return this.length > 0 && (t = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (t += " ... ")), "<Buffer " + t + ">"
            }, f.prototype.compare = function(t, e, r, n, i) {
                if (!f.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
                if (void 0 === e && (e = 0), void 0 === r && (r = t ? t.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), e < 0 || r > t.length || n < 0 || i > this.length) throw new RangeError("out of range index");
                if (n >= i && e >= r) return 0;
                if (n >= i) return -1;
                if (e >= r) return 1;
                if (this === t) return 0;
                for (var o = (i >>>= 0) - (n >>>= 0), a = (r >>>= 0) - (e >>>= 0), s = Math.min(o, a), u = this.slice(n, i), h = t.slice(e, r), c = 0; c < s; ++c)
                    if (u[c] !== h[c]) { o = u[c], a = h[c]; break } return o < a ? -1 : a < o ? 1 : 0
            }, f.prototype.includes = function(t, e, r) { return -1 !== this.indexOf(t, e, r) }, f.prototype.indexOf = function(t, e, r) { return g(this, t, e, r, !0) }, f.prototype.lastIndexOf = function(t, e, r) { return g(this, t, e, r, !1) }, f.prototype.write = function(t, e, r, n) {
                if (void 0 === e) n = "utf8", r = this.length, e = 0;
                else if (void 0 === r && "string" == typeof e) n = e, r = this.length, e = 0;
                else {
                    if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                    e |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0)
                }
                var i = this.length - e;
                if ((void 0 === r || r > i) && (r = i), t.length > 0 && (r < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                n || (n = "utf8");
                for (var o = !1;;) switch (n) {
                    case "hex":
                        return b(this, t, e, r);
                    case "utf8":
                    case "utf-8":
                        return w(this, t, e, r);
                    case "ascii":
                        return _(this, t, e, r);
                    case "latin1":
                    case "binary":
                        return m(this, t, e, r);
                    case "base64":
                        return k(this, t, e, r);
                    case "ucs2":
                    case "ucs-2":
                    case "utf16le":
                    case "utf-16le":
                        return E(this, t, e, r);
                    default:
                        if (o) throw new TypeError("Unknown encoding: " + n);
                        n = ("" + n).toLowerCase(), o = !0
                }
            }, f.prototype.toJSON = function() { return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) } };
            var x = 4096;

            function A(t, e, r) {
                var n = "";
                r = Math.min(t.length, r);
                for (var i = e; i < r; ++i) n += String.fromCharCode(127 & t[i]);
                return n
            }

            function T(t, e, r) {
                var n = "";
                r = Math.min(t.length, r);
                for (var i = e; i < r; ++i) n += String.fromCharCode(t[i]);
                return n
            }

            function C(t, e, r) {
                var n = t.length;
                (!e || e < 0) && (e = 0), (!r || r < 0 || r > n) && (r = n);
                for (var i = "", o = e; o < r; ++o) i += j(t[o]);
                return i
            }

            function R(t, e, r) { for (var n = t.slice(e, r), i = "", o = 0; o < n.length; o += 2) i += String.fromCharCode(n[o] + 256 * n[o + 1]); return i }

            function O(t, e, r) { if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint"); if (t + e > r) throw new RangeError("Trying to access beyond buffer length") }

            function I(t, e, r, n, i, o) { if (!f.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance'); if (e > i || e < o) throw new RangeError('"value" argument is out of bounds'); if (r + n > t.length) throw new RangeError("Index out of range") }

            function U(t, e, r, n) { e < 0 && (e = 65535 + e + 1); for (var i = 0, o = Math.min(t.length - r, 2); i < o; ++i) t[r + i] = (e & 255 << 8 * (n ? i : 1 - i)) >>> 8 * (n ? i : 1 - i) }

            function M(t, e, r, n) { e < 0 && (e = 4294967295 + e + 1); for (var i = 0, o = Math.min(t.length - r, 4); i < o; ++i) t[r + i] = e >>> 8 * (n ? i : 3 - i) & 255 }

            function L(t, e, r, n, i, o) { if (r + n > t.length) throw new RangeError("Index out of range"); if (r < 0) throw new RangeError("Index out of range") }

            function D(t, e, r, n, o) { return o || L(t, 0, r, 4), i.write(t, e, r, n, 23, 4), r + 4 }

            function P(t, e, r, n, o) { return o || L(t, 0, r, 8), i.write(t, e, r, n, 52, 8), r + 8 } f.prototype.slice = function(t, e) {
                var r, n = this.length;
                if ((t = ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), (e = void 0 === e ? n : ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), e < t && (e = t), f.TYPED_ARRAY_SUPPORT)(r = this.subarray(t, e)).__proto__ = f.prototype;
                else {
                    var i = e - t;
                    r = new f(i, void 0);
                    for (var o = 0; o < i; ++o) r[o] = this[o + t]
                }
                return r
            }, f.prototype.readUIntLE = function(t, e, r) { t |= 0, e |= 0, r || O(t, e, this.length); for (var n = this[t], i = 1, o = 0; ++o < e && (i *= 256);) n += this[t + o] * i; return n }, f.prototype.readUIntBE = function(t, e, r) { t |= 0, e |= 0, r || O(t, e, this.length); for (var n = this[t + --e], i = 1; e > 0 && (i *= 256);) n += this[t + --e] * i; return n }, f.prototype.readUInt8 = function(t, e) { return e || O(t, 1, this.length), this[t] }, f.prototype.readUInt16LE = function(t, e) { return e || O(t, 2, this.length), this[t] | this[t + 1] << 8 }, f.prototype.readUInt16BE = function(t, e) { return e || O(t, 2, this.length), this[t] << 8 | this[t + 1] }, f.prototype.readUInt32LE = function(t, e) { return e || O(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3] }, f.prototype.readUInt32BE = function(t, e) { return e || O(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]) }, f.prototype.readIntLE = function(t, e, r) { t |= 0, e |= 0, r || O(t, e, this.length); for (var n = this[t], i = 1, o = 0; ++o < e && (i *= 256);) n += this[t + o] * i; return n >= (i *= 128) && (n -= Math.pow(2, 8 * e)), n }, f.prototype.readIntBE = function(t, e, r) { t |= 0, e |= 0, r || O(t, e, this.length); for (var n = e, i = 1, o = this[t + --n]; n > 0 && (i *= 256);) o += this[t + --n] * i; return o >= (i *= 128) && (o -= Math.pow(2, 8 * e)), o }, f.prototype.readInt8 = function(t, e) { return e || O(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t] }, f.prototype.readInt16LE = function(t, e) { e || O(t, 2, this.length); var r = this[t] | this[t + 1] << 8; return 32768 & r ? 4294901760 | r : r }, f.prototype.readInt16BE = function(t, e) { e || O(t, 2, this.length); var r = this[t + 1] | this[t] << 8; return 32768 & r ? 4294901760 | r : r }, f.prototype.readInt32LE = function(t, e) { return e || O(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24 }, f.prototype.readInt32BE = function(t, e) { return e || O(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3] }, f.prototype.readFloatLE = function(t, e) { return e || O(t, 4, this.length), i.read(this, t, !0, 23, 4) }, f.prototype.readFloatBE = function(t, e) { return e || O(t, 4, this.length), i.read(this, t, !1, 23, 4) }, f.prototype.readDoubleLE = function(t, e) { return e || O(t, 8, this.length), i.read(this, t, !0, 52, 8) }, f.prototype.readDoubleBE = function(t, e) { return e || O(t, 8, this.length), i.read(this, t, !1, 52, 8) }, f.prototype.writeUIntLE = function(t, e, r, n) {
                (t = +t, e |= 0, r |= 0, n) || I(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
                var i = 1,
                    o = 0;
                for (this[e] = 255 & t; ++o < r && (i *= 256);) this[e + o] = t / i & 255;
                return e + r
            }, f.prototype.writeUIntBE = function(t, e, r, n) {
                (t = +t, e |= 0, r |= 0, n) || I(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
                var i = r - 1,
                    o = 1;
                for (this[e + i] = 255 & t; --i >= 0 && (o *= 256);) this[e + i] = t / o & 255;
                return e + r
            }, f.prototype.writeUInt8 = function(t, e, r) { return t = +t, e |= 0, r || I(this, t, e, 1, 255, 0), f.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1 }, f.prototype.writeUInt16LE = function(t, e, r) { return t = +t, e |= 0, r || I(this, t, e, 2, 65535, 0), f.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : U(this, t, e, !0), e + 2 }, f.prototype.writeUInt16BE = function(t, e, r) { return t = +t, e |= 0, r || I(this, t, e, 2, 65535, 0), f.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : U(this, t, e, !1), e + 2 }, f.prototype.writeUInt32LE = function(t, e, r) { return t = +t, e |= 0, r || I(this, t, e, 4, 4294967295, 0), f.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : M(this, t, e, !0), e + 4 }, f.prototype.writeUInt32BE = function(t, e, r) { return t = +t, e |= 0, r || I(this, t, e, 4, 4294967295, 0), f.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : M(this, t, e, !1), e + 4 }, f.prototype.writeIntLE = function(t, e, r, n) {
                if (t = +t, e |= 0, !n) {
                    var i = Math.pow(2, 8 * r - 1);
                    I(this, t, e, r, i - 1, -i)
                }
                var o = 0,
                    a = 1,
                    s = 0;
                for (this[e] = 255 & t; ++o < r && (a *= 256);) t < 0 && 0 === s && 0 !== this[e + o - 1] && (s = 1), this[e + o] = (t / a >> 0) - s & 255;
                return e + r
            }, f.prototype.writeIntBE = function(t, e, r, n) {
                if (t = +t, e |= 0, !n) {
                    var i = Math.pow(2, 8 * r - 1);
                    I(this, t, e, r, i - 1, -i)
                }
                var o = r - 1,
                    a = 1,
                    s = 0;
                for (this[e + o] = 255 & t; --o >= 0 && (a *= 256);) t < 0 && 0 === s && 0 !== this[e + o + 1] && (s = 1), this[e + o] = (t / a >> 0) - s & 255;
                return e + r
            }, f.prototype.writeInt8 = function(t, e, r) { return t = +t, e |= 0, r || I(this, t, e, 1, 127, -128), f.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1 }, f.prototype.writeInt16LE = function(t, e, r) { return t = +t, e |= 0, r || I(this, t, e, 2, 32767, -32768), f.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : U(this, t, e, !0), e + 2 }, f.prototype.writeInt16BE = function(t, e, r) { return t = +t, e |= 0, r || I(this, t, e, 2, 32767, -32768), f.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : U(this, t, e, !1), e + 2 }, f.prototype.writeInt32LE = function(t, e, r) { return t = +t, e |= 0, r || I(this, t, e, 4, 2147483647, -2147483648), f.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : M(this, t, e, !0), e + 4 }, f.prototype.writeInt32BE = function(t, e, r) { return t = +t, e |= 0, r || I(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), f.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : M(this, t, e, !1), e + 4 }, f.prototype.writeFloatLE = function(t, e, r) { return D(this, t, e, !0, r) }, f.prototype.writeFloatBE = function(t, e, r) { return D(this, t, e, !1, r) }, f.prototype.writeDoubleLE = function(t, e, r) { return P(this, t, e, !0, r) }, f.prototype.writeDoubleBE = function(t, e, r) { return P(this, t, e, !1, r) }, f.prototype.copy = function(t, e, r, n) {
                if (r || (r = 0), n || 0 === n || (n = this.length), e >= t.length && (e = t.length), e || (e = 0), n > 0 && n < r && (n = r), n === r) return 0;
                if (0 === t.length || 0 === this.length) return 0;
                if (e < 0) throw new RangeError("targetStart out of bounds");
                if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
                if (n < 0) throw new RangeError("sourceEnd out of bounds");
                n > this.length && (n = this.length), t.length - e < n - r && (n = t.length - e + r);
                var i, o = n - r;
                if (this === t && r < e && e < n)
                    for (i = o - 1; i >= 0; --i) t[i + e] = this[i + r];
                else if (o < 1e3 || !f.TYPED_ARRAY_SUPPORT)
                    for (i = 0; i < o; ++i) t[i + e] = this[i + r];
                else Uint8Array.prototype.set.call(t, this.subarray(r, r + o), e);
                return o
            }, f.prototype.fill = function(t, e, r, n) {
                if ("string" == typeof t) {
                    if ("string" == typeof e ? (n = e, e = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === t.length) {
                        var i = t.charCodeAt(0);
                        i < 256 && (t = i)
                    }
                    if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
                    if ("string" == typeof n && !f.isEncoding(n)) throw new TypeError("Unknown encoding: " + n)
                } else "number" == typeof t && (t &= 255);
                if (e < 0 || this.length < e || this.length < r) throw new RangeError("Out of range index");
                if (r <= e) return this;
                var o;
                if (e >>>= 0, r = void 0 === r ? this.length : r >>> 0, t || (t = 0), "number" == typeof t)
                    for (o = e; o < r; ++o) this[o] = t;
                else {
                    var a = f.isBuffer(t) ? t : F(new f(t, n).toString()),
                        s = a.length;
                    for (o = 0; o < r - e; ++o) this[o + e] = a[o % s]
                }
                return this
            };
            var N = /[^+\/0-9A-Za-z-_]/g;

            function j(t) { return t < 16 ? "0" + t.toString(16) : t.toString(16) }

            function F(t, e) {
                var r;
                e = e || 1 / 0;
                for (var n = t.length, i = null, o = [], a = 0; a < n; ++a) {
                    if ((r = t.charCodeAt(a)) > 55295 && r < 57344) {
                        if (!i) {
                            if (r > 56319) {
                                (e -= 3) > -1 && o.push(239, 191, 189);
                                continue
                            }
                            if (a + 1 === n) {
                                (e -= 3) > -1 && o.push(239, 191, 189);
                                continue
                            }
                            i = r;
                            continue
                        }
                        if (r < 56320) {
                            (e -= 3) > -1 && o.push(239, 191, 189), i = r;
                            continue
                        }
                        r = 65536 + (i - 55296 << 10 | r - 56320)
                    } else i && (e -= 3) > -1 && o.push(239, 191, 189);
                    if (i = null, r < 128) {
                        if ((e -= 1) < 0) break;
                        o.push(r)
                    } else if (r < 2048) {
                        if ((e -= 2) < 0) break;
                        o.push(r >> 6 | 192, 63 & r | 128)
                    } else if (r < 65536) {
                        if ((e -= 3) < 0) break;
                        o.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128)
                    } else {
                        if (!(r < 1114112)) throw new Error("Invalid code point");
                        if ((e -= 4) < 0) break;
                        o.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128)
                    }
                }
                return o
            }

            function z(t) { return n.toByteArray(function(t) { if ((t = function(t) { return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "") }(t).replace(N, "")).length < 2) return ""; for (; t.length % 4 != 0;) t += "="; return t }(t)) }

            function Y(t, e, r, n) { for (var i = 0; i < n && !(i + r >= e.length || i >= t.length); ++i) e[i + r] = t[i]; return i }
        }).call(this, r(3))
    }, function(t, e) {
        var r, n, i = t.exports = {};

        function o() { throw new Error("setTimeout has not been defined") }

        function a() { throw new Error("clearTimeout has not been defined") }

        function s(t) { if (r === setTimeout) return setTimeout(t, 0); if ((r === o || !r) && setTimeout) return r = setTimeout, setTimeout(t, 0); try { return r(t, 0) } catch (e) { try { return r.call(null, t, 0) } catch (e) { return r.call(this, t, 0) } } }! function() { try { r = "function" == typeof setTimeout ? setTimeout : o } catch (t) { r = o } try { n = "function" == typeof clearTimeout ? clearTimeout : a } catch (t) { n = a } }();
        var f, u = [],
            h = !1,
            c = -1;

        function l() { h && f && (h = !1, f.length ? u = f.concat(u) : c = -1, u.length && d()) }

        function d() {
            if (!h) {
                var t = s(l);
                h = !0;
                for (var e = u.length; e;) {
                    for (f = u, u = []; ++c < e;) f && f[c].run();
                    c = -1, e = u.length
                }
                f = null, h = !1,
                    function(t) { if (n === clearTimeout) return clearTimeout(t); if ((n === a || !n) && clearTimeout) return n = clearTimeout, clearTimeout(t); try { n(t) } catch (e) { try { return n.call(null, t) } catch (e) { return n.call(this, t) } } }(t)
            }
        }

        function p(t, e) { this.fun = t, this.array = e }

        function y() {} i.nextTick = function(t) {
            var e = new Array(arguments.length - 1);
            if (arguments.length > 1)
                for (var r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
            u.push(new p(t, e)), 1 !== u.length || h || s(d)
        }, p.prototype.run = function() { this.fun.apply(null, this.array) }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = y, i.addListener = y, i.once = y, i.off = y, i.removeListener = y, i.removeAllListeners = y, i.emit = y, i.prependListener = y, i.prependOnceListener = y, i.listeners = function(t) { return [] }, i.binding = function(t) { throw new Error("process.binding is not supported") }, i.cwd = function() { return "/" }, i.chdir = function(t) { throw new Error("process.chdir is not supported") }, i.umask = function() { return 0 }
    }, function(t, e, r) {
        "use strict";
        (function(e) {
            !e.version || 0 === e.version.indexOf("v0.") || 0 === e.version.indexOf("v1.") && 0 !== e.version.indexOf("v1.8.") ? t.exports = {
                nextTick: function(t, r, n, i) {
                    if ("function" != typeof t) throw new TypeError('"callback" argument must be a function');
                    var o, a, s = arguments.length;
                    switch (s) {
                        case 0:
                        case 1:
                            return e.nextTick(t);
                        case 2:
                            return e.nextTick(function() { t.call(null, r) });
                        case 3:
                            return e.nextTick(function() { t.call(null, r, n) });
                        case 4:
                            return e.nextTick(function() { t.call(null, r, n, i) });
                        default:
                            for (o = new Array(s - 1), a = 0; a < o.length;) o[a++] = arguments[a];
                            return e.nextTick(function() { t.apply(null, o) })
                    }
                }
            } : t.exports = e
        }).call(this, r(8))
    }, function(t, e) {
        function r(t, e) { if (!t) throw new Error(e || "Assertion failed") } t.exports = r, r.equal = function(t, e, r) { if (t != e) throw new Error(r || "Assertion failed: " + t + " != " + e) }
    }, function(t, e, r) {
        var n = r(0).Buffer;

        function i(t) { n.isBuffer(t) || (t = n.from(t)); for (var e = t.length / 4 | 0, r = new Array(e), i = 0; i < e; i++) r[i] = t.readUInt32BE(4 * i); return r }

        function o(t) { for (; 0 < t.length; t++) t[0] = 0 }

        function a(t, e, r, n, i) { for (var o, a, s, f, u = r[0], h = r[1], c = r[2], l = r[3], d = t[0] ^ e[0], p = t[1] ^ e[1], y = t[2] ^ e[2], g = t[3] ^ e[3], v = 4, b = 1; b < i; b++) o = u[d >>> 24] ^ h[p >>> 16 & 255] ^ c[y >>> 8 & 255] ^ l[255 & g] ^ e[v++], a = u[p >>> 24] ^ h[y >>> 16 & 255] ^ c[g >>> 8 & 255] ^ l[255 & d] ^ e[v++], s = u[y >>> 24] ^ h[g >>> 16 & 255] ^ c[d >>> 8 & 255] ^ l[255 & p] ^ e[v++], f = u[g >>> 24] ^ h[d >>> 16 & 255] ^ c[p >>> 8 & 255] ^ l[255 & y] ^ e[v++], d = o, p = a, y = s, g = f; return o = (n[d >>> 24] << 24 | n[p >>> 16 & 255] << 16 | n[y >>> 8 & 255] << 8 | n[255 & g]) ^ e[v++], a = (n[p >>> 24] << 24 | n[y >>> 16 & 255] << 16 | n[g >>> 8 & 255] << 8 | n[255 & d]) ^ e[v++], s = (n[y >>> 24] << 24 | n[g >>> 16 & 255] << 16 | n[d >>> 8 & 255] << 8 | n[255 & p]) ^ e[v++], f = (n[g >>> 24] << 24 | n[d >>> 16 & 255] << 16 | n[p >>> 8 & 255] << 8 | n[255 & y]) ^ e[v++], [o >>>= 0, a >>>= 0, s >>>= 0, f >>>= 0] }
        var s = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54],
            f = function() {
                for (var t = new Array(256), e = 0; e < 256; e++) t[e] = e < 128 ? e << 1 : e << 1 ^ 283;
                for (var r = [], n = [], i = [
                        [],
                        [],
                        [],
                        []
                    ], o = [
                        [],
                        [],
                        [],
                        []
                    ], a = 0, s = 0, f = 0; f < 256; ++f) {
                    var u = s ^ s << 1 ^ s << 2 ^ s << 3 ^ s << 4;
                    u = u >>> 8 ^ 255 & u ^ 99, r[a] = u, n[u] = a;
                    var h = t[a],
                        c = t[h],
                        l = t[c],
                        d = 257 * t[u] ^ 16843008 * u;
                    i[0][a] = d << 24 | d >>> 8, i[1][a] = d << 16 | d >>> 16, i[2][a] = d << 8 | d >>> 24, i[3][a] = d, d = 16843009 * l ^ 65537 * c ^ 257 * h ^ 16843008 * a, o[0][u] = d << 24 | d >>> 8, o[1][u] = d << 16 | d >>> 16, o[2][u] = d << 8 | d >>> 24, o[3][u] = d, 0 === a ? a = s = 1 : (a = h ^ t[t[t[l ^ h]]], s ^= t[t[s]])
                }
                return { SBOX: r, INV_SBOX: n, SUB_MIX: i, INV_SUB_MIX: o }
            }();

        function u(t) { this._key = i(t), this._reset() } u.blockSize = 16, u.keySize = 32, u.prototype.blockSize = u.blockSize, u.prototype.keySize = u.keySize, u.prototype._reset = function() {
            for (var t = this._key, e = t.length, r = e + 6, n = 4 * (r + 1), i = [], o = 0; o < e; o++) i[o] = t[o];
            for (o = e; o < n; o++) {
                var a = i[o - 1];
                o % e == 0 ? (a = a << 8 | a >>> 24, a = f.SBOX[a >>> 24] << 24 | f.SBOX[a >>> 16 & 255] << 16 | f.SBOX[a >>> 8 & 255] << 8 | f.SBOX[255 & a], a ^= s[o / e | 0] << 24) : e > 6 && o % e == 4 && (a = f.SBOX[a >>> 24] << 24 | f.SBOX[a >>> 16 & 255] << 16 | f.SBOX[a >>> 8 & 255] << 8 | f.SBOX[255 & a]), i[o] = i[o - e] ^ a
            }
            for (var u = [], h = 0; h < n; h++) {
                var c = n - h,
                    l = i[c - (h % 4 ? 0 : 4)];
                u[h] = h < 4 || c <= 4 ? l : f.INV_SUB_MIX[0][f.SBOX[l >>> 24]] ^ f.INV_SUB_MIX[1][f.SBOX[l >>> 16 & 255]] ^ f.INV_SUB_MIX[2][f.SBOX[l >>> 8 & 255]] ^ f.INV_SUB_MIX[3][f.SBOX[255 & l]]
            }
            this._nRounds = r, this._keySchedule = i, this._invKeySchedule = u
        }, u.prototype.encryptBlockRaw = function(t) { return a(t = i(t), this._keySchedule, f.SUB_MIX, f.SBOX, this._nRounds) }, u.prototype.encryptBlock = function(t) {
            var e = this.encryptBlockRaw(t),
                r = n.allocUnsafe(16);
            return r.writeUInt32BE(e[0], 0), r.writeUInt32BE(e[1], 4), r.writeUInt32BE(e[2], 8), r.writeUInt32BE(e[3], 12), r
        }, u.prototype.decryptBlock = function(t) {
            var e = (t = i(t))[1];
            t[1] = t[3], t[3] = e;
            var r = a(t, this._invKeySchedule, f.INV_SUB_MIX, f.INV_SBOX, this._nRounds),
                o = n.allocUnsafe(16);
            return o.writeUInt32BE(r[0], 0), o.writeUInt32BE(r[3], 4), o.writeUInt32BE(r[2], 8), o.writeUInt32BE(r[1], 12), o
        }, u.prototype.scrub = function() { o(this._keySchedule), o(this._invKeySchedule), o(this._key) }, t.exports.AES = u
    }, function(t, e, r) {
        "use strict";
        var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;

        function i(t, e) { return Object.prototype.hasOwnProperty.call(t, e) } e.assign = function(t) { for (var e = Array.prototype.slice.call(arguments, 1); e.length;) { var r = e.shift(); if (r) { if ("object" != typeof r) throw new TypeError(r + "must be non-object"); for (var n in r) i(r, n) && (t[n] = r[n]) } } return t }, e.shrinkBuf = function(t, e) { return t.length === e ? t : t.subarray ? t.subarray(0, e) : (t.length = e, t) };
        var o = {
                arraySet: function(t, e, r, n, i) {
                    if (e.subarray && t.subarray) t.set(e.subarray(r, r + n), i);
                    else
                        for (var o = 0; o < n; o++) t[i + o] = e[r + o]
                },
                flattenChunks: function(t) { var e, r, n, i, o, a; for (n = 0, e = 0, r = t.length; e < r; e++) n += t[e].length; for (a = new Uint8Array(n), i = 0, e = 0, r = t.length; e < r; e++) o = t[e], a.set(o, i), i += o.length; return a }
            },
            a = { arraySet: function(t, e, r, n, i) { for (var o = 0; o < n; o++) t[i + o] = e[r + o] }, flattenChunks: function(t) { return [].concat.apply([], t) } };
        e.setTyped = function(t) { t ? (e.Buf8 = Uint8Array, e.Buf16 = Uint16Array, e.Buf32 = Int32Array, e.assign(e, o)) : (e.Buf8 = Array, e.Buf16 = Array, e.Buf32 = Array, e.assign(e, a)) }, e.setTyped(n)
    }, function(t, e, r) {
        "use strict";
        var n, i = "object" == typeof Reflect ? Reflect : null,
            o = i && "function" == typeof i.apply ? i.apply : function(t, e, r) { return Function.prototype.apply.call(t, e, r) };
        n = i && "function" == typeof i.ownKeys ? i.ownKeys : Object.getOwnPropertySymbols ? function(t) { return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t)) } : function(t) { return Object.getOwnPropertyNames(t) };
        var a = Number.isNaN || function(t) { return t != t };

        function s() { s.init.call(this) } t.exports = s, s.EventEmitter = s, s.prototype._events = void 0, s.prototype._eventsCount = 0, s.prototype._maxListeners = void 0;
        var f = 10;

        function u(t) { return void 0 === t._maxListeners ? s.defaultMaxListeners : t._maxListeners }

        function h(t, e, r, n) {
            var i, o, a, s;
            if ("function" != typeof r) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof r);
            if (void 0 === (o = t._events) ? (o = t._events = Object.create(null), t._eventsCount = 0) : (void 0 !== o.newListener && (t.emit("newListener", e, r.listener ? r.listener : r), o = t._events), a = o[e]), void 0 === a) a = o[e] = r, ++t._eventsCount;
            else if ("function" == typeof a ? a = o[e] = n ? [r, a] : [a, r] : n ? a.unshift(r) : a.push(r), (i = u(t)) > 0 && a.length > i && !a.warned) {
                a.warned = !0;
                var f = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
                f.name = "MaxListenersExceededWarning", f.emitter = t, f.type = e, f.count = a.length, s = f, console && console.warn && console.warn(s)
            }
            return t
        }

        function c(t, e, r) {
            var n = { fired: !1, wrapFn: void 0, target: t, type: e, listener: r },
                i = function() {
                    for (var t = [], e = 0; e < arguments.length; e++) t.push(arguments[e]);
                    this.fired || (this.target.removeListener(this.type, this.wrapFn), this.fired = !0, o(this.listener, this.target, t))
                }.bind(n);
            return i.listener = r, n.wrapFn = i, i
        }

        function l(t, e, r) { var n = t._events; if (void 0 === n) return []; var i = n[e]; return void 0 === i ? [] : "function" == typeof i ? r ? [i.listener || i] : [i] : r ? function(t) { for (var e = new Array(t.length), r = 0; r < e.length; ++r) e[r] = t[r].listener || t[r]; return e }(i) : p(i, i.length) }

        function d(t) { var e = this._events; if (void 0 !== e) { var r = e[t]; if ("function" == typeof r) return 1; if (void 0 !== r) return r.length } return 0 }

        function p(t, e) { for (var r = new Array(e), n = 0; n < e; ++n) r[n] = t[n]; return r } Object.defineProperty(s, "defaultMaxListeners", {
            enumerable: !0,
            get: function() { return f },
            set: function(t) {
                if ("number" != typeof t || t < 0 || a(t)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
                f = t
            }
        }), s.init = function() { void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0 }, s.prototype.setMaxListeners = function(t) { if ("number" != typeof t || t < 0 || a(t)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + "."); return this._maxListeners = t, this }, s.prototype.getMaxListeners = function() { return u(this) }, s.prototype.emit = function(t) {
            for (var e = [], r = 1; r < arguments.length; r++) e.push(arguments[r]);
            var n = "error" === t,
                i = this._events;
            if (void 0 !== i) n = n && void 0 === i.error;
            else if (!n) return !1;
            if (n) { var a; if (e.length > 0 && (a = e[0]), a instanceof Error) throw a; var s = new Error("Unhandled error." + (a ? " (" + a.message + ")" : "")); throw s.context = a, s }
            var f = i[t];
            if (void 0 === f) return !1;
            if ("function" == typeof f) o(f, this, e);
            else {
                var u = f.length,
                    h = p(f, u);
                for (r = 0; r < u; ++r) o(h[r], this, e)
            }
            return !0
        }, s.prototype.addListener = function(t, e) { return h(this, t, e, !1) }, s.prototype.on = s.prototype.addListener, s.prototype.prependListener = function(t, e) { return h(this, t, e, !0) }, s.prototype.once = function(t, e) { if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e); return this.on(t, c(this, t, e)), this }, s.prototype.prependOnceListener = function(t, e) { if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e); return this.prependListener(t, c(this, t, e)), this }, s.prototype.removeListener = function(t, e) {
            var r, n, i, o, a;
            if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
            if (void 0 === (n = this._events)) return this;
            if (void 0 === (r = n[t])) return this;
            if (r === e || r.listener === e) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete n[t], n.removeListener && this.emit("removeListener", t, r.listener || e));
            else if ("function" != typeof r) {
                for (i = -1, o = r.length - 1; o >= 0; o--)
                    if (r[o] === e || r[o].listener === e) { a = r[o].listener, i = o; break } if (i < 0) return this;
                0 === i ? r.shift() : function(t, e) {
                    for (; e + 1 < t.length; e++) t[e] = t[e + 1];
                    t.pop()
                }(r, i), 1 === r.length && (n[t] = r[0]), void 0 !== n.removeListener && this.emit("removeListener", t, a || e)
            }
            return this
        }, s.prototype.off = s.prototype.removeListener, s.prototype.removeAllListeners = function(t) {
            var e, r, n;
            if (void 0 === (r = this._events)) return this;
            if (void 0 === r.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== r[t] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete r[t]), this;
            if (0 === arguments.length) { var i, o = Object.keys(r); for (n = 0; n < o.length; ++n) "removeListener" !== (i = o[n]) && this.removeAllListeners(i); return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this }
            if ("function" == typeof(e = r[t])) this.removeListener(t, e);
            else if (void 0 !== e)
                for (n = e.length - 1; n >= 0; n--) this.removeListener(t, e[n]);
            return this
        }, s.prototype.listeners = function(t) { return l(this, t, !0) }, s.prototype.rawListeners = function(t) { return l(this, t, !1) }, s.listenerCount = function(t, e) { return "function" == typeof t.listenerCount ? t.listenerCount(e) : d.call(t, e) }, s.prototype.listenerCount = d, s.prototype.eventNames = function() { return this._eventsCount > 0 ? n(this._events) : [] }
    }, function(t, e, r) {
        (e = t.exports = r(22)).Stream = e, e.Readable = e, e.Writable = r(15), e.Duplex = r(2), e.Transform = r(25), e.PassThrough = r(42)
    }, function(t, e, r) {
        "use strict";
        (function(e, n, i) {
            var o = r(9);

            function a(t) {
                var e = this;
                this.next = null, this.entry = null, this.finish = function() {
                    ! function(t, e, r) {
                        var n = t.entry;
                        t.entry = null;
                        for (; n;) {
                            var i = n.callback;
                            e.pendingcb--, i(r), n = n.next
                        }
                        e.corkedRequestsFree ? e.corkedRequestsFree.next = t : e.corkedRequestsFree = t
                    }(e, t)
                }
            }
            t.exports = b;
            var s, f = !e.browser && ["v0.10", "v0.9."].indexOf(e.version.slice(0, 5)) > -1 ? n : o.nextTick;
            b.WritableState = v;
            var u = r(5);
            u.inherits = r(1);
            var h = { deprecate: r(41) },
                c = r(23),
                l = r(0).Buffer,
                d = i.Uint8Array || function() {};
            var p, y = r(24);

            function g() {}

            function v(t, e) {
                s = s || r(2), t = t || {};
                var n = e instanceof s;
                this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.writableObjectMode);
                var i = t.highWaterMark,
                    u = t.writableHighWaterMark,
                    h = this.objectMode ? 16 : 16384;
                this.highWaterMark = i || 0 === i ? i : n && (u || 0 === u) ? u : h, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
                var c = !1 === t.decodeStrings;
                this.decodeStrings = !c, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(t) {
                    ! function(t, e) {
                        var r = t._writableState,
                            n = r.sync,
                            i = r.writecb;
                        if (function(t) { t.writing = !1, t.writecb = null, t.length -= t.writelen, t.writelen = 0 }(r), e) ! function(t, e, r, n, i) {--e.pendingcb, r ? (o.nextTick(i, n), o.nextTick(S, t, e), t._writableState.errorEmitted = !0, t.emit("error", n)) : (i(n), t._writableState.errorEmitted = !0, t.emit("error", n), S(t, e)) }(t, r, n, e, i);
                        else {
                            var a = k(r);
                            a || r.corked || r.bufferProcessing || !r.bufferedRequest || m(t, r), n ? f(_, t, r, a, i) : _(t, r, a, i)
                        }
                    }(e, t)
                }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new a(this)
            }

            function b(t) {
                if (s = s || r(2), !(p.call(b, this) || this instanceof s)) return new b(t);
                this._writableState = new v(t, this), this.writable = !0, t && ("function" == typeof t.write && (this._write = t.write), "function" == typeof t.writev && (this._writev = t.writev), "function" == typeof t.destroy && (this._destroy = t.destroy), "function" == typeof t.final && (this._final = t.final)), c.call(this)
            }

            function w(t, e, r, n, i, o, a) { e.writelen = n, e.writecb = a, e.writing = !0, e.sync = !0, r ? t._writev(i, e.onwrite) : t._write(i, o, e.onwrite), e.sync = !1 }

            function _(t, e, r, n) { r || function(t, e) { 0 === e.length && e.needDrain && (e.needDrain = !1, t.emit("drain")) }(t, e), e.pendingcb--, n(), S(t, e) }

            function m(t, e) {
                e.bufferProcessing = !0;
                var r = e.bufferedRequest;
                if (t._writev && r && r.next) {
                    var n = e.bufferedRequestCount,
                        i = new Array(n),
                        o = e.corkedRequestsFree;
                    o.entry = r;
                    for (var s = 0, f = !0; r;) i[s] = r, r.isBuf || (f = !1), r = r.next, s += 1;
                    i.allBuffers = f, w(t, e, !0, e.length, i, "", o.finish), e.pendingcb++, e.lastBufferedRequest = null, o.next ? (e.corkedRequestsFree = o.next, o.next = null) : e.corkedRequestsFree = new a(e), e.bufferedRequestCount = 0
                } else {
                    for (; r;) {
                        var u = r.chunk,
                            h = r.encoding,
                            c = r.callback;
                        if (w(t, e, !1, e.objectMode ? 1 : u.length, u, h, c), r = r.next, e.bufferedRequestCount--, e.writing) break
                    }
                    null === r && (e.lastBufferedRequest = null)
                }
                e.bufferedRequest = r, e.bufferProcessing = !1
            }

            function k(t) { return t.ending && 0 === t.length && null === t.bufferedRequest && !t.finished && !t.writing }

            function E(t, e) { t._final(function(r) { e.pendingcb--, r && t.emit("error", r), e.prefinished = !0, t.emit("prefinish"), S(t, e) }) }

            function S(t, e) { var r = k(e); return r && (! function(t, e) { e.prefinished || e.finalCalled || ("function" == typeof t._final ? (e.pendingcb++, e.finalCalled = !0, o.nextTick(E, t, e)) : (e.prefinished = !0, t.emit("prefinish"))) }(t, e), 0 === e.pendingcb && (e.finished = !0, t.emit("finish"))), r } u.inherits(b, c), v.prototype.getBuffer = function() { for (var t = this.bufferedRequest, e = []; t;) e.push(t), t = t.next; return e },
                function() { try { Object.defineProperty(v.prototype, "buffer", { get: h.deprecate(function() { return this.getBuffer() }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003") }) } catch (t) {} }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (p = Function.prototype[Symbol.hasInstance], Object.defineProperty(b, Symbol.hasInstance, { value: function(t) { return !!p.call(this, t) || this === b && (t && t._writableState instanceof v) } })) : p = function(t) { return t instanceof this }, b.prototype.pipe = function() { this.emit("error", new Error("Cannot pipe, not readable")) }, b.prototype.write = function(t, e, r) {
                    var n, i = this._writableState,
                        a = !1,
                        s = !i.objectMode && (n = t, l.isBuffer(n) || n instanceof d);
                    return s && !l.isBuffer(t) && (t = function(t) { return l.from(t) }(t)), "function" == typeof e && (r = e, e = null), s ? e = "buffer" : e || (e = i.defaultEncoding), "function" != typeof r && (r = g), i.ended ? function(t, e) {
                        var r = new Error("write after end");
                        t.emit("error", r), o.nextTick(e, r)
                    }(this, r) : (s || function(t, e, r, n) {
                        var i = !0,
                            a = !1;
                        return null === r ? a = new TypeError("May not write null values to stream") : "string" == typeof r || void 0 === r || e.objectMode || (a = new TypeError("Invalid non-string/buffer chunk")), a && (t.emit("error", a), o.nextTick(n, a), i = !1), i
                    }(this, i, t, r)) && (i.pendingcb++, a = function(t, e, r, n, i, o) {
                        if (!r) {
                            var a = function(t, e, r) { t.objectMode || !1 === t.decodeStrings || "string" != typeof e || (e = l.from(e, r)); return e }(e, n, i);
                            n !== a && (r = !0, i = "buffer", n = a)
                        }
                        var s = e.objectMode ? 1 : n.length;
                        e.length += s;
                        var f = e.length < e.highWaterMark;
                        f || (e.needDrain = !0);
                        if (e.writing || e.corked) {
                            var u = e.lastBufferedRequest;
                            e.lastBufferedRequest = { chunk: n, encoding: i, isBuf: r, callback: o, next: null }, u ? u.next = e.lastBufferedRequest : e.bufferedRequest = e.lastBufferedRequest, e.bufferedRequestCount += 1
                        } else w(t, e, !1, s, n, i, o);
                        return f
                    }(this, i, s, t, e, r)), a
                }, b.prototype.cork = function() { this._writableState.corked++ }, b.prototype.uncork = function() {
                    var t = this._writableState;
                    t.corked && (t.corked--, t.writing || t.corked || t.finished || t.bufferProcessing || !t.bufferedRequest || m(this, t))
                }, b.prototype.setDefaultEncoding = function(t) { if ("string" == typeof t && (t = t.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((t + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + t); return this._writableState.defaultEncoding = t, this }, Object.defineProperty(b.prototype, "writableHighWaterMark", { enumerable: !1, get: function() { return this._writableState.highWaterMark } }), b.prototype._write = function(t, e, r) { r(new Error("_write() is not implemented")) }, b.prototype._writev = null, b.prototype.end = function(t, e, r) {
                    var n = this._writableState;
                    "function" == typeof t ? (r = t, t = null, e = null) : "function" == typeof e && (r = e, e = null), null != t && this.write(t, e), n.corked && (n.corked = 1, this.uncork()), n.ending || n.finished || function(t, e, r) {
                        e.ending = !0, S(t, e), r && (e.finished ? o.nextTick(r) : t.once("finish", r));
                        e.ended = !0, t.writable = !1
                    }(this, n, r)
                }, Object.defineProperty(b.prototype, "destroyed", { get: function() { return void 0 !== this._writableState && this._writableState.destroyed }, set: function(t) { this._writableState && (this._writableState.destroyed = t) } }), b.prototype.destroy = y.destroy, b.prototype._undestroy = y.undestroy, b.prototype._destroy = function(t, e) { this.end(), e(t) }
        }).call(this, r(8), r(39).setImmediate, r(3))
    }, function(t, e, r) {
        "use strict";
        var n = r(0).Buffer,
            i = n.isEncoding || function(t) {
                switch ((t = "" + t) && t.toLowerCase()) {
                    case "hex":
                    case "utf8":
                    case "utf-8":
                    case "ascii":
                    case "binary":
                    case "base64":
                    case "ucs2":
                    case "ucs-2":
                    case "utf16le":
                    case "utf-16le":
                    case "raw":
                        return !0;
                    default:
                        return !1
                }
            };

        function o(t) {
            var e;
            switch (this.encoding = function(t) {
                var e = function(t) {
                    if (!t) return "utf8";
                    for (var e;;) switch (t) {
                        case "utf8":
                        case "utf-8":
                            return "utf8";
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return "utf16le";
                        case "latin1":
                        case "binary":
                            return "latin1";
                        case "base64":
                        case "ascii":
                        case "hex":
                            return t;
                        default:
                            if (e) return;
                            t = ("" + t).toLowerCase(), e = !0
                    }
                }(t);
                if ("string" != typeof e && (n.isEncoding === i || !i(t))) throw new Error("Unknown encoding: " + t);
                return e || t
            }(t), this.encoding) {
                case "utf16le":
                    this.text = f, this.end = u, e = 4;
                    break;
                case "utf8":
                    this.fillLast = s, e = 4;
                    break;
                case "base64":
                    this.text = h, this.end = c, e = 3;
                    break;
                default:
                    return this.write = l, void(this.end = d)
            }
            this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n.allocUnsafe(e)
        }

        function a(t) { return t <= 127 ? 0 : t >> 5 == 6 ? 2 : t >> 4 == 14 ? 3 : t >> 3 == 30 ? 4 : t >> 6 == 2 ? -1 : -2 }

        function s(t) {
            var e = this.lastTotal - this.lastNeed,
                r = function(t, e, r) { if (128 != (192 & e[0])) return t.lastNeed = 0, "�"; if (t.lastNeed > 1 && e.length > 1) { if (128 != (192 & e[1])) return t.lastNeed = 1, "�"; if (t.lastNeed > 2 && e.length > 2 && 128 != (192 & e[2])) return t.lastNeed = 2, "�" } }(this, t);
            return void 0 !== r ? r : this.lastNeed <= t.length ? (t.copy(this.lastChar, e, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (t.copy(this.lastChar, e, 0, t.length), void(this.lastNeed -= t.length))
        }

        function f(t, e) { if ((t.length - e) % 2 == 0) { var r = t.toString("utf16le", e); if (r) { var n = r.charCodeAt(r.length - 1); if (n >= 55296 && n <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1], r.slice(0, -1) } return r } return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = t[t.length - 1], t.toString("utf16le", e, t.length - 1) }

        function u(t) { var e = t && t.length ? this.write(t) : ""; if (this.lastNeed) { var r = this.lastTotal - this.lastNeed; return e + this.lastChar.toString("utf16le", 0, r) } return e }

        function h(t, e) { var r = (t.length - e) % 3; return 0 === r ? t.toString("base64", e) : (this.lastNeed = 3 - r, this.lastTotal = 3, 1 === r ? this.lastChar[0] = t[t.length - 1] : (this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1]), t.toString("base64", e, t.length - r)) }

        function c(t) { var e = t && t.length ? this.write(t) : ""; return this.lastNeed ? e + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : e }

        function l(t) { return t.toString(this.encoding) }

        function d(t) { return t && t.length ? this.write(t) : "" } e.StringDecoder = o, o.prototype.write = function(t) {
            if (0 === t.length) return "";
            var e, r;
            if (this.lastNeed) {
                if (void 0 === (e = this.fillLast(t))) return "";
                r = this.lastNeed, this.lastNeed = 0
            } else r = 0;
            return r < t.length ? e ? e + this.text(t, r) : this.text(t, r) : e || ""
        }, o.prototype.end = function(t) { var e = t && t.length ? this.write(t) : ""; return this.lastNeed ? e + "�" : e }, o.prototype.text = function(t, e) {
            var r = function(t, e, r) { var n = e.length - 1; if (n < r) return 0; var i = a(e[n]); if (i >= 0) return i > 0 && (t.lastNeed = i - 1), i; if (--n < r || -2 === i) return 0; if ((i = a(e[n])) >= 0) return i > 0 && (t.lastNeed = i - 2), i; if (--n < r || -2 === i) return 0; if ((i = a(e[n])) >= 0) return i > 0 && (2 === i ? i = 0 : t.lastNeed = i - 3), i; return 0 }(this, t, e);
            if (!this.lastNeed) return t.toString("utf8", e);
            this.lastTotal = r;
            var n = t.length - (r - this.lastNeed);
            return t.copy(this.lastChar, 0, n), t.toString("utf8", e, n)
        }, o.prototype.fillLast = function(t) {
            if (this.lastNeed <= t.length) return t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
            t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, t.length), this.lastNeed -= t.length
        }
    }, function(t, e, r) {
        "use strict";
        e.utils = r(47), e.Cipher = r(48), e.DES = r(49), e.CBC = r(50), e.EDE = r(51)
    }, function(t, e, r) {
        var n = { ECB: r(54), CBC: r(55), CFB: r(56), CFB8: r(57), CFB1: r(58), OFB: r(59), CTR: r(26), GCM: r(26) },
            i = r(28);
        for (var o in i) i[o].module = n[i[o].mode];
        t.exports = i
    }, function(t, e, r) {
        var n = r(0).Buffer,
            i = r(61);
        t.exports = function(t, e, r, o) {
            if (n.isBuffer(t) || (t = n.from(t, "binary")), e && (n.isBuffer(e) || (e = n.from(e, "binary")), 8 !== e.length)) throw new RangeError("salt should be Buffer with 8 byte length");
            for (var a = r / 8, s = n.alloc(a), f = n.alloc(o || 0), u = n.alloc(0); a > 0 || o > 0;) {
                var h = new i;
                h.update(u), h.update(t), e && h.update(e), u = h.digest();
                var c = 0;
                if (a > 0) {
                    var l = s.length - a;
                    c = Math.min(a, u.length), u.copy(s, l, 0, c), a -= c
                }
                if (c < u.length && o > 0) {
                    var d = f.length - o,
                        p = Math.min(o, u.length - c);
                    u.copy(f, d, c, c + p), o -= p
                }
            }
            return u.fill(0), { key: s, iv: f }
        }
    }, function(t, e) {
        var r = {}.toString;
        t.exports = Array.isArray || function(t) { return "[object Array]" == r.call(t) }
    }, function(t, e, r) {
        t.exports = i;
        var n = r(13).EventEmitter;

        function i() { n.call(this) } r(1)(i, n), i.Readable = r(14), i.Writable = r(43), i.Duplex = r(44), i.Transform = r(45), i.PassThrough = r(46), i.Stream = i, i.prototype.pipe = function(t, e) {
            var r = this;

            function i(e) { t.writable && !1 === t.write(e) && r.pause && r.pause() }

            function o() { r.readable && r.resume && r.resume() } r.on("data", i), t.on("drain", o), t._isStdio || e && !1 === e.end || (r.on("end", s), r.on("close", f));
            var a = !1;

            function s() { a || (a = !0, t.end()) }

            function f() { a || (a = !0, "function" == typeof t.destroy && t.destroy()) }

            function u(t) { if (h(), 0 === n.listenerCount(this, "error")) throw t }

            function h() { r.removeListener("data", i), t.removeListener("drain", o), r.removeListener("end", s), r.removeListener("close", f), r.removeListener("error", u), t.removeListener("error", u), r.removeListener("end", h), r.removeListener("close", h), t.removeListener("close", h) }
            return r.on("error", u), t.on("error", u), r.on("end", h), r.on("close", h), t.on("close", h), t.emit("pipe", r), t
        }
    }, function(t, e, r) {
        "use strict";
        (function(e, n) {
            var i = r(9);
            t.exports = w;
            var o, a = r(20);
            w.ReadableState = b;
            r(13).EventEmitter;
            var s = function(t, e) { return t.listeners(e).length },
                f = r(23),
                u = r(0).Buffer,
                h = e.Uint8Array || function() {};
            var c = r(5);
            c.inherits = r(1);
            var l = r(36),
                d = void 0;
            d = l && l.debuglog ? l.debuglog("stream") : function() {};
            var p, y = r(37),
                g = r(24);
            c.inherits(w, f);
            var v = ["error", "close", "destroy", "pause", "resume"];

            function b(t, e) {
                t = t || {};
                var n = e instanceof(o = o || r(2));
                this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.readableObjectMode);
                var i = t.highWaterMark,
                    a = t.readableHighWaterMark,
                    s = this.objectMode ? 16 : 16384;
                this.highWaterMark = i || 0 === i ? i : n && (a || 0 === a) ? a : s, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new y, this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (p || (p = r(16).StringDecoder), this.decoder = new p(t.encoding), this.encoding = t.encoding)
            }

            function w(t) {
                if (o = o || r(2), !(this instanceof w)) return new w(t);
                this._readableState = new b(t, this), this.readable = !0, t && ("function" == typeof t.read && (this._read = t.read), "function" == typeof t.destroy && (this._destroy = t.destroy)), f.call(this)
            }

            function _(t, e, r, n, i) {
                var o, a = t._readableState;
                null === e ? (a.reading = !1, function(t, e) {
                    if (e.ended) return;
                    if (e.decoder) {
                        var r = e.decoder.end();
                        r && r.length && (e.buffer.push(r), e.length += e.objectMode ? 1 : r.length)
                    }
                    e.ended = !0, S(t)
                }(t, a)) : (i || (o = function(t, e) {
                    var r;
                    n = e, u.isBuffer(n) || n instanceof h || "string" == typeof e || void 0 === e || t.objectMode || (r = new TypeError("Invalid non-string/buffer chunk"));
                    var n;
                    return r
                }(a, e)), o ? t.emit("error", o) : a.objectMode || e && e.length > 0 ? ("string" == typeof e || a.objectMode || Object.getPrototypeOf(e) === u.prototype || (e = function(t) { return u.from(t) }(e)), n ? a.endEmitted ? t.emit("error", new Error("stream.unshift() after end event")) : m(t, a, e, !0) : a.ended ? t.emit("error", new Error("stream.push() after EOF")) : (a.reading = !1, a.decoder && !r ? (e = a.decoder.write(e), a.objectMode || 0 !== e.length ? m(t, a, e, !1) : x(t, a)) : m(t, a, e, !1))) : n || (a.reading = !1));
                return function(t) { return !t.ended && (t.needReadable || t.length < t.highWaterMark || 0 === t.length) }(a)
            }

            function m(t, e, r, n) { e.flowing && 0 === e.length && !e.sync ? (t.emit("data", r), t.read(0)) : (e.length += e.objectMode ? 1 : r.length, n ? e.buffer.unshift(r) : e.buffer.push(r), e.needReadable && S(t)), x(t, e) } Object.defineProperty(w.prototype, "destroyed", { get: function() { return void 0 !== this._readableState && this._readableState.destroyed }, set: function(t) { this._readableState && (this._readableState.destroyed = t) } }), w.prototype.destroy = g.destroy, w.prototype._undestroy = g.undestroy, w.prototype._destroy = function(t, e) { this.push(null), e(t) }, w.prototype.push = function(t, e) { var r, n = this._readableState; return n.objectMode ? r = !0 : "string" == typeof t && ((e = e || n.defaultEncoding) !== n.encoding && (t = u.from(t, e), e = ""), r = !0), _(this, t, e, !1, r) }, w.prototype.unshift = function(t) { return _(this, t, null, !0, !1) }, w.prototype.isPaused = function() { return !1 === this._readableState.flowing }, w.prototype.setEncoding = function(t) { return p || (p = r(16).StringDecoder), this._readableState.decoder = new p(t), this._readableState.encoding = t, this };
            var k = 8388608;

            function E(t, e) { return t <= 0 || 0 === e.length && e.ended ? 0 : e.objectMode ? 1 : t != t ? e.flowing && e.length ? e.buffer.head.data.length : e.length : (t > e.highWaterMark && (e.highWaterMark = function(t) { return t >= k ? t = k : (t--, t |= t >>> 1, t |= t >>> 2, t |= t >>> 4, t |= t >>> 8, t |= t >>> 16, t++), t }(t)), t <= e.length ? t : e.ended ? e.length : (e.needReadable = !0, 0)) }

            function S(t) {
                var e = t._readableState;
                e.needReadable = !1, e.emittedReadable || (d("emitReadable", e.flowing), e.emittedReadable = !0, e.sync ? i.nextTick(B, t) : B(t))
            }

            function B(t) { d("emit readable"), t.emit("readable"), R(t) }

            function x(t, e) { e.readingMore || (e.readingMore = !0, i.nextTick(A, t, e)) }

            function A(t, e) {
                for (var r = e.length; !e.reading && !e.flowing && !e.ended && e.length < e.highWaterMark && (d("maybeReadMore read 0"), t.read(0), r !== e.length);) r = e.length;
                e.readingMore = !1
            }

            function T(t) { d("readable nexttick read 0"), t.read(0) }

            function C(t, e) { e.reading || (d("resume read 0"), t.read(0)), e.resumeScheduled = !1, e.awaitDrain = 0, t.emit("resume"), R(t), e.flowing && !e.reading && t.read(0) }

            function R(t) { var e = t._readableState; for (d("flow", e.flowing); e.flowing && null !== t.read();); }

            function O(t, e) {
                return 0 === e.length ? null : (e.objectMode ? r = e.buffer.shift() : !t || t >= e.length ? (r = e.decoder ? e.buffer.join("") : 1 === e.buffer.length ? e.buffer.head.data : e.buffer.concat(e.length), e.buffer.clear()) : r = function(t, e, r) {
                    var n;
                    t < e.head.data.length ? (n = e.head.data.slice(0, t), e.head.data = e.head.data.slice(t)) : n = t === e.head.data.length ? e.shift() : r ? function(t, e) {
                        var r = e.head,
                            n = 1,
                            i = r.data;
                        t -= i.length;
                        for (; r = r.next;) {
                            var o = r.data,
                                a = t > o.length ? o.length : t;
                            if (a === o.length ? i += o : i += o.slice(0, t), 0 === (t -= a)) { a === o.length ? (++n, r.next ? e.head = r.next : e.head = e.tail = null) : (e.head = r, r.data = o.slice(a)); break }++n
                        }
                        return e.length -= n, i
                    }(t, e) : function(t, e) {
                        var r = u.allocUnsafe(t),
                            n = e.head,
                            i = 1;
                        n.data.copy(r), t -= n.data.length;
                        for (; n = n.next;) {
                            var o = n.data,
                                a = t > o.length ? o.length : t;
                            if (o.copy(r, r.length - t, 0, a), 0 === (t -= a)) { a === o.length ? (++i, n.next ? e.head = n.next : e.head = e.tail = null) : (e.head = n, n.data = o.slice(a)); break }++i
                        }
                        return e.length -= i, r
                    }(t, e);
                    return n
                }(t, e.buffer, e.decoder), r);
                var r
            }

            function I(t) {
                var e = t._readableState;
                if (e.length > 0) throw new Error('"endReadable()" called on non-empty stream');
                e.endEmitted || (e.ended = !0, i.nextTick(U, e, t))
            }

            function U(t, e) { t.endEmitted || 0 !== t.length || (t.endEmitted = !0, e.readable = !1, e.emit("end")) }

            function M(t, e) {
                for (var r = 0, n = t.length; r < n; r++)
                    if (t[r] === e) return r;
                return -1
            }
            w.prototype.read = function(t) {
                d("read", t), t = parseInt(t, 10);
                var e = this._readableState,
                    r = t;
                if (0 !== t && (e.emittedReadable = !1), 0 === t && e.needReadable && (e.length >= e.highWaterMark || e.ended)) return d("read: emitReadable", e.length, e.ended), 0 === e.length && e.ended ? I(this) : S(this), null;
                if (0 === (t = E(t, e)) && e.ended) return 0 === e.length && I(this), null;
                var n, i = e.needReadable;
                return d("need readable", i), (0 === e.length || e.length - t < e.highWaterMark) && d("length less than watermark", i = !0), e.ended || e.reading ? d("reading or ended", i = !1) : i && (d("do read"), e.reading = !0, e.sync = !0, 0 === e.length && (e.needReadable = !0), this._read(e.highWaterMark), e.sync = !1, e.reading || (t = E(r, e))), null === (n = t > 0 ? O(t, e) : null) ? (e.needReadable = !0, t = 0) : e.length -= t, 0 === e.length && (e.ended || (e.needReadable = !0), r !== t && e.ended && I(this)), null !== n && this.emit("data", n), n
            }, w.prototype._read = function(t) { this.emit("error", new Error("_read() is not implemented")) }, w.prototype.pipe = function(t, e) {
                var r = this,
                    o = this._readableState;
                switch (o.pipesCount) {
                    case 0:
                        o.pipes = t;
                        break;
                    case 1:
                        o.pipes = [o.pipes, t];
                        break;
                    default:
                        o.pipes.push(t)
                }
                o.pipesCount += 1, d("pipe count=%d opts=%j", o.pipesCount, e);
                var f = (!e || !1 !== e.end) && t !== n.stdout && t !== n.stderr ? h : w;

                function u(e, n) { d("onunpipe"), e === r && n && !1 === n.hasUnpiped && (n.hasUnpiped = !0, d("cleanup"), t.removeListener("close", v), t.removeListener("finish", b), t.removeListener("drain", c), t.removeListener("error", g), t.removeListener("unpipe", u), r.removeListener("end", h), r.removeListener("end", w), r.removeListener("data", y), l = !0, !o.awaitDrain || t._writableState && !t._writableState.needDrain || c()) }

                function h() { d("onend"), t.end() } o.endEmitted ? i.nextTick(f) : r.once("end", f), t.on("unpipe", u);
                var c = function(t) {
                    return function() {
                        var e = t._readableState;
                        d("pipeOnDrain", e.awaitDrain), e.awaitDrain && e.awaitDrain--, 0 === e.awaitDrain && s(t, "data") && (e.flowing = !0, R(t))
                    }
                }(r);
                t.on("drain", c);
                var l = !1;
                var p = !1;

                function y(e) { d("ondata"), p = !1, !1 !== t.write(e) || p || ((1 === o.pipesCount && o.pipes === t || o.pipesCount > 1 && -1 !== M(o.pipes, t)) && !l && (d("false write response, pause", r._readableState.awaitDrain), r._readableState.awaitDrain++, p = !0), r.pause()) }

                function g(e) { d("onerror", e), w(), t.removeListener("error", g), 0 === s(t, "error") && t.emit("error", e) }

                function v() { t.removeListener("finish", b), w() }

                function b() { d("onfinish"), t.removeListener("close", v), w() }

                function w() { d("unpipe"), r.unpipe(t) }
                return r.on("data", y),
                    function(t, e, r) {
                        if ("function" == typeof t.prependListener) return t.prependListener(e, r);
                        t._events && t._events[e] ? a(t._events[e]) ? t._events[e].unshift(r) : t._events[e] = [r, t._events[e]] : t.on(e, r)
                    }(t, "error", g), t.once("close", v), t.once("finish", b), t.emit("pipe", r), o.flowing || (d("pipe resume"), r.resume()), t
            }, w.prototype.unpipe = function(t) {
                var e = this._readableState,
                    r = { hasUnpiped: !1 };
                if (0 === e.pipesCount) return this;
                if (1 === e.pipesCount) return t && t !== e.pipes ? this : (t || (t = e.pipes), e.pipes = null, e.pipesCount = 0, e.flowing = !1, t && t.emit("unpipe", this, r), this);
                if (!t) {
                    var n = e.pipes,
                        i = e.pipesCount;
                    e.pipes = null, e.pipesCount = 0, e.flowing = !1;
                    for (var o = 0; o < i; o++) n[o].emit("unpipe", this, r);
                    return this
                }
                var a = M(e.pipes, t);
                return -1 === a ? this : (e.pipes.splice(a, 1), e.pipesCount -= 1, 1 === e.pipesCount && (e.pipes = e.pipes[0]), t.emit("unpipe", this, r), this)
            }, w.prototype.on = function(t, e) {
                var r = f.prototype.on.call(this, t, e);
                if ("data" === t) !1 !== this._readableState.flowing && this.resume();
                else if ("readable" === t) {
                    var n = this._readableState;
                    n.endEmitted || n.readableListening || (n.readableListening = n.needReadable = !0, n.emittedReadable = !1, n.reading ? n.length && S(this) : i.nextTick(T, this))
                }
                return r
            }, w.prototype.addListener = w.prototype.on, w.prototype.resume = function() { var t = this._readableState; return t.flowing || (d("resume"), t.flowing = !0, function(t, e) { e.resumeScheduled || (e.resumeScheduled = !0, i.nextTick(C, t, e)) }(this, t)), this }, w.prototype.pause = function() { return d("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (d("pause"), this._readableState.flowing = !1, this.emit("pause")), this }, w.prototype.wrap = function(t) {
                var e = this,
                    r = this._readableState,
                    n = !1;
                for (var i in t.on("end", function() {
                        if (d("wrapped end"), r.decoder && !r.ended) {
                            var t = r.decoder.end();
                            t && t.length && e.push(t)
                        }
                        e.push(null)
                    }), t.on("data", function(i) {
                        (d("wrapped data"), r.decoder && (i = r.decoder.write(i)), r.objectMode && null == i) || (r.objectMode || i && i.length) && (e.push(i) || (n = !0, t.pause()))
                    }), t) void 0 === this[i] && "function" == typeof t[i] && (this[i] = function(e) { return function() { return t[e].apply(t, arguments) } }(i));
                for (var o = 0; o < v.length; o++) t.on(v[o], this.emit.bind(this, v[o]));
                return this._read = function(e) { d("wrapped _read", e), n && (n = !1, t.resume()) }, this
            }, Object.defineProperty(w.prototype, "readableHighWaterMark", { enumerable: !1, get: function() { return this._readableState.highWaterMark } }), w._fromList = O
        }).call(this, r(3), r(8))
    }, function(t, e, r) { t.exports = r(13).EventEmitter }, function(t, e, r) {
        "use strict";
        var n = r(9);

        function i(t, e) { t.emit("error", e) } t.exports = {
            destroy: function(t, e) {
                var r = this,
                    o = this._readableState && this._readableState.destroyed,
                    a = this._writableState && this._writableState.destroyed;
                return o || a ? (e ? e(t) : !t || this._writableState && this._writableState.errorEmitted || n.nextTick(i, this, t), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t || null, function(t) {!e && t ? (n.nextTick(i, r, t), r._writableState && (r._writableState.errorEmitted = !0)) : e && e(t) }), this)
            },
            undestroy: function() { this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1) }
        }
    }, function(t, e, r) {
        "use strict";
        t.exports = a;
        var n = r(2),
            i = r(5);

        function o(t, e) {
            var r = this._transformState;
            r.transforming = !1;
            var n = r.writecb;
            if (!n) return this.emit("error", new Error("write callback called multiple times"));
            r.writechunk = null, r.writecb = null, null != e && this.push(e), n(t);
            var i = this._readableState;
            i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark)
        }

        function a(t) {
            if (!(this instanceof a)) return new a(t);
            n.call(this, t), this._transformState = { afterTransform: o.bind(this), needTransform: !1, transforming: !1, writecb: null, writechunk: null, writeencoding: null }, this._readableState.needReadable = !0, this._readableState.sync = !1, t && ("function" == typeof t.transform && (this._transform = t.transform), "function" == typeof t.flush && (this._flush = t.flush)), this.on("prefinish", s)
        }

        function s() { var t = this; "function" == typeof this._flush ? this._flush(function(e, r) { f(t, e, r) }) : f(this, null, null) }

        function f(t, e, r) { if (e) return t.emit("error", e); if (null != r && t.push(r), t._writableState.length) throw new Error("Calling transform done when ws.length != 0"); if (t._transformState.transforming) throw new Error("Calling transform done when still transforming"); return t.push(null) } i.inherits = r(1), i.inherits(a, n), a.prototype.push = function(t, e) { return this._transformState.needTransform = !1, n.prototype.push.call(this, t, e) }, a.prototype._transform = function(t, e, r) { throw new Error("_transform() is not implemented") }, a.prototype._write = function(t, e, r) {
            var n = this._transformState;
            if (n.writecb = r, n.writechunk = t, n.writeencoding = e, !n.transforming) {
                var i = this._readableState;
                (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark)
            }
        }, a.prototype._read = function(t) {
            var e = this._transformState;
            null !== e.writechunk && e.writecb && !e.transforming ? (e.transforming = !0, this._transform(e.writechunk, e.writeencoding, e.afterTransform)) : e.needTransform = !0
        }, a.prototype._destroy = function(t, e) {
            var r = this;
            n.prototype._destroy.call(this, t, function(t) { e(t), r.emit("close") })
        }
    }, function(t, e, r) {
        var n = r(6),
            i = r(0).Buffer,
            o = r(27);

        function a(t) { var e = t._cipher.encryptBlockRaw(t._prev); return o(t._prev), e } e.encrypt = function(t, e) {
            var r = Math.ceil(e.length / 16),
                o = t._cache.length;
            t._cache = i.concat([t._cache, i.allocUnsafe(16 * r)]);
            for (var s = 0; s < r; s++) {
                var f = a(t),
                    u = o + 16 * s;
                t._cache.writeUInt32BE(f[0], u + 0), t._cache.writeUInt32BE(f[1], u + 4), t._cache.writeUInt32BE(f[2], u + 8), t._cache.writeUInt32BE(f[3], u + 12)
            }
            var h = t._cache.slice(0, e.length);
            return t._cache = t._cache.slice(e.length), n(e, h)
        }
    }, function(t, e) { t.exports = function(t) { for (var e, r = t.length; r--;) { if (255 !== (e = t.readUInt8(r))) { e++, t.writeUInt8(e, r); break } t.writeUInt8(0, r) } } }, function(t) { t.exports = { "aes-128-ecb": { cipher: "AES", key: 128, iv: 0, mode: "ECB", type: "block" }, "aes-192-ecb": { cipher: "AES", key: 192, iv: 0, mode: "ECB", type: "block" }, "aes-256-ecb": { cipher: "AES", key: 256, iv: 0, mode: "ECB", type: "block" }, "aes-128-cbc": { cipher: "AES", key: 128, iv: 16, mode: "CBC", type: "block" }, "aes-192-cbc": { cipher: "AES", key: 192, iv: 16, mode: "CBC", type: "block" }, "aes-256-cbc": { cipher: "AES", key: 256, iv: 16, mode: "CBC", type: "block" }, aes128: { cipher: "AES", key: 128, iv: 16, mode: "CBC", type: "block" }, aes192: { cipher: "AES", key: 192, iv: 16, mode: "CBC", type: "block" }, aes256: { cipher: "AES", key: 256, iv: 16, mode: "CBC", type: "block" }, "aes-128-cfb": { cipher: "AES", key: 128, iv: 16, mode: "CFB", type: "stream" }, "aes-192-cfb": { cipher: "AES", key: 192, iv: 16, mode: "CFB", type: "stream" }, "aes-256-cfb": { cipher: "AES", key: 256, iv: 16, mode: "CFB", type: "stream" }, "aes-128-cfb8": { cipher: "AES", key: 128, iv: 16, mode: "CFB8", type: "stream" }, "aes-192-cfb8": { cipher: "AES", key: 192, iv: 16, mode: "CFB8", type: "stream" }, "aes-256-cfb8": { cipher: "AES", key: 256, iv: 16, mode: "CFB8", type: "stream" }, "aes-128-cfb1": { cipher: "AES", key: 128, iv: 16, mode: "CFB1", type: "stream" }, "aes-192-cfb1": { cipher: "AES", key: 192, iv: 16, mode: "CFB1", type: "stream" }, "aes-256-cfb1": { cipher: "AES", key: 256, iv: 16, mode: "CFB1", type: "stream" }, "aes-128-ofb": { cipher: "AES", key: 128, iv: 16, mode: "OFB", type: "stream" }, "aes-192-ofb": { cipher: "AES", key: 192, iv: 16, mode: "OFB", type: "stream" }, "aes-256-ofb": { cipher: "AES", key: 256, iv: 16, mode: "OFB", type: "stream" }, "aes-128-ctr": { cipher: "AES", key: 128, iv: 16, mode: "CTR", type: "stream" }, "aes-192-ctr": { cipher: "AES", key: 192, iv: 16, mode: "CTR", type: "stream" }, "aes-256-ctr": { cipher: "AES", key: 256, iv: 16, mode: "CTR", type: "stream" }, "aes-128-gcm": { cipher: "AES", key: 128, iv: 12, mode: "GCM", type: "auth" }, "aes-192-gcm": { cipher: "AES", key: 192, iv: 12, mode: "GCM", type: "auth" }, "aes-256-gcm": { cipher: "AES", key: 256, iv: 12, mode: "GCM", type: "auth" } } }, function(t, e, r) {
        var n = r(11),
            i = r(0).Buffer,
            o = r(4),
            a = r(1),
            s = r(60),
            f = r(6),
            u = r(27);

        function h(t, e, r, a) {
            o.call(this);
            var f = i.alloc(4, 0);
            this._cipher = new n.AES(e);
            var h = this._cipher.encryptBlock(f);
            this._ghash = new s(h), r = function(t, e, r) {
                if (12 === e.length) return t._finID = i.concat([e, i.from([0, 0, 0, 1])]), i.concat([e, i.from([0, 0, 0, 2])]);
                var n = new s(r),
                    o = e.length,
                    a = o % 16;
                n.update(e), a && (a = 16 - a, n.update(i.alloc(a, 0))), n.update(i.alloc(8, 0));
                var f = 8 * o,
                    h = i.alloc(8);
                h.writeUIntBE(f, 0, 8), n.update(h), t._finID = n.state;
                var c = i.from(t._finID);
                return u(c), c
            }(this, r, h), this._prev = i.from(r), this._cache = i.allocUnsafe(0), this._secCache = i.allocUnsafe(0), this._decrypt = a, this._alen = 0, this._len = 0, this._mode = t, this._authTag = null, this._called = !1
        }
        a(h, o), h.prototype._update = function(t) {
            if (!this._called && this._alen) {
                var e = 16 - this._alen % 16;
                e < 16 && (e = i.alloc(e, 0), this._ghash.update(e))
            }
            this._called = !0;
            var r = this._mode.encrypt(this, t);
            return this._decrypt ? this._ghash.update(t) : this._ghash.update(r), this._len += t.length, r
        }, h.prototype._final = function() {
            if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
            var t = f(this._ghash.final(8 * this._alen, 8 * this._len), this._cipher.encryptBlock(this._finID));
            if (this._decrypt && function(t, e) {
                    var r = 0;
                    t.length !== e.length && r++;
                    for (var n = Math.min(t.length, e.length), i = 0; i < n; ++i) r += t[i] ^ e[i];
                    return r
                }(t, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
            this._authTag = t, this._cipher.scrub()
        }, h.prototype.getAuthTag = function() { if (this._decrypt || !i.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state"); return this._authTag }, h.prototype.setAuthTag = function(t) {
            if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
            this._authTag = t
        }, h.prototype.setAAD = function(t) {
            if (this._called) throw new Error("Attempting to set AAD in unsupported state");
            this._ghash.update(t), this._alen += t.length
        }, t.exports = h
    }, function(t, e, r) {
        var n = r(11),
            i = r(0).Buffer,
            o = r(4);

        function a(t, e, r, a) { o.call(this), this._cipher = new n.AES(e), this._prev = i.from(r), this._cache = i.allocUnsafe(0), this._secCache = i.allocUnsafe(0), this._decrypt = a, this._mode = t } r(1)(a, o), a.prototype._update = function(t) { return this._mode.encrypt(this, t, this._decrypt) }, a.prototype._final = function() { this._cipher.scrub() }, t.exports = a
    }, function(t, e, r) {
        const n = r(32),
            i = r(65),
            o = r(0).Buffer;
        e.decode = function(t) {
            t = o.from(t);
            const e = n.createDecipher("aes192", t.slice(0, 8));
            let r = e.update(t.slice(8)),
                a = e.final();
            const s = new Uint8Array(r.length + a.length);
            for (let t = 0; t < r.length; t++) s[t] = r[t];
            for (let t = 0; t < a.length; t++) s[t + r.length] = a[t];
            return i.inflate(s)
        }
    }, function(t, e, r) {
        var n = r(33),
            i = r(52),
            o = r(18),
            a = r(64),
            s = r(19);

        function f(t, e, r) { if (t = t.toLowerCase(), o[t]) return i.createCipheriv(t, e, r); if (a[t]) return new n({ key: e, iv: r, mode: t }); throw new TypeError("invalid suite type") }

        function u(t, e, r) { if (t = t.toLowerCase(), o[t]) return i.createDecipheriv(t, e, r); if (a[t]) return new n({ key: e, iv: r, mode: t, decrypt: !0 }); throw new TypeError("invalid suite type") } e.createCipher = e.Cipher = function(t, e) {
            var r, n;
            if (t = t.toLowerCase(), o[t]) r = o[t].key, n = o[t].iv;
            else {
                if (!a[t]) throw new TypeError("invalid suite type");
                r = 8 * a[t].key, n = a[t].iv
            }
            var i = s(e, !1, r, n);
            return f(t, i.key, i.iv)
        }, e.createCipheriv = e.Cipheriv = f, e.createDecipher = e.Decipher = function(t, e) {
            var r, n;
            if (t = t.toLowerCase(), o[t]) r = o[t].key, n = o[t].iv;
            else {
                if (!a[t]) throw new TypeError("invalid suite type");
                r = 8 * a[t].key, n = a[t].iv
            }
            var i = s(e, !1, r, n);
            return u(t, i.key, i.iv)
        }, e.createDecipheriv = e.Decipheriv = u, e.listCiphers = e.getCiphers = function() { return Object.keys(a).concat(i.getCiphers()) }
    }, function(t, e, r) {
        var n = r(4),
            i = r(17),
            o = r(1),
            a = r(0).Buffer,
            s = { "des-ede3-cbc": i.CBC.instantiate(i.EDE), "des-ede3": i.EDE, "des-ede-cbc": i.CBC.instantiate(i.EDE), "des-ede": i.EDE, "des-cbc": i.CBC.instantiate(i.DES), "des-ecb": i.DES };

        function f(t) {
            n.call(this);
            var e, r = t.mode.toLowerCase(),
                i = s[r];
            e = t.decrypt ? "decrypt" : "encrypt";
            var o = t.key;
            a.isBuffer(o) || (o = a.from(o)), "des-ede" !== r && "des-ede-cbc" !== r || (o = a.concat([o, o.slice(0, 8)]));
            var f = t.iv;
            a.isBuffer(f) || (f = a.from(f)), this._des = i.create({ key: o, iv: f, type: e })
        }
        s.des = s["des-cbc"], s.des3 = s["des-ede3-cbc"], t.exports = f, o(f, n), f.prototype._update = function(t) { return a.from(this._des.update(t)) }, f.prototype._final = function() { return a.from(this._des.final()) }
    }, function(t, e, r) {
        "use strict";
        e.byteLength = function(t) {
            var e = u(t),
                r = e[0],
                n = e[1];
            return 3 * (r + n) / 4 - n
        }, e.toByteArray = function(t) {
            for (var e, r = u(t), n = r[0], a = r[1], s = new o(function(t, e, r) { return 3 * (e + r) / 4 - r }(0, n, a)), f = 0, h = a > 0 ? n - 4 : n, c = 0; c < h; c += 4) e = i[t.charCodeAt(c)] << 18 | i[t.charCodeAt(c + 1)] << 12 | i[t.charCodeAt(c + 2)] << 6 | i[t.charCodeAt(c + 3)], s[f++] = e >> 16 & 255, s[f++] = e >> 8 & 255, s[f++] = 255 & e;
            2 === a && (e = i[t.charCodeAt(c)] << 2 | i[t.charCodeAt(c + 1)] >> 4, s[f++] = 255 & e);
            1 === a && (e = i[t.charCodeAt(c)] << 10 | i[t.charCodeAt(c + 1)] << 4 | i[t.charCodeAt(c + 2)] >> 2, s[f++] = e >> 8 & 255, s[f++] = 255 & e);
            return s
        }, e.fromByteArray = function(t) {
            for (var e, r = t.length, i = r % 3, o = [], a = 0, s = r - i; a < s; a += 16383) o.push(h(t, a, a + 16383 > s ? s : a + 16383));
            1 === i ? (e = t[r - 1], o.push(n[e >> 2] + n[e << 4 & 63] + "==")) : 2 === i && (e = (t[r - 2] << 8) + t[r - 1], o.push(n[e >> 10] + n[e >> 4 & 63] + n[e << 2 & 63] + "="));
            return o.join("")
        };
        for (var n = [], i = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s = 0, f = a.length; s < f; ++s) n[s] = a[s], i[a.charCodeAt(s)] = s;

        function u(t) { var e = t.length; if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4"); var r = t.indexOf("="); return -1 === r && (r = e), [r, r === e ? 0 : 4 - r % 4] }

        function h(t, e, r) { for (var i, o, a = [], s = e; s < r; s += 3) i = (t[s] << 16 & 16711680) + (t[s + 1] << 8 & 65280) + (255 & t[s + 2]), a.push(n[(o = i) >> 18 & 63] + n[o >> 12 & 63] + n[o >> 6 & 63] + n[63 & o]); return a.join("") } i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63
    }, function(t, e) {
        e.read = function(t, e, r, n, i) {
            var o, a, s = 8 * i - n - 1,
                f = (1 << s) - 1,
                u = f >> 1,
                h = -7,
                c = r ? i - 1 : 0,
                l = r ? -1 : 1,
                d = t[e + c];
            for (c += l, o = d & (1 << -h) - 1, d >>= -h, h += s; h > 0; o = 256 * o + t[e + c], c += l, h -= 8);
            for (a = o & (1 << -h) - 1, o >>= -h, h += n; h > 0; a = 256 * a + t[e + c], c += l, h -= 8);
            if (0 === o) o = 1 - u;
            else {
                if (o === f) return a ? NaN : 1 / 0 * (d ? -1 : 1);
                a += Math.pow(2, n), o -= u
            }
            return (d ? -1 : 1) * a * Math.pow(2, o - n)
        }, e.write = function(t, e, r, n, i, o) {
            var a, s, f, u = 8 * o - i - 1,
                h = (1 << u) - 1,
                c = h >> 1,
                l = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
                d = n ? 0 : o - 1,
                p = n ? 1 : -1,
                y = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;
            for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, a = h) : (a = Math.floor(Math.log(e) / Math.LN2), e * (f = Math.pow(2, -a)) < 1 && (a--, f *= 2), (e += a + c >= 1 ? l / f : l * Math.pow(2, 1 - c)) * f >= 2 && (a++, f /= 2), a + c >= h ? (s = 0, a = h) : a + c >= 1 ? (s = (e * f - 1) * Math.pow(2, i), a += c) : (s = e * Math.pow(2, c - 1) * Math.pow(2, i), a = 0)); i >= 8; t[r + d] = 255 & s, d += p, s /= 256, i -= 8);
            for (a = a << i | s, u += i; u > 0; t[r + d] = 255 & a, d += p, a /= 256, u -= 8);
            t[r + d - p] |= 128 * y
        }
    }, function(t, e) {}, function(t, e, r) {
        "use strict";
        var n = r(0).Buffer,
            i = r(38);
        t.exports = function() {
            function t() {! function(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") }(this, t), this.head = null, this.tail = null, this.length = 0 }
            return t.prototype.push = function(t) {
                var e = { data: t, next: null };
                this.length > 0 ? this.tail.next = e : this.head = e, this.tail = e, ++this.length
            }, t.prototype.unshift = function(t) {
                var e = { data: t, next: this.head };
                0 === this.length && (this.tail = e), this.head = e, ++this.length
            }, t.prototype.shift = function() { if (0 !== this.length) { var t = this.head.data; return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, t } }, t.prototype.clear = function() { this.head = this.tail = null, this.length = 0 }, t.prototype.join = function(t) { if (0 === this.length) return ""; for (var e = this.head, r = "" + e.data; e = e.next;) r += t + e.data; return r }, t.prototype.concat = function(t) { if (0 === this.length) return n.alloc(0); if (1 === this.length) return this.head.data; for (var e, r, i, o = n.allocUnsafe(t >>> 0), a = this.head, s = 0; a;) e = a.data, r = o, i = s, e.copy(r, i), s += a.data.length, a = a.next; return o }, t
        }(), i && i.inspect && i.inspect.custom && (t.exports.prototype[i.inspect.custom] = function() { var t = i.inspect({ length: this.length }); return this.constructor.name + " " + t })
    }, function(t, e) {}, function(t, e, r) {
        (function(t) {
            var n = void 0 !== t && t || "undefined" != typeof self && self || window,
                i = Function.prototype.apply;

            function o(t, e) { this._id = t, this._clearFn = e } e.setTimeout = function() { return new o(i.call(setTimeout, n, arguments), clearTimeout) }, e.setInterval = function() { return new o(i.call(setInterval, n, arguments), clearInterval) }, e.clearTimeout = e.clearInterval = function(t) { t && t.close() }, o.prototype.unref = o.prototype.ref = function() {}, o.prototype.close = function() { this._clearFn.call(n, this._id) }, e.enroll = function(t, e) { clearTimeout(t._idleTimeoutId), t._idleTimeout = e }, e.unenroll = function(t) { clearTimeout(t._idleTimeoutId), t._idleTimeout = -1 }, e._unrefActive = e.active = function(t) {
                clearTimeout(t._idleTimeoutId);
                var e = t._idleTimeout;
                e >= 0 && (t._idleTimeoutId = setTimeout(function() { t._onTimeout && t._onTimeout() }, e))
            }, r(40), e.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== t && t.setImmediate || this && this.setImmediate, e.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== t && t.clearImmediate || this && this.clearImmediate
        }).call(this, r(3))
    }, function(t, e, r) {
        (function(t, e) {
            ! function(t, r) {
                "use strict";
                if (!t.setImmediate) {
                    var n, i, o, a, s, f = 1,
                        u = {},
                        h = !1,
                        c = t.document,
                        l = Object.getPrototypeOf && Object.getPrototypeOf(t);
                    l = l && l.setTimeout ? l : t, "[object process]" === {}.toString.call(t.process) ? n = function(t) { e.nextTick(function() { p(t) }) } : ! function() {
                        if (t.postMessage && !t.importScripts) {
                            var e = !0,
                                r = t.onmessage;
                            return t.onmessage = function() { e = !1 }, t.postMessage("", "*"), t.onmessage = r, e
                        }
                    }() ? t.MessageChannel ? ((o = new MessageChannel).port1.onmessage = function(t) { p(t.data) }, n = function(t) { o.port2.postMessage(t) }) : c && "onreadystatechange" in c.createElement("script") ? (i = c.documentElement, n = function(t) {
                        var e = c.createElement("script");
                        e.onreadystatechange = function() { p(t), e.onreadystatechange = null, i.removeChild(e), e = null }, i.appendChild(e)
                    }) : n = function(t) { setTimeout(p, 0, t) } : (a = "setImmediate$" + Math.random() + "$", s = function(e) { e.source === t && "string" == typeof e.data && 0 === e.data.indexOf(a) && p(+e.data.slice(a.length)) }, t.addEventListener ? t.addEventListener("message", s, !1) : t.attachEvent("onmessage", s), n = function(e) { t.postMessage(a + e, "*") }), l.setImmediate = function(t) { "function" != typeof t && (t = new Function("" + t)); for (var e = new Array(arguments.length - 1), r = 0; r < e.length; r++) e[r] = arguments[r + 1]; var i = { callback: t, args: e }; return u[f] = i, n(f), f++ }, l.clearImmediate = d
                }

                function d(t) { delete u[t] }

                function p(t) {
                    if (h) setTimeout(p, 0, t);
                    else {
                        var e = u[t];
                        if (e) {
                            h = !0;
                            try {
                                ! function(t) {
                                    var e = t.callback,
                                        n = t.args;
                                    switch (n.length) {
                                        case 0:
                                            e();
                                            break;
                                        case 1:
                                            e(n[0]);
                                            break;
                                        case 2:
                                            e(n[0], n[1]);
                                            break;
                                        case 3:
                                            e(n[0], n[1], n[2]);
                                            break;
                                        default:
                                            e.apply(r, n)
                                    }
                                }(e)
                            } finally { d(t), h = !1 }
                        }
                    }
                }
            }("undefined" == typeof self ? void 0 === t ? this : t : self)
        }).call(this, r(3), r(8))
    }, function(t, e, r) {
        (function(e) {
            function r(t) { try { if (!e.localStorage) return !1 } catch (t) { return !1 } var r = e.localStorage[t]; return null != r && "true" === String(r).toLowerCase() } t.exports = function(t, e) {
                if (r("noDeprecation")) return t;
                var n = !1;
                return function() {
                    if (!n) {
                        if (r("throwDeprecation")) throw new Error(e);
                        r("traceDeprecation") ? console.trace(e) : console.warn(e), n = !0
                    }
                    return t.apply(this, arguments)
                }
            }
        }).call(this, r(3))
    }, function(t, e, r) {
        "use strict";
        t.exports = o;
        var n = r(25),
            i = r(5);

        function o(t) {
            if (!(this instanceof o)) return new o(t);
            n.call(this, t)
        }
        i.inherits = r(1), i.inherits(o, n), o.prototype._transform = function(t, e, r) { r(null, t) }
    }, function(t, e, r) { t.exports = r(15) }, function(t, e, r) { t.exports = r(2) }, function(t, e, r) { t.exports = r(14).Transform }, function(t, e, r) { t.exports = r(14).PassThrough }, function(t, e, r) {
        "use strict";
        e.readUInt32BE = function(t, e) { return (t[0 + e] << 24 | t[1 + e] << 16 | t[2 + e] << 8 | t[3 + e]) >>> 0 }, e.writeUInt32BE = function(t, e, r) { t[0 + r] = e >>> 24, t[1 + r] = e >>> 16 & 255, t[2 + r] = e >>> 8 & 255, t[3 + r] = 255 & e }, e.ip = function(t, e, r, n) { for (var i = 0, o = 0, a = 6; a >= 0; a -= 2) { for (var s = 0; s <= 24; s += 8) i <<= 1, i |= e >>> s + a & 1; for (s = 0; s <= 24; s += 8) i <<= 1, i |= t >>> s + a & 1 } for (a = 6; a >= 0; a -= 2) { for (s = 1; s <= 25; s += 8) o <<= 1, o |= e >>> s + a & 1; for (s = 1; s <= 25; s += 8) o <<= 1, o |= t >>> s + a & 1 } r[n + 0] = i >>> 0, r[n + 1] = o >>> 0 }, e.rip = function(t, e, r, n) {
            for (var i = 0, o = 0, a = 0; a < 4; a++)
                for (var s = 24; s >= 0; s -= 8) i <<= 1, i |= e >>> s + a & 1, i <<= 1, i |= t >>> s + a & 1;
            for (a = 4; a < 8; a++)
                for (s = 24; s >= 0; s -= 8) o <<= 1, o |= e >>> s + a & 1, o <<= 1, o |= t >>> s + a & 1;
            r[n + 0] = i >>> 0, r[n + 1] = o >>> 0
        }, e.pc1 = function(t, e, r, n) {
            for (var i = 0, o = 0, a = 7; a >= 5; a--) { for (var s = 0; s <= 24; s += 8) i <<= 1, i |= e >> s + a & 1; for (s = 0; s <= 24; s += 8) i <<= 1, i |= t >> s + a & 1 }
            for (s = 0; s <= 24; s += 8) i <<= 1, i |= e >> s + a & 1;
            for (a = 1; a <= 3; a++) { for (s = 0; s <= 24; s += 8) o <<= 1, o |= e >> s + a & 1; for (s = 0; s <= 24; s += 8) o <<= 1, o |= t >> s + a & 1 }
            for (s = 0; s <= 24; s += 8) o <<= 1, o |= t >> s + a & 1;
            r[n + 0] = i >>> 0, r[n + 1] = o >>> 0
        }, e.r28shl = function(t, e) { return t << e & 268435455 | t >>> 28 - e };
        var n = [14, 11, 17, 4, 27, 23, 25, 0, 13, 22, 7, 18, 5, 9, 16, 24, 2, 20, 12, 21, 1, 8, 15, 26, 15, 4, 25, 19, 9, 1, 26, 16, 5, 11, 23, 8, 12, 7, 17, 0, 22, 3, 10, 14, 6, 20, 27, 24];
        e.pc2 = function(t, e, r, i) {
            for (var o = 0, a = 0, s = n.length >>> 1, f = 0; f < s; f++) o <<= 1, o |= t >>> n[f] & 1;
            for (f = s; f < n.length; f++) a <<= 1, a |= e >>> n[f] & 1;
            r[i + 0] = o >>> 0, r[i + 1] = a >>> 0
        }, e.expand = function(t, e, r) {
            var n = 0,
                i = 0;
            n = (1 & t) << 5 | t >>> 27;
            for (var o = 23; o >= 15; o -= 4) n <<= 6, n |= t >>> o & 63;
            for (o = 11; o >= 3; o -= 4) i |= t >>> o & 63, i <<= 6;
            i |= (31 & t) << 1 | t >>> 31, e[r + 0] = n >>> 0, e[r + 1] = i >>> 0
        };
        var i = [14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1, 3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8, 4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7, 15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13, 15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14, 9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5, 0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2, 5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9, 10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10, 1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1, 13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7, 11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12, 7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3, 1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9, 10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8, 15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14, 2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1, 8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6, 4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13, 15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3, 12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5, 0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8, 9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10, 7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13, 4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10, 3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6, 1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7, 10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12, 13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4, 10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2, 7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13, 0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11];
        e.substitute = function(t, e) { for (var r = 0, n = 0; n < 4; n++) { r <<= 4, r |= i[64 * n + (t >>> 18 - 6 * n & 63)] } for (n = 0; n < 4; n++) { r <<= 4, r |= i[256 + 64 * n + (e >>> 18 - 6 * n & 63)] } return r >>> 0 };
        var o = [16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22, 30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7];
        e.permute = function(t) { for (var e = 0, r = 0; r < o.length; r++) e <<= 1, e |= t >>> o[r] & 1; return e >>> 0 }, e.padSplit = function(t, e, r) { for (var n = t.toString(2); n.length < e;) n = "0" + n; for (var i = [], o = 0; o < e; o += r) i.push(n.slice(o, o + r)); return i.join(" ") }
    }, function(t, e, r) {
        "use strict";
        var n = r(10);

        function i(t) { this.options = t, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0 } t.exports = i, i.prototype._init = function() {}, i.prototype.update = function(t) { return 0 === t.length ? [] : "decrypt" === this.type ? this._updateDecrypt(t) : this._updateEncrypt(t) }, i.prototype._buffer = function(t, e) { for (var r = Math.min(this.buffer.length - this.bufferOff, t.length - e), n = 0; n < r; n++) this.buffer[this.bufferOff + n] = t[e + n]; return this.bufferOff += r, r }, i.prototype._flushBuffer = function(t, e) { return this._update(this.buffer, 0, t, e), this.bufferOff = 0, this.blockSize }, i.prototype._updateEncrypt = function(t) {
            var e = 0,
                r = 0,
                n = (this.bufferOff + t.length) / this.blockSize | 0,
                i = new Array(n * this.blockSize);
            0 !== this.bufferOff && (e += this._buffer(t, e), this.bufferOff === this.buffer.length && (r += this._flushBuffer(i, r)));
            for (var o = t.length - (t.length - e) % this.blockSize; e < o; e += this.blockSize) this._update(t, e, i, r), r += this.blockSize;
            for (; e < t.length; e++, this.bufferOff++) this.buffer[this.bufferOff] = t[e];
            return i
        }, i.prototype._updateDecrypt = function(t) { for (var e = 0, r = 0, n = Math.ceil((this.bufferOff + t.length) / this.blockSize) - 1, i = new Array(n * this.blockSize); n > 0; n--) e += this._buffer(t, e), r += this._flushBuffer(i, r); return e += this._buffer(t, e), i }, i.prototype.final = function(t) { var e, r; return t && (e = this.update(t)), r = "encrypt" === this.type ? this._finalEncrypt() : this._finalDecrypt(), e ? e.concat(r) : r }, i.prototype._pad = function(t, e) { if (0 === e) return !1; for (; e < t.length;) t[e++] = 0; return !0 }, i.prototype._finalEncrypt = function() { if (!this._pad(this.buffer, this.bufferOff)) return []; var t = new Array(this.blockSize); return this._update(this.buffer, 0, t, 0), t }, i.prototype._unpad = function(t) { return t }, i.prototype._finalDecrypt = function() { n.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt"); var t = new Array(this.blockSize); return this._flushBuffer(t, 0), this._unpad(t) }
    }, function(t, e, r) {
        "use strict";
        var n = r(10),
            i = r(1),
            o = r(17),
            a = o.utils,
            s = o.Cipher;

        function f() { this.tmp = new Array(2), this.keys = null }

        function u(t) {
            s.call(this, t);
            var e = new f;
            this._desState = e, this.deriveKeys(e, t.key)
        }
        i(u, s), t.exports = u, u.create = function(t) { return new u(t) };
        var h = [1, 1, 2, 2, 2, 2, 2, 2, 1, 2, 2, 2, 2, 2, 2, 1];
        u.prototype.deriveKeys = function(t, e) {
            t.keys = new Array(32), n.equal(e.length, this.blockSize, "Invalid key length");
            var r = a.readUInt32BE(e, 0),
                i = a.readUInt32BE(e, 4);
            a.pc1(r, i, t.tmp, 0), r = t.tmp[0], i = t.tmp[1];
            for (var o = 0; o < t.keys.length; o += 2) {
                var s = h[o >>> 1];
                r = a.r28shl(r, s), i = a.r28shl(i, s), a.pc2(r, i, t.keys, o)
            }
        }, u.prototype._update = function(t, e, r, n) {
            var i = this._desState,
                o = a.readUInt32BE(t, e),
                s = a.readUInt32BE(t, e + 4);
            a.ip(o, s, i.tmp, 0), o = i.tmp[0], s = i.tmp[1], "encrypt" === this.type ? this._encrypt(i, o, s, i.tmp, 0) : this._decrypt(i, o, s, i.tmp, 0), o = i.tmp[0], s = i.tmp[1], a.writeUInt32BE(r, o, n), a.writeUInt32BE(r, s, n + 4)
        }, u.prototype._pad = function(t, e) { for (var r = t.length - e, n = e; n < t.length; n++) t[n] = r; return !0 }, u.prototype._unpad = function(t) { for (var e = t[t.length - 1], r = t.length - e; r < t.length; r++) n.equal(t[r], e); return t.slice(0, t.length - e) }, u.prototype._encrypt = function(t, e, r, n, i) {
            for (var o = e, s = r, f = 0; f < t.keys.length; f += 2) {
                var u = t.keys[f],
                    h = t.keys[f + 1];
                a.expand(s, t.tmp, 0), u ^= t.tmp[0], h ^= t.tmp[1];
                var c = a.substitute(u, h),
                    l = s;
                s = (o ^ a.permute(c)) >>> 0, o = l
            }
            a.rip(s, o, n, i)
        }, u.prototype._decrypt = function(t, e, r, n, i) {
            for (var o = r, s = e, f = t.keys.length - 2; f >= 0; f -= 2) {
                var u = t.keys[f],
                    h = t.keys[f + 1];
                a.expand(o, t.tmp, 0), u ^= t.tmp[0], h ^= t.tmp[1];
                var c = a.substitute(u, h),
                    l = o;
                o = (s ^ a.permute(c)) >>> 0, s = l
            }
            a.rip(o, s, n, i)
        }
    }, function(t, e, r) {
        "use strict";
        var n = r(10),
            i = r(1),
            o = {};

        function a(t) { n.equal(t.length, 8, "Invalid IV length"), this.iv = new Array(8); for (var e = 0; e < this.iv.length; e++) this.iv[e] = t[e] } e.instantiate = function(t) {
            function e(e) { t.call(this, e), this._cbcInit() } i(e, t);
            for (var r = Object.keys(o), n = 0; n < r.length; n++) {
                var a = r[n];
                e.prototype[a] = o[a]
            }
            return e.create = function(t) { return new e(t) }, e
        }, o._cbcInit = function() {
            var t = new a(this.options.iv);
            this._cbcState = t
        }, o._update = function(t, e, r, n) {
            var i = this._cbcState,
                o = this.constructor.super_.prototype,
                a = i.iv;
            if ("encrypt" === this.type) {
                for (var s = 0; s < this.blockSize; s++) a[s] ^= t[e + s];
                o._update.call(this, a, 0, r, n);
                for (s = 0; s < this.blockSize; s++) a[s] = r[n + s]
            } else { o._update.call(this, t, e, r, n); for (s = 0; s < this.blockSize; s++) r[n + s] ^= a[s]; for (s = 0; s < this.blockSize; s++) a[s] = t[e + s] }
        }
    }, function(t, e, r) {
        "use strict";
        var n = r(10),
            i = r(1),
            o = r(17),
            a = o.Cipher,
            s = o.DES;

        function f(t, e) {
            n.equal(e.length, 24, "Invalid key length");
            var r = e.slice(0, 8),
                i = e.slice(8, 16),
                o = e.slice(16, 24);
            this.ciphers = "encrypt" === t ? [s.create({ type: "encrypt", key: r }), s.create({ type: "decrypt", key: i }), s.create({ type: "encrypt", key: o })] : [s.create({ type: "decrypt", key: o }), s.create({ type: "encrypt", key: i }), s.create({ type: "decrypt", key: r })]
        }

        function u(t) {
            a.call(this, t);
            var e = new f(this.type, this.options.key);
            this._edeState = e
        }
        i(u, a), t.exports = u, u.create = function(t) { return new u(t) }, u.prototype._update = function(t, e, r, n) {
            var i = this._edeState;
            i.ciphers[0]._update(t, e, r, n), i.ciphers[1]._update(r, n, r, n), i.ciphers[2]._update(r, n, r, n)
        }, u.prototype._pad = s.prototype._pad, u.prototype._unpad = s.prototype._unpad
    }, function(t, e, r) {
        var n = r(53),
            i = r(63),
            o = r(28);
        e.createCipher = e.Cipher = n.createCipher, e.createCipheriv = e.Cipheriv = n.createCipheriv, e.createDecipher = e.Decipher = i.createDecipher, e.createDecipheriv = e.Decipheriv = i.createDecipheriv, e.listCiphers = e.getCiphers = function() { return Object.keys(o) }
    }, function(t, e, r) {
        var n = r(18),
            i = r(29),
            o = r(0).Buffer,
            a = r(30),
            s = r(4),
            f = r(11),
            u = r(19);

        function h(t, e, r) { s.call(this), this._cache = new l, this._cipher = new f.AES(e), this._prev = o.from(r), this._mode = t, this._autopadding = !0 } r(1)(h, s), h.prototype._update = function(t) {
            var e, r;
            this._cache.add(t);
            for (var n = []; e = this._cache.get();) r = this._mode.encrypt(this, e), n.push(r);
            return o.concat(n)
        };
        var c = o.alloc(16, 16);

        function l() { this.cache = o.allocUnsafe(0) }

        function d(t, e, r) { var s = n[t.toLowerCase()]; if (!s) throw new TypeError("invalid suite type"); if ("string" == typeof e && (e = o.from(e)), e.length !== s.key / 8) throw new TypeError("invalid key length " + e.length); if ("string" == typeof r && (r = o.from(r)), "GCM" !== s.mode && r.length !== s.iv) throw new TypeError("invalid iv length " + r.length); return "stream" === s.type ? new a(s.module, e, r) : "auth" === s.type ? new i(s.module, e, r) : new h(s.module, e, r) } h.prototype._final = function() { var t = this._cache.flush(); if (this._autopadding) return t = this._mode.encrypt(this, t), this._cipher.scrub(), t; if (!t.equals(c)) throw this._cipher.scrub(), new Error("data not multiple of block length") }, h.prototype.setAutoPadding = function(t) { return this._autopadding = !!t, this }, l.prototype.add = function(t) { this.cache = o.concat([this.cache, t]) }, l.prototype.get = function() { if (this.cache.length > 15) { var t = this.cache.slice(0, 16); return this.cache = this.cache.slice(16), t } return null }, l.prototype.flush = function() { for (var t = 16 - this.cache.length, e = o.allocUnsafe(t), r = -1; ++r < t;) e.writeUInt8(t, r); return o.concat([this.cache, e]) }, e.createCipheriv = d, e.createCipher = function(t, e) { var r = n[t.toLowerCase()]; if (!r) throw new TypeError("invalid suite type"); var i = u(e, !1, r.key, r.iv); return d(t, i.key, i.iv) }
    }, function(t, e) { e.encrypt = function(t, e) { return t._cipher.encryptBlock(e) }, e.decrypt = function(t, e) { return t._cipher.decryptBlock(e) } }, function(t, e, r) {
        var n = r(6);
        e.encrypt = function(t, e) { var r = n(e, t._prev); return t._prev = t._cipher.encryptBlock(r), t._prev }, e.decrypt = function(t, e) {
            var r = t._prev;
            t._prev = e;
            var i = t._cipher.decryptBlock(e);
            return n(i, r)
        }
    }, function(t, e, r) {
        var n = r(0).Buffer,
            i = r(6);

        function o(t, e, r) {
            var o = e.length,
                a = i(e, t._cache);
            return t._cache = t._cache.slice(o), t._prev = n.concat([t._prev, r ? e : a]), a
        }
        e.encrypt = function(t, e, r) { for (var i, a = n.allocUnsafe(0); e.length;) { if (0 === t._cache.length && (t._cache = t._cipher.encryptBlock(t._prev), t._prev = n.allocUnsafe(0)), !(t._cache.length <= e.length)) { a = n.concat([a, o(t, e, r)]); break } i = t._cache.length, a = n.concat([a, o(t, e.slice(0, i), r)]), e = e.slice(i) } return a }
    }, function(t, e, r) {
        var n = r(0).Buffer;

        function i(t, e, r) { var i = t._cipher.encryptBlock(t._prev)[0] ^ e; return t._prev = n.concat([t._prev.slice(1), n.from([r ? e : i])]), i } e.encrypt = function(t, e, r) { for (var o = e.length, a = n.allocUnsafe(o), s = -1; ++s < o;) a[s] = i(t, e[s], r); return a }
    }, function(t, e, r) {
        var n = r(0).Buffer;

        function i(t, e, r) { for (var n, i, a = -1, s = 0; ++a < 8;) n = e & 1 << 7 - a ? 128 : 0, s += (128 & (i = t._cipher.encryptBlock(t._prev)[0] ^ n)) >> a % 8, t._prev = o(t._prev, r ? n : i); return s }

        function o(t, e) {
            var r = t.length,
                i = -1,
                o = n.allocUnsafe(t.length);
            for (t = n.concat([t, n.from([e])]); ++i < r;) o[i] = t[i] << 1 | t[i + 1] >> 7;
            return o
        }
        e.encrypt = function(t, e, r) { for (var o = e.length, a = n.allocUnsafe(o), s = -1; ++s < o;) a[s] = i(t, e[s], r); return a }
    }, function(t, e, r) {
        (function(t) {
            var n = r(6);

            function i(t) { return t._prev = t._cipher.encryptBlock(t._prev), t._prev } e.encrypt = function(e, r) { for (; e._cache.length < r.length;) e._cache = t.concat([e._cache, i(e)]); var o = e._cache.slice(0, r.length); return e._cache = e._cache.slice(r.length), n(r, o) }
        }).call(this, r(7).Buffer)
    }, function(t, e, r) {
        var n = r(0).Buffer,
            i = n.alloc(16, 0);

        function o(t) { var e = n.allocUnsafe(16); return e.writeUInt32BE(t[0] >>> 0, 0), e.writeUInt32BE(t[1] >>> 0, 4), e.writeUInt32BE(t[2] >>> 0, 8), e.writeUInt32BE(t[3] >>> 0, 12), e }

        function a(t) { this.h = t, this.state = n.alloc(16, 0), this.cache = n.allocUnsafe(0) } a.prototype.ghash = function(t) {
            for (var e = -1; ++e < t.length;) this.state[e] ^= t[e];
            this._multiply()
        }, a.prototype._multiply = function() {
            for (var t, e, r, n = [(t = this.h).readUInt32BE(0), t.readUInt32BE(4), t.readUInt32BE(8), t.readUInt32BE(12)], i = [0, 0, 0, 0], a = -1; ++a < 128;) {
                for (0 != (this.state[~~(a / 8)] & 1 << 7 - a % 8) && (i[0] ^= n[0], i[1] ^= n[1], i[2] ^= n[2], i[3] ^= n[3]), r = 0 != (1 & n[3]), e = 3; e > 0; e--) n[e] = n[e] >>> 1 | (1 & n[e - 1]) << 31;
                n[0] = n[0] >>> 1, r && (n[0] = n[0] ^ 225 << 24)
            }
            this.state = o(i)
        }, a.prototype.update = function(t) { var e; for (this.cache = n.concat([this.cache, t]); this.cache.length >= 16;) e = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(e) }, a.prototype.final = function(t, e) { return this.cache.length && this.ghash(n.concat([this.cache, i], 16)), this.ghash(o([0, t, 0, e])), this.state }, t.exports = a
    }, function(t, e, r) {
        "use strict";
        var n = r(1),
            i = r(62),
            o = r(0).Buffer,
            a = new Array(16);

        function s() { i.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878 }

        function f(t, e) { return t << e | t >>> 32 - e }

        function u(t, e, r, n, i, o, a) { return f(t + (e & r | ~e & n) + i + o | 0, a) + e | 0 }

        function h(t, e, r, n, i, o, a) { return f(t + (e & n | r & ~n) + i + o | 0, a) + e | 0 }

        function c(t, e, r, n, i, o, a) { return f(t + (e ^ r ^ n) + i + o | 0, a) + e | 0 }

        function l(t, e, r, n, i, o, a) { return f(t + (r ^ (e | ~n)) + i + o | 0, a) + e | 0 } n(s, i), s.prototype._update = function() {
            for (var t = a, e = 0; e < 16; ++e) t[e] = this._block.readInt32LE(4 * e);
            var r = this._a,
                n = this._b,
                i = this._c,
                o = this._d;
            r = u(r, n, i, o, t[0], 3614090360, 7), o = u(o, r, n, i, t[1], 3905402710, 12), i = u(i, o, r, n, t[2], 606105819, 17), n = u(n, i, o, r, t[3], 3250441966, 22), r = u(r, n, i, o, t[4], 4118548399, 7), o = u(o, r, n, i, t[5], 1200080426, 12), i = u(i, o, r, n, t[6], 2821735955, 17), n = u(n, i, o, r, t[7], 4249261313, 22), r = u(r, n, i, o, t[8], 1770035416, 7), o = u(o, r, n, i, t[9], 2336552879, 12), i = u(i, o, r, n, t[10], 4294925233, 17), n = u(n, i, o, r, t[11], 2304563134, 22), r = u(r, n, i, o, t[12], 1804603682, 7), o = u(o, r, n, i, t[13], 4254626195, 12), i = u(i, o, r, n, t[14], 2792965006, 17), r = h(r, n = u(n, i, o, r, t[15], 1236535329, 22), i, o, t[1], 4129170786, 5), o = h(o, r, n, i, t[6], 3225465664, 9), i = h(i, o, r, n, t[11], 643717713, 14), n = h(n, i, o, r, t[0], 3921069994, 20), r = h(r, n, i, o, t[5], 3593408605, 5), o = h(o, r, n, i, t[10], 38016083, 9), i = h(i, o, r, n, t[15], 3634488961, 14), n = h(n, i, o, r, t[4], 3889429448, 20), r = h(r, n, i, o, t[9], 568446438, 5), o = h(o, r, n, i, t[14], 3275163606, 9), i = h(i, o, r, n, t[3], 4107603335, 14), n = h(n, i, o, r, t[8], 1163531501, 20), r = h(r, n, i, o, t[13], 2850285829, 5), o = h(o, r, n, i, t[2], 4243563512, 9), i = h(i, o, r, n, t[7], 1735328473, 14), r = c(r, n = h(n, i, o, r, t[12], 2368359562, 20), i, o, t[5], 4294588738, 4), o = c(o, r, n, i, t[8], 2272392833, 11), i = c(i, o, r, n, t[11], 1839030562, 16), n = c(n, i, o, r, t[14], 4259657740, 23), r = c(r, n, i, o, t[1], 2763975236, 4), o = c(o, r, n, i, t[4], 1272893353, 11), i = c(i, o, r, n, t[7], 4139469664, 16), n = c(n, i, o, r, t[10], 3200236656, 23), r = c(r, n, i, o, t[13], 681279174, 4), o = c(o, r, n, i, t[0], 3936430074, 11), i = c(i, o, r, n, t[3], 3572445317, 16), n = c(n, i, o, r, t[6], 76029189, 23), r = c(r, n, i, o, t[9], 3654602809, 4), o = c(o, r, n, i, t[12], 3873151461, 11), i = c(i, o, r, n, t[15], 530742520, 16), r = l(r, n = c(n, i, o, r, t[2], 3299628645, 23), i, o, t[0], 4096336452, 6), o = l(o, r, n, i, t[7], 1126891415, 10), i = l(i, o, r, n, t[14], 2878612391, 15), n = l(n, i, o, r, t[5], 4237533241, 21), r = l(r, n, i, o, t[12], 1700485571, 6), o = l(o, r, n, i, t[3], 2399980690, 10), i = l(i, o, r, n, t[10], 4293915773, 15), n = l(n, i, o, r, t[1], 2240044497, 21), r = l(r, n, i, o, t[8], 1873313359, 6), o = l(o, r, n, i, t[15], 4264355552, 10), i = l(i, o, r, n, t[6], 2734768916, 15), n = l(n, i, o, r, t[13], 1309151649, 21), r = l(r, n, i, o, t[4], 4149444226, 6), o = l(o, r, n, i, t[11], 3174756917, 10), i = l(i, o, r, n, t[2], 718787259, 15), n = l(n, i, o, r, t[9], 3951481745, 21), this._a = this._a + r | 0, this._b = this._b + n | 0, this._c = this._c + i | 0, this._d = this._d + o | 0
        }, s.prototype._digest = function() { this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update(); var t = o.allocUnsafe(16); return t.writeInt32LE(this._a, 0), t.writeInt32LE(this._b, 4), t.writeInt32LE(this._c, 8), t.writeInt32LE(this._d, 12), t }, t.exports = s
    }, function(t, e, r) {
        "use strict";
        var n = r(0).Buffer,
            i = r(21).Transform;

        function o(t) { i.call(this), this._block = n.allocUnsafe(t), this._blockSize = t, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1 } r(1)(o, i), o.prototype._transform = function(t, e, r) { var n = null; try { this.update(t, e) } catch (t) { n = t } r(n) }, o.prototype._flush = function(t) { var e = null; try { this.push(this.digest()) } catch (t) { e = t } t(e) }, o.prototype.update = function(t, e) {
            if (function(t, e) { if (!n.isBuffer(t) && "string" != typeof t) throw new TypeError(e + " must be a string or a buffer") }(t, "Data"), this._finalized) throw new Error("Digest already called");
            n.isBuffer(t) || (t = n.from(t, e));
            for (var r = this._block, i = 0; this._blockOffset + t.length - i >= this._blockSize;) {
                for (var o = this._blockOffset; o < this._blockSize;) r[o++] = t[i++];
                this._update(), this._blockOffset = 0
            }
            for (; i < t.length;) r[this._blockOffset++] = t[i++];
            for (var a = 0, s = 8 * t.length; s > 0; ++a) this._length[a] += s, (s = this._length[a] / 4294967296 | 0) > 0 && (this._length[a] -= 4294967296 * s);
            return this
        }, o.prototype._update = function() { throw new Error("_update is not implemented") }, o.prototype.digest = function(t) {
            if (this._finalized) throw new Error("Digest already called");
            this._finalized = !0;
            var e = this._digest();
            void 0 !== t && (e = e.toString(t)), this._block.fill(0), this._blockOffset = 0;
            for (var r = 0; r < 4; ++r) this._length[r] = 0;
            return e
        }, o.prototype._digest = function() { throw new Error("_digest is not implemented") }, t.exports = o
    }, function(t, e, r) {
        var n = r(29),
            i = r(0).Buffer,
            o = r(18),
            a = r(30),
            s = r(4),
            f = r(11),
            u = r(19);

        function h(t, e, r) { s.call(this), this._cache = new c, this._last = void 0, this._cipher = new f.AES(e), this._prev = i.from(r), this._mode = t, this._autopadding = !0 }

        function c() { this.cache = i.allocUnsafe(0) }

        function l(t, e, r) { var s = o[t.toLowerCase()]; if (!s) throw new TypeError("invalid suite type"); if ("string" == typeof r && (r = i.from(r)), "GCM" !== s.mode && r.length !== s.iv) throw new TypeError("invalid iv length " + r.length); if ("string" == typeof e && (e = i.from(e)), e.length !== s.key / 8) throw new TypeError("invalid key length " + e.length); return "stream" === s.type ? new a(s.module, e, r, !0) : "auth" === s.type ? new n(s.module, e, r, !0) : new h(s.module, e, r) } r(1)(h, s), h.prototype._update = function(t) {
            var e, r;
            this._cache.add(t);
            for (var n = []; e = this._cache.get(this._autopadding);) r = this._mode.decrypt(this, e), n.push(r);
            return i.concat(n)
        }, h.prototype._final = function() {
            var t = this._cache.flush();
            if (this._autopadding) return function(t) {
                var e = t[15];
                if (e < 1 || e > 16) throw new Error("unable to decrypt data");
                var r = -1;
                for (; ++r < e;)
                    if (t[r + (16 - e)] !== e) throw new Error("unable to decrypt data");
                if (16 === e) return;
                return t.slice(0, 16 - e)
            }(this._mode.decrypt(this, t));
            if (t) throw new Error("data not multiple of block length")
        }, h.prototype.setAutoPadding = function(t) { return this._autopadding = !!t, this }, c.prototype.add = function(t) { this.cache = i.concat([this.cache, t]) }, c.prototype.get = function(t) { var e; if (t) { if (this.cache.length > 16) return e = this.cache.slice(0, 16), this.cache = this.cache.slice(16), e } else if (this.cache.length >= 16) return e = this.cache.slice(0, 16), this.cache = this.cache.slice(16), e; return null }, c.prototype.flush = function() { if (this.cache.length) return this.cache }, e.createDecipher = function(t, e) { var r = o[t.toLowerCase()]; if (!r) throw new TypeError("invalid suite type"); var n = u(e, !1, r.key, r.iv); return l(t, n.key, n.iv) }, e.createDecipheriv = l
    }, function(t, e) { e["des-ecb"] = { key: 8, iv: 0 }, e["des-cbc"] = e.des = { key: 8, iv: 8 }, e["des-ede3-cbc"] = e.des3 = { key: 24, iv: 8 }, e["des-ede3"] = { key: 24, iv: 0 }, e["des-ede-cbc"] = { key: 16, iv: 8 }, e["des-ede"] = { key: 16, iv: 0 } }, function(t, e, r) {
        "use strict";
        var n = r(66),
            i = r(12),
            o = r(71),
            a = r(72),
            s = r(73),
            f = r(74),
            u = r(75),
            h = Object.prototype.toString;

        function c(t) {
            if (!(this instanceof c)) return new c(t);
            this.options = i.assign({ chunkSize: 16384, windowBits: 0, to: "" }, t || {});
            var e = this.options;
            e.raw && e.windowBits >= 0 && e.windowBits < 16 && (e.windowBits = -e.windowBits, 0 === e.windowBits && (e.windowBits = -15)), !(e.windowBits >= 0 && e.windowBits < 16) || t && t.windowBits || (e.windowBits += 32), e.windowBits > 15 && e.windowBits < 48 && 0 == (15 & e.windowBits) && (e.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new f, this.strm.avail_out = 0;
            var r = n.inflateInit2(this.strm, e.windowBits);
            if (r !== a.Z_OK) throw new Error(s[r]);
            if (this.header = new u, n.inflateGetHeader(this.strm, this.header), e.dictionary && ("string" == typeof e.dictionary ? e.dictionary = o.string2buf(e.dictionary) : "[object ArrayBuffer]" === h.call(e.dictionary) && (e.dictionary = new Uint8Array(e.dictionary)), e.raw && (r = n.inflateSetDictionary(this.strm, e.dictionary)) !== a.Z_OK)) throw new Error(s[r])
        }

        function l(t, e) { var r = new c(e); if (r.push(t, !0), r.err) throw r.msg || s[r.err]; return r.result } c.prototype.push = function(t, e) {
            var r, s, f, u, c, l = this.strm,
                d = this.options.chunkSize,
                p = this.options.dictionary,
                y = !1;
            if (this.ended) return !1;
            s = e === ~~e ? e : !0 === e ? a.Z_FINISH : a.Z_NO_FLUSH, "string" == typeof t ? l.input = o.binstring2buf(t) : "[object ArrayBuffer]" === h.call(t) ? l.input = new Uint8Array(t) : l.input = t, l.next_in = 0, l.avail_in = l.input.length;
            do {
                if (0 === l.avail_out && (l.output = new i.Buf8(d), l.next_out = 0, l.avail_out = d), (r = n.inflate(l, a.Z_NO_FLUSH)) === a.Z_NEED_DICT && p && (r = n.inflateSetDictionary(this.strm, p)), r === a.Z_BUF_ERROR && !0 === y && (r = a.Z_OK, y = !1), r !== a.Z_STREAM_END && r !== a.Z_OK) return this.onEnd(r), this.ended = !0, !1;
                l.next_out && (0 !== l.avail_out && r !== a.Z_STREAM_END && (0 !== l.avail_in || s !== a.Z_FINISH && s !== a.Z_SYNC_FLUSH) || ("string" === this.options.to ? (f = o.utf8border(l.output, l.next_out), u = l.next_out - f, c = o.buf2string(l.output, f), l.next_out = u, l.avail_out = d - u, u && i.arraySet(l.output, l.output, f, u, 0), this.onData(c)) : this.onData(i.shrinkBuf(l.output, l.next_out)))), 0 === l.avail_in && 0 === l.avail_out && (y = !0)
            } while ((l.avail_in > 0 || 0 === l.avail_out) && r !== a.Z_STREAM_END);
            return r === a.Z_STREAM_END && (s = a.Z_FINISH), s === a.Z_FINISH ? (r = n.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === a.Z_OK) : s !== a.Z_SYNC_FLUSH || (this.onEnd(a.Z_OK), l.avail_out = 0, !0)
        }, c.prototype.onData = function(t) { this.chunks.push(t) }, c.prototype.onEnd = function(t) { t === a.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = i.flattenChunks(this.chunks)), this.chunks = [], this.err = t, this.msg = this.strm.msg }, e.Inflate = c, e.inflate = l, e.inflateRaw = function(t, e) { return (e = e || {}).raw = !0, l(t, e) }, e.ungzip = l
    }, function(t, e, r) {
        "use strict";
        var n = r(12),
            i = r(67),
            o = r(68),
            a = r(69),
            s = r(70),
            f = 0,
            u = 1,
            h = 2,
            c = 4,
            l = 5,
            d = 6,
            p = 0,
            y = 1,
            g = 2,
            v = -2,
            b = -3,
            w = -4,
            _ = -5,
            m = 8,
            k = 1,
            E = 2,
            S = 3,
            B = 4,
            x = 5,
            A = 6,
            T = 7,
            C = 8,
            R = 9,
            O = 10,
            I = 11,
            U = 12,
            M = 13,
            L = 14,
            D = 15,
            P = 16,
            N = 17,
            j = 18,
            F = 19,
            z = 20,
            Y = 21,
            Z = 22,
            q = 23,
            W = 24,
            X = 25,
            H = 26,
            K = 27,
            V = 28,
            G = 29,
            $ = 30,
            J = 31,
            Q = 32,
            tt = 852,
            et = 592,
            rt = 15;

        function nt(t) { return (t >>> 24 & 255) + (t >>> 8 & 65280) + ((65280 & t) << 8) + ((255 & t) << 24) }

        function it() { this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new n.Buf16(320), this.work = new n.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0 }

        function ot(t) { var e; return t && t.state ? (e = t.state, t.total_in = t.total_out = e.total = 0, t.msg = "", e.wrap && (t.adler = 1 & e.wrap), e.mode = k, e.last = 0, e.havedict = 0, e.dmax = 32768, e.head = null, e.hold = 0, e.bits = 0, e.lencode = e.lendyn = new n.Buf32(tt), e.distcode = e.distdyn = new n.Buf32(et), e.sane = 1, e.back = -1, p) : v }

        function at(t) { var e; return t && t.state ? ((e = t.state).wsize = 0, e.whave = 0, e.wnext = 0, ot(t)) : v }

        function st(t, e) { var r, n; return t && t.state ? (n = t.state, e < 0 ? (r = 0, e = -e) : (r = 1 + (e >> 4), e < 48 && (e &= 15)), e && (e < 8 || e > 15) ? v : (null !== n.window && n.wbits !== e && (n.window = null), n.wrap = r, n.wbits = e, at(t))) : v }

        function ft(t, e) { var r, n; return t ? (n = new it, t.state = n, n.window = null, (r = st(t, e)) !== p && (t.state = null), r) : v }
        var ut, ht, ct = !0;

        function lt(t) {
            if (ct) {
                var e;
                for (ut = new n.Buf32(512), ht = new n.Buf32(32), e = 0; e < 144;) t.lens[e++] = 8;
                for (; e < 256;) t.lens[e++] = 9;
                for (; e < 280;) t.lens[e++] = 7;
                for (; e < 288;) t.lens[e++] = 8;
                for (s(u, t.lens, 0, 288, ut, 0, t.work, { bits: 9 }), e = 0; e < 32;) t.lens[e++] = 5;
                s(h, t.lens, 0, 32, ht, 0, t.work, { bits: 5 }), ct = !1
            }
            t.lencode = ut, t.lenbits = 9, t.distcode = ht, t.distbits = 5
        }

        function dt(t, e, r, i) { var o, a = t.state; return null === a.window && (a.wsize = 1 << a.wbits, a.wnext = 0, a.whave = 0, a.window = new n.Buf8(a.wsize)), i >= a.wsize ? (n.arraySet(a.window, e, r - a.wsize, a.wsize, 0), a.wnext = 0, a.whave = a.wsize) : ((o = a.wsize - a.wnext) > i && (o = i), n.arraySet(a.window, e, r - i, o, a.wnext), (i -= o) ? (n.arraySet(a.window, e, r - i, i, 0), a.wnext = i, a.whave = a.wsize) : (a.wnext += o, a.wnext === a.wsize && (a.wnext = 0), a.whave < a.wsize && (a.whave += o))), 0 } e.inflateReset = at, e.inflateReset2 = st, e.inflateResetKeep = ot, e.inflateInit = function(t) { return ft(t, rt) }, e.inflateInit2 = ft, e.inflate = function(t, e) {
            var r, tt, et, rt, it, ot, at, st, ft, ut, ht, ct, pt, yt, gt, vt, bt, wt, _t, mt, kt, Et, St, Bt, xt = 0,
                At = new n.Buf8(4),
                Tt = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
            if (!t || !t.state || !t.output || !t.input && 0 !== t.avail_in) return v;
            (r = t.state).mode === U && (r.mode = M), it = t.next_out, et = t.output, at = t.avail_out, rt = t.next_in, tt = t.input, ot = t.avail_in, st = r.hold, ft = r.bits, ut = ot, ht = at, Et = p;
            t: for (;;) switch (r.mode) {
                case k:
                    if (0 === r.wrap) { r.mode = M; break }
                    for (; ft < 16;) {
                        if (0 === ot) break t;
                        ot--, st += tt[rt++] << ft, ft += 8
                    }
                    if (2 & r.wrap && 35615 === st) { r.check = 0, At[0] = 255 & st, At[1] = st >>> 8 & 255, r.check = o(r.check, At, 2, 0), st = 0, ft = 0, r.mode = E; break }
                    if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & st) << 8) + (st >> 8)) % 31) { t.msg = "incorrect header check", r.mode = $; break }
                    if ((15 & st) !== m) { t.msg = "unknown compression method", r.mode = $; break }
                    if (ft -= 4, kt = 8 + (15 & (st >>>= 4)), 0 === r.wbits) r.wbits = kt;
                    else if (kt > r.wbits) { t.msg = "invalid window size", r.mode = $; break } r.dmax = 1 << kt, t.adler = r.check = 1, r.mode = 512 & st ? O : U, st = 0, ft = 0;
                    break;
                case E:
                    for (; ft < 16;) {
                        if (0 === ot) break t;
                        ot--, st += tt[rt++] << ft, ft += 8
                    }
                    if (r.flags = st, (255 & r.flags) !== m) { t.msg = "unknown compression method", r.mode = $; break }
                    if (57344 & r.flags) { t.msg = "unknown header flags set", r.mode = $; break } r.head && (r.head.text = st >> 8 & 1), 512 & r.flags && (At[0] = 255 & st, At[1] = st >>> 8 & 255, r.check = o(r.check, At, 2, 0)), st = 0, ft = 0, r.mode = S;
                case S:
                    for (; ft < 32;) {
                        if (0 === ot) break t;
                        ot--, st += tt[rt++] << ft, ft += 8
                    }
                    r.head && (r.head.time = st), 512 & r.flags && (At[0] = 255 & st, At[1] = st >>> 8 & 255, At[2] = st >>> 16 & 255, At[3] = st >>> 24 & 255, r.check = o(r.check, At, 4, 0)), st = 0, ft = 0, r.mode = B;
                case B:
                    for (; ft < 16;) {
                        if (0 === ot) break t;
                        ot--, st += tt[rt++] << ft, ft += 8
                    }
                    r.head && (r.head.xflags = 255 & st, r.head.os = st >> 8), 512 & r.flags && (At[0] = 255 & st, At[1] = st >>> 8 & 255, r.check = o(r.check, At, 2, 0)), st = 0, ft = 0, r.mode = x;
                case x:
                    if (1024 & r.flags) {
                        for (; ft < 16;) {
                            if (0 === ot) break t;
                            ot--, st += tt[rt++] << ft, ft += 8
                        }
                        r.length = st, r.head && (r.head.extra_len = st), 512 & r.flags && (At[0] = 255 & st, At[1] = st >>> 8 & 255, r.check = o(r.check, At, 2, 0)), st = 0, ft = 0
                    } else r.head && (r.head.extra = null);
                    r.mode = A;
                case A:
                    if (1024 & r.flags && ((ct = r.length) > ot && (ct = ot), ct && (r.head && (kt = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), n.arraySet(r.head.extra, tt, rt, ct, kt)), 512 & r.flags && (r.check = o(r.check, tt, ct, rt)), ot -= ct, rt += ct, r.length -= ct), r.length)) break t;
                    r.length = 0, r.mode = T;
                case T:
                    if (2048 & r.flags) {
                        if (0 === ot) break t;
                        ct = 0;
                        do { kt = tt[rt + ct++], r.head && kt && r.length < 65536 && (r.head.name += String.fromCharCode(kt)) } while (kt && ct < ot);
                        if (512 & r.flags && (r.check = o(r.check, tt, ct, rt)), ot -= ct, rt += ct, kt) break t
                    } else r.head && (r.head.name = null);
                    r.length = 0, r.mode = C;
                case C:
                    if (4096 & r.flags) {
                        if (0 === ot) break t;
                        ct = 0;
                        do { kt = tt[rt + ct++], r.head && kt && r.length < 65536 && (r.head.comment += String.fromCharCode(kt)) } while (kt && ct < ot);
                        if (512 & r.flags && (r.check = o(r.check, tt, ct, rt)), ot -= ct, rt += ct, kt) break t
                    } else r.head && (r.head.comment = null);
                    r.mode = R;
                case R:
                    if (512 & r.flags) {
                        for (; ft < 16;) {
                            if (0 === ot) break t;
                            ot--, st += tt[rt++] << ft, ft += 8
                        }
                        if (st !== (65535 & r.check)) { t.msg = "header crc mismatch", r.mode = $; break } st = 0, ft = 0
                    }
                    r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), t.adler = r.check = 0, r.mode = U;
                    break;
                case O:
                    for (; ft < 32;) {
                        if (0 === ot) break t;
                        ot--, st += tt[rt++] << ft, ft += 8
                    }
                    t.adler = r.check = nt(st), st = 0, ft = 0, r.mode = I;
                case I:
                    if (0 === r.havedict) return t.next_out = it, t.avail_out = at, t.next_in = rt, t.avail_in = ot, r.hold = st, r.bits = ft, g;
                    t.adler = r.check = 1, r.mode = U;
                case U:
                    if (e === l || e === d) break t;
                case M:
                    if (r.last) { st >>>= 7 & ft, ft -= 7 & ft, r.mode = K; break }
                    for (; ft < 3;) {
                        if (0 === ot) break t;
                        ot--, st += tt[rt++] << ft, ft += 8
                    }
                    switch (r.last = 1 & st, ft -= 1, 3 & (st >>>= 1)) {
                        case 0:
                            r.mode = L;
                            break;
                        case 1:
                            if (lt(r), r.mode = z, e === d) { st >>>= 2, ft -= 2; break t }
                            break;
                        case 2:
                            r.mode = N;
                            break;
                        case 3:
                            t.msg = "invalid block type", r.mode = $
                    }
                    st >>>= 2, ft -= 2;
                    break;
                case L:
                    for (st >>>= 7 & ft, ft -= 7 & ft; ft < 32;) {
                        if (0 === ot) break t;
                        ot--, st += tt[rt++] << ft, ft += 8
                    }
                    if ((65535 & st) != (st >>> 16 ^ 65535)) { t.msg = "invalid stored block lengths", r.mode = $; break }
                    if (r.length = 65535 & st, st = 0, ft = 0, r.mode = D, e === d) break t;
                case D:
                    r.mode = P;
                case P:
                    if (ct = r.length) {
                        if (ct > ot && (ct = ot), ct > at && (ct = at), 0 === ct) break t;
                        n.arraySet(et, tt, rt, ct, it), ot -= ct, rt += ct, at -= ct, it += ct, r.length -= ct;
                        break
                    }
                    r.mode = U;
                    break;
                case N:
                    for (; ft < 14;) {
                        if (0 === ot) break t;
                        ot--, st += tt[rt++] << ft, ft += 8
                    }
                    if (r.nlen = 257 + (31 & st), st >>>= 5, ft -= 5, r.ndist = 1 + (31 & st), st >>>= 5, ft -= 5, r.ncode = 4 + (15 & st), st >>>= 4, ft -= 4, r.nlen > 286 || r.ndist > 30) { t.msg = "too many length or distance symbols", r.mode = $; break } r.have = 0, r.mode = j;
                case j:
                    for (; r.have < r.ncode;) {
                        for (; ft < 3;) {
                            if (0 === ot) break t;
                            ot--, st += tt[rt++] << ft, ft += 8
                        }
                        r.lens[Tt[r.have++]] = 7 & st, st >>>= 3, ft -= 3
                    }
                    for (; r.have < 19;) r.lens[Tt[r.have++]] = 0;
                    if (r.lencode = r.lendyn, r.lenbits = 7, St = { bits: r.lenbits }, Et = s(f, r.lens, 0, 19, r.lencode, 0, r.work, St), r.lenbits = St.bits, Et) { t.msg = "invalid code lengths set", r.mode = $; break } r.have = 0, r.mode = F;
                case F:
                    for (; r.have < r.nlen + r.ndist;) {
                        for (; vt = (xt = r.lencode[st & (1 << r.lenbits) - 1]) >>> 16 & 255, bt = 65535 & xt, !((gt = xt >>> 24) <= ft);) {
                            if (0 === ot) break t;
                            ot--, st += tt[rt++] << ft, ft += 8
                        }
                        if (bt < 16) st >>>= gt, ft -= gt, r.lens[r.have++] = bt;
                        else {
                            if (16 === bt) {
                                for (Bt = gt + 2; ft < Bt;) {
                                    if (0 === ot) break t;
                                    ot--, st += tt[rt++] << ft, ft += 8
                                }
                                if (st >>>= gt, ft -= gt, 0 === r.have) { t.msg = "invalid bit length repeat", r.mode = $; break } kt = r.lens[r.have - 1], ct = 3 + (3 & st), st >>>= 2, ft -= 2
                            } else if (17 === bt) {
                                for (Bt = gt + 3; ft < Bt;) {
                                    if (0 === ot) break t;
                                    ot--, st += tt[rt++] << ft, ft += 8
                                }
                                ft -= gt, kt = 0, ct = 3 + (7 & (st >>>= gt)), st >>>= 3, ft -= 3
                            } else {
                                for (Bt = gt + 7; ft < Bt;) {
                                    if (0 === ot) break t;
                                    ot--, st += tt[rt++] << ft, ft += 8
                                }
                                ft -= gt, kt = 0, ct = 11 + (127 & (st >>>= gt)), st >>>= 7, ft -= 7
                            }
                            if (r.have + ct > r.nlen + r.ndist) { t.msg = "invalid bit length repeat", r.mode = $; break }
                            for (; ct--;) r.lens[r.have++] = kt
                        }
                    }
                    if (r.mode === $) break;
                    if (0 === r.lens[256]) { t.msg = "invalid code -- missing end-of-block", r.mode = $; break }
                    if (r.lenbits = 9, St = { bits: r.lenbits }, Et = s(u, r.lens, 0, r.nlen, r.lencode, 0, r.work, St), r.lenbits = St.bits, Et) { t.msg = "invalid literal/lengths set", r.mode = $; break }
                    if (r.distbits = 6, r.distcode = r.distdyn, St = { bits: r.distbits }, Et = s(h, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, St), r.distbits = St.bits, Et) { t.msg = "invalid distances set", r.mode = $; break }
                    if (r.mode = z, e === d) break t;
                case z:
                    r.mode = Y;
                case Y:
                    if (ot >= 6 && at >= 258) { t.next_out = it, t.avail_out = at, t.next_in = rt, t.avail_in = ot, r.hold = st, r.bits = ft, a(t, ht), it = t.next_out, et = t.output, at = t.avail_out, rt = t.next_in, tt = t.input, ot = t.avail_in, st = r.hold, ft = r.bits, r.mode === U && (r.back = -1); break }
                    for (r.back = 0; vt = (xt = r.lencode[st & (1 << r.lenbits) - 1]) >>> 16 & 255, bt = 65535 & xt, !((gt = xt >>> 24) <= ft);) {
                        if (0 === ot) break t;
                        ot--, st += tt[rt++] << ft, ft += 8
                    }
                    if (vt && 0 == (240 & vt)) {
                        for (wt = gt, _t = vt, mt = bt; vt = (xt = r.lencode[mt + ((st & (1 << wt + _t) - 1) >> wt)]) >>> 16 & 255, bt = 65535 & xt, !(wt + (gt = xt >>> 24) <= ft);) {
                            if (0 === ot) break t;
                            ot--, st += tt[rt++] << ft, ft += 8
                        }
                        st >>>= wt, ft -= wt, r.back += wt
                    }
                    if (st >>>= gt, ft -= gt, r.back += gt, r.length = bt, 0 === vt) { r.mode = H; break }
                    if (32 & vt) { r.back = -1, r.mode = U; break }
                    if (64 & vt) { t.msg = "invalid literal/length code", r.mode = $; break } r.extra = 15 & vt, r.mode = Z;
                case Z:
                    if (r.extra) {
                        for (Bt = r.extra; ft < Bt;) {
                            if (0 === ot) break t;
                            ot--, st += tt[rt++] << ft, ft += 8
                        }
                        r.length += st & (1 << r.extra) - 1, st >>>= r.extra, ft -= r.extra, r.back += r.extra
                    }
                    r.was = r.length, r.mode = q;
                case q:
                    for (; vt = (xt = r.distcode[st & (1 << r.distbits) - 1]) >>> 16 & 255, bt = 65535 & xt, !((gt = xt >>> 24) <= ft);) {
                        if (0 === ot) break t;
                        ot--, st += tt[rt++] << ft, ft += 8
                    }
                    if (0 == (240 & vt)) {
                        for (wt = gt, _t = vt, mt = bt; vt = (xt = r.distcode[mt + ((st & (1 << wt + _t) - 1) >> wt)]) >>> 16 & 255, bt = 65535 & xt, !(wt + (gt = xt >>> 24) <= ft);) {
                            if (0 === ot) break t;
                            ot--, st += tt[rt++] << ft, ft += 8
                        }
                        st >>>= wt, ft -= wt, r.back += wt
                    }
                    if (st >>>= gt, ft -= gt, r.back += gt, 64 & vt) { t.msg = "invalid distance code", r.mode = $; break } r.offset = bt, r.extra = 15 & vt, r.mode = W;
                case W:
                    if (r.extra) {
                        for (Bt = r.extra; ft < Bt;) {
                            if (0 === ot) break t;
                            ot--, st += tt[rt++] << ft, ft += 8
                        }
                        r.offset += st & (1 << r.extra) - 1, st >>>= r.extra, ft -= r.extra, r.back += r.extra
                    }
                    if (r.offset > r.dmax) { t.msg = "invalid distance too far back", r.mode = $; break } r.mode = X;
                case X:
                    if (0 === at) break t;
                    if (ct = ht - at, r.offset > ct) { if ((ct = r.offset - ct) > r.whave && r.sane) { t.msg = "invalid distance too far back", r.mode = $; break } ct > r.wnext ? (ct -= r.wnext, pt = r.wsize - ct) : pt = r.wnext - ct, ct > r.length && (ct = r.length), yt = r.window } else yt = et, pt = it - r.offset, ct = r.length;
                    ct > at && (ct = at), at -= ct, r.length -= ct;
                    do { et[it++] = yt[pt++] } while (--ct);
                    0 === r.length && (r.mode = Y);
                    break;
                case H:
                    if (0 === at) break t;
                    et[it++] = r.length, at--, r.mode = Y;
                    break;
                case K:
                    if (r.wrap) {
                        for (; ft < 32;) {
                            if (0 === ot) break t;
                            ot--, st |= tt[rt++] << ft, ft += 8
                        }
                        if (ht -= at, t.total_out += ht, r.total += ht, ht && (t.adler = r.check = r.flags ? o(r.check, et, ht, it - ht) : i(r.check, et, ht, it - ht)), ht = at, (r.flags ? st : nt(st)) !== r.check) { t.msg = "incorrect data check", r.mode = $; break } st = 0, ft = 0
                    }
                    r.mode = V;
                case V:
                    if (r.wrap && r.flags) {
                        for (; ft < 32;) {
                            if (0 === ot) break t;
                            ot--, st += tt[rt++] << ft, ft += 8
                        }
                        if (st !== (4294967295 & r.total)) { t.msg = "incorrect length check", r.mode = $; break } st = 0, ft = 0
                    }
                    r.mode = G;
                case G:
                    Et = y;
                    break t;
                case $:
                    Et = b;
                    break t;
                case J:
                    return w;
                case Q:
                default:
                    return v
            }
            return t.next_out = it, t.avail_out = at, t.next_in = rt, t.avail_in = ot, r.hold = st, r.bits = ft, (r.wsize || ht !== t.avail_out && r.mode < $ && (r.mode < K || e !== c)) && dt(t, t.output, t.next_out, ht - t.avail_out) ? (r.mode = J, w) : (ut -= t.avail_in, ht -= t.avail_out, t.total_in += ut, t.total_out += ht, r.total += ht, r.wrap && ht && (t.adler = r.check = r.flags ? o(r.check, et, ht, t.next_out - ht) : i(r.check, et, ht, t.next_out - ht)), t.data_type = r.bits + (r.last ? 64 : 0) + (r.mode === U ? 128 : 0) + (r.mode === z || r.mode === D ? 256 : 0), (0 === ut && 0 === ht || e === c) && Et === p && (Et = _), Et)
        }, e.inflateEnd = function(t) { if (!t || !t.state) return v; var e = t.state; return e.window && (e.window = null), t.state = null, p }, e.inflateGetHeader = function(t, e) { var r; return t && t.state ? 0 == (2 & (r = t.state).wrap) ? v : (r.head = e, e.done = !1, p) : v }, e.inflateSetDictionary = function(t, e) { var r, n = e.length; return t && t.state ? 0 !== (r = t.state).wrap && r.mode !== I ? v : r.mode === I && i(1, e, n, 0) !== r.check ? b : dt(t, e, n, n) ? (r.mode = J, w) : (r.havedict = 1, p) : v }, e.inflateInfo = "pako inflate (from Nodeca project)"
    }, function(t, e, r) {
        "use strict";
        t.exports = function(t, e, r, n) {
            for (var i = 65535 & t | 0, o = t >>> 16 & 65535 | 0, a = 0; 0 !== r;) {
                r -= a = r > 2e3 ? 2e3 : r;
                do { o = o + (i = i + e[n++] | 0) | 0 } while (--a);
                i %= 65521, o %= 65521
            }
            return i | o << 16 | 0
        }
    }, function(t, e, r) {
        "use strict";
        var n = function() {
            for (var t, e = [], r = 0; r < 256; r++) {
                t = r;
                for (var n = 0; n < 8; n++) t = 1 & t ? 3988292384 ^ t >>> 1 : t >>> 1;
                e[r] = t
            }
            return e
        }();
        t.exports = function(t, e, r, i) {
            var o = n,
                a = i + r;
            t ^= -1;
            for (var s = i; s < a; s++) t = t >>> 8 ^ o[255 & (t ^ e[s])];
            return -1 ^ t
        }
    }, function(t, e, r) {
        "use strict";
        t.exports = function(t, e) {
            var r, n, i, o, a, s, f, u, h, c, l, d, p, y, g, v, b, w, _, m, k, E, S, B, x;
            r = t.state, n = t.next_in, B = t.input, i = n + (t.avail_in - 5), o = t.next_out, x = t.output, a = o - (e - t.avail_out), s = o + (t.avail_out - 257), f = r.dmax, u = r.wsize, h = r.whave, c = r.wnext, l = r.window, d = r.hold, p = r.bits, y = r.lencode, g = r.distcode, v = (1 << r.lenbits) - 1, b = (1 << r.distbits) - 1;
            t: do {
                p < 15 && (d += B[n++] << p, p += 8, d += B[n++] << p, p += 8), w = y[d & v];
                e: for (;;) {
                    if (d >>>= _ = w >>> 24, p -= _, 0 === (_ = w >>> 16 & 255)) x[o++] = 65535 & w;
                    else {
                        if (!(16 & _)) { if (0 == (64 & _)) { w = y[(65535 & w) + (d & (1 << _) - 1)]; continue e } if (32 & _) { r.mode = 12; break t } t.msg = "invalid literal/length code", r.mode = 30; break t } m = 65535 & w, (_ &= 15) && (p < _ && (d += B[n++] << p, p += 8), m += d & (1 << _) - 1, d >>>= _, p -= _), p < 15 && (d += B[n++] << p, p += 8, d += B[n++] << p, p += 8), w = g[d & b];
                        r: for (;;) {
                            if (d >>>= _ = w >>> 24, p -= _, !(16 & (_ = w >>> 16 & 255))) { if (0 == (64 & _)) { w = g[(65535 & w) + (d & (1 << _) - 1)]; continue r } t.msg = "invalid distance code", r.mode = 30; break t }
                            if (k = 65535 & w, p < (_ &= 15) && (d += B[n++] << p, (p += 8) < _ && (d += B[n++] << p, p += 8)), (k += d & (1 << _) - 1) > f) { t.msg = "invalid distance too far back", r.mode = 30; break t }
                            if (d >>>= _, p -= _, k > (_ = o - a)) {
                                if ((_ = k - _) > h && r.sane) { t.msg = "invalid distance too far back", r.mode = 30; break t }
                                if (E = 0, S = l, 0 === c) {
                                    if (E += u - _, _ < m) {
                                        m -= _;
                                        do { x[o++] = l[E++] } while (--_);
                                        E = o - k, S = x
                                    }
                                } else if (c < _) {
                                    if (E += u + c - _, (_ -= c) < m) {
                                        m -= _;
                                        do { x[o++] = l[E++] } while (--_);
                                        if (E = 0, c < m) {
                                            m -= _ = c;
                                            do { x[o++] = l[E++] } while (--_);
                                            E = o - k, S = x
                                        }
                                    }
                                } else if (E += c - _, _ < m) {
                                    m -= _;
                                    do { x[o++] = l[E++] } while (--_);
                                    E = o - k, S = x
                                }
                                for (; m > 2;) x[o++] = S[E++], x[o++] = S[E++], x[o++] = S[E++], m -= 3;
                                m && (x[o++] = S[E++], m > 1 && (x[o++] = S[E++]))
                            } else {
                                E = o - k;
                                do { x[o++] = x[E++], x[o++] = x[E++], x[o++] = x[E++], m -= 3 } while (m > 2);
                                m && (x[o++] = x[E++], m > 1 && (x[o++] = x[E++]))
                            }
                            break
                        }
                    }
                    break
                }
            } while (n < i && o < s);
            n -= m = p >> 3, d &= (1 << (p -= m << 3)) - 1, t.next_in = n, t.next_out = o, t.avail_in = n < i ? i - n + 5 : 5 - (n - i), t.avail_out = o < s ? s - o + 257 : 257 - (o - s), r.hold = d, r.bits = p
        }
    }, function(t, e, r) {
        "use strict";
        var n = r(12),
            i = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0],
            o = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78],
            a = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0],
            s = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
        t.exports = function(t, e, r, f, u, h, c, l) {
            var d, p, y, g, v, b, w, _, m, k = l.bits,
                E = 0,
                S = 0,
                B = 0,
                x = 0,
                A = 0,
                T = 0,
                C = 0,
                R = 0,
                O = 0,
                I = 0,
                U = null,
                M = 0,
                L = new n.Buf16(16),
                D = new n.Buf16(16),
                P = null,
                N = 0;
            for (E = 0; E <= 15; E++) L[E] = 0;
            for (S = 0; S < f; S++) L[e[r + S]]++;
            for (A = k, x = 15; x >= 1 && 0 === L[x]; x--);
            if (A > x && (A = x), 0 === x) return u[h++] = 20971520, u[h++] = 20971520, l.bits = 1, 0;
            for (B = 1; B < x && 0 === L[B]; B++);
            for (A < B && (A = B), R = 1, E = 1; E <= 15; E++)
                if (R <<= 1, (R -= L[E]) < 0) return -1;
            if (R > 0 && (0 === t || 1 !== x)) return -1;
            for (D[1] = 0, E = 1; E < 15; E++) D[E + 1] = D[E] + L[E];
            for (S = 0; S < f; S++) 0 !== e[r + S] && (c[D[e[r + S]]++] = S);
            if (0 === t ? (U = P = c, b = 19) : 1 === t ? (U = i, M -= 257, P = o, N -= 257, b = 256) : (U = a, P = s, b = -1), I = 0, S = 0, E = B, v = h, T = A, C = 0, y = -1, g = (O = 1 << A) - 1, 1 === t && O > 852 || 2 === t && O > 592) return 1;
            for (;;) {
                w = E - C, c[S] < b ? (_ = 0, m = c[S]) : c[S] > b ? (_ = P[N + c[S]], m = U[M + c[S]]) : (_ = 96, m = 0), d = 1 << E - C, B = p = 1 << T;
                do { u[v + (I >> C) + (p -= d)] = w << 24 | _ << 16 | m | 0 } while (0 !== p);
                for (d = 1 << E - 1; I & d;) d >>= 1;
                if (0 !== d ? (I &= d - 1, I += d) : I = 0, S++, 0 == --L[E]) {
                    if (E === x) break;
                    E = e[r + c[S]]
                }
                if (E > A && (I & g) !== y) {
                    for (0 === C && (C = A), v += B, R = 1 << (T = E - C); T + C < x && !((R -= L[T + C]) <= 0);) T++, R <<= 1;
                    if (O += 1 << T, 1 === t && O > 852 || 2 === t && O > 592) return 1;
                    u[y = I & g] = A << 24 | T << 16 | v - h | 0
                }
            }
            return 0 !== I && (u[v + I] = E - C << 24 | 64 << 16 | 0), l.bits = A, 0
        }
    }, function(t, e, r) {
        "use strict";
        var n = r(12),
            i = !0,
            o = !0;
        try { String.fromCharCode.apply(null, [0]) } catch (t) { i = !1 }
        try { String.fromCharCode.apply(null, new Uint8Array(1)) } catch (t) { o = !1 }
        for (var a = new n.Buf8(256), s = 0; s < 256; s++) a[s] = s >= 252 ? 6 : s >= 248 ? 5 : s >= 240 ? 4 : s >= 224 ? 3 : s >= 192 ? 2 : 1;

        function f(t, e) { if (e < 65534 && (t.subarray && o || !t.subarray && i)) return String.fromCharCode.apply(null, n.shrinkBuf(t, e)); for (var r = "", a = 0; a < e; a++) r += String.fromCharCode(t[a]); return r } a[254] = a[254] = 1, e.string2buf = function(t) {
            var e, r, i, o, a, s = t.length,
                f = 0;
            for (o = 0; o < s; o++) 55296 == (64512 & (r = t.charCodeAt(o))) && o + 1 < s && 56320 == (64512 & (i = t.charCodeAt(o + 1))) && (r = 65536 + (r - 55296 << 10) + (i - 56320), o++), f += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
            for (e = new n.Buf8(f), a = 0, o = 0; a < f; o++) 55296 == (64512 & (r = t.charCodeAt(o))) && o + 1 < s && 56320 == (64512 & (i = t.charCodeAt(o + 1))) && (r = 65536 + (r - 55296 << 10) + (i - 56320), o++), r < 128 ? e[a++] = r : r < 2048 ? (e[a++] = 192 | r >>> 6, e[a++] = 128 | 63 & r) : r < 65536 ? (e[a++] = 224 | r >>> 12, e[a++] = 128 | r >>> 6 & 63, e[a++] = 128 | 63 & r) : (e[a++] = 240 | r >>> 18, e[a++] = 128 | r >>> 12 & 63, e[a++] = 128 | r >>> 6 & 63, e[a++] = 128 | 63 & r);
            return e
        }, e.buf2binstring = function(t) { return f(t, t.length) }, e.binstring2buf = function(t) { for (var e = new n.Buf8(t.length), r = 0, i = e.length; r < i; r++) e[r] = t.charCodeAt(r); return e }, e.buf2string = function(t, e) {
            var r, n, i, o, s = e || t.length,
                u = new Array(2 * s);
            for (n = 0, r = 0; r < s;)
                if ((i = t[r++]) < 128) u[n++] = i;
                else if ((o = a[i]) > 4) u[n++] = 65533, r += o - 1;
            else {
                for (i &= 2 === o ? 31 : 3 === o ? 15 : 7; o > 1 && r < s;) i = i << 6 | 63 & t[r++], o--;
                o > 1 ? u[n++] = 65533 : i < 65536 ? u[n++] = i : (i -= 65536, u[n++] = 55296 | i >> 10 & 1023, u[n++] = 56320 | 1023 & i)
            }
            return f(u, n)
        }, e.utf8border = function(t, e) { var r; for ((e = e || t.length) > t.length && (e = t.length), r = e - 1; r >= 0 && 128 == (192 & t[r]);) r--; return r < 0 ? e : 0 === r ? e : r + a[t[r]] > e ? r : e }
    }, function(t, e, r) {
        "use strict";
        t.exports = { Z_NO_FLUSH: 0, Z_PARTIAL_FLUSH: 1, Z_SYNC_FLUSH: 2, Z_FULL_FLUSH: 3, Z_FINISH: 4, Z_BLOCK: 5, Z_TREES: 6, Z_OK: 0, Z_STREAM_END: 1, Z_NEED_DICT: 2, Z_ERRNO: -1, Z_STREAM_ERROR: -2, Z_DATA_ERROR: -3, Z_BUF_ERROR: -5, Z_NO_COMPRESSION: 0, Z_BEST_SPEED: 1, Z_BEST_COMPRESSION: 9, Z_DEFAULT_COMPRESSION: -1, Z_FILTERED: 1, Z_HUFFMAN_ONLY: 2, Z_RLE: 3, Z_FIXED: 4, Z_DEFAULT_STRATEGY: 0, Z_BINARY: 0, Z_TEXT: 1, Z_UNKNOWN: 2, Z_DEFLATED: 8 }
    }, function(t, e, r) {
        "use strict";
        t.exports = { 2: "need dictionary", 1: "stream end", 0: "", "-1": "file error", "-2": "stream error", "-3": "data error", "-4": "insufficient memory", "-5": "buffer error", "-6": "incompatible version" }
    }, function(t, e, r) {
        "use strict";
        t.exports = function() { this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0 }
    }, function(t, e, r) {
        "use strict";
        t.exports = function() { this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1 }
    }]);

    THREE.GLTFLoader = (function() {

        function GLTFLoader(manager) {

            this.manager = (manager !== undefined) ? manager : THREE.DefaultLoadingManager;
            this.dracoLoader = null;

        }

        GLTFLoader.prototype = {

            constructor: GLTFLoader,

            crossOrigin: 'anonymous',

            load: function(url, onLoad, onProgress, onError) {

                var scope = this;

                var resourcePath;

                if (this.resourcePath !== undefined) {

                    resourcePath = this.resourcePath;

                } else if (this.path !== undefined) {

                    resourcePath = this.path;

                } else {

                    resourcePath = THREE.LoaderUtils.extractUrlBase(url);

                }

                // Tells the LoadingManager to track an extra item, which resolves after
                // the model is fully loaded. This means the count of items loaded will
                // be incorrect, but ensures manager.onLoad() does not fire early.
                scope.manager.itemStart(url);

                var _onError = function(e) {

                    if (onError) {

                        onError(e);

                    } else {

                        console.error(e);

                    }

                    scope.manager.itemError(url);
                    scope.manager.itemEnd(url);

                };

                var loader = new THREE.FileLoader(scope.manager);

                loader.setPath(this.path);
                loader.setResponseType('arraybuffer');

                loader.load(url, function(data) {
                    try {


                        scope.parse(egmDecoder.decode(data), resourcePath, function(gltf) {

                            onLoad(gltf);

                            scope.manager.itemEnd(url);

                        }, _onError);

                    } catch (e) {

                        _onError(e);

                    }

                }, onProgress, _onError);

            },

            setCrossOrigin: function(value) {

                this.crossOrigin = value;
                return this;

            },

            setPath: function(value) {

                this.path = value;
                return this;

            },

            setResourcePath: function(value) {

                this.resourcePath = value;
                return this;

            },

            setDRACOLoader: function(dracoLoader) {

                this.dracoLoader = dracoLoader;
                return this;

            },

            parse: function(data, path, onLoad, onError) {

                var content;
                var extensions = {};

                if (typeof data === 'string') {

                    content = data;

                } else {

                    var magic = THREE.LoaderUtils.decodeText(new Uint8Array(data, 0, 4));

                    if (magic === BINARY_EXTENSION_HEADER_MAGIC) {

                        try {

                            extensions[EXTENSIONS.KHR_BINARY_GLTF] = new GLTFBinaryExtension(data);

                        } catch (error) {

                            if (onError) onError(error);
                            return;

                        }

                        content = extensions[EXTENSIONS.KHR_BINARY_GLTF].content;

                    } else {

                        content = THREE.LoaderUtils.decodeText(new Uint8Array(data));

                    }

                }

                var json = JSON.parse(content);

                if (json.asset === undefined || json.asset.version[0] < 2) {

                    if (onError) onError(new Error('THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported. Use LegacyGLTFLoader instead.'));
                    return;

                }

                if (json.extensionsUsed) {

                    for (var i = 0; i < json.extensionsUsed.length; ++i) {

                        var extensionName = json.extensionsUsed[i];
                        var extensionsRequired = json.extensionsRequired || [];

                        switch (extensionName) {

                            case EXTENSIONS.KHR_LIGHTS_PUNCTUAL:
                                extensions[extensionName] = new GLTFLightsExtension(json);
                                break;

                            case EXTENSIONS.KHR_MATERIALS_UNLIT:
                                extensions[extensionName] = new GLTFMaterialsUnlitExtension(json);
                                break;

                            case EXTENSIONS.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS:
                                extensions[extensionName] = new GLTFMaterialsPbrSpecularGlossinessExtension(json);
                                break;

                            case EXTENSIONS.KHR_DRACO_MESH_COMPRESSION:
                                extensions[extensionName] = new GLTFDracoMeshCompressionExtension(json, this.dracoLoader);
                                break;

                            case EXTENSIONS.MSFT_TEXTURE_DDS:
                                extensions[EXTENSIONS.MSFT_TEXTURE_DDS] = new GLTFTextureDDSExtension(json);
                                break;

                            case EXTENSIONS.KHR_TEXTURE_TRANSFORM:
                                extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM] = new GLTFTextureTransformExtension(json);
                                break;

                            default:

                                if (extensionsRequired.indexOf(extensionName) >= 0) {

                                    console.warn('THREE.GLTFLoader: Unknown extension "' + extensionName + '".');

                                }

                        }

                    }

                }

                var parser = new GLTFParser(json, extensions, {

                    path: path || this.resourcePath || '',
                    crossOrigin: this.crossOrigin,
                    manager: this.manager

                });

                parser.parse(function(scene, scenes, cameras, animations, json) {

                    var glTF = {
                        scene: scene,
                        scenes: scenes,
                        cameras: cameras,
                        animations: animations,
                        asset: json.asset,
                        parser: parser,
                        userData: {}
                    };

                    addUnknownExtensionsToUserData(extensions, glTF, json);

                    onLoad(glTF);

                }, onError);

            }

        };

        /* GLTFREGISTRY */

        function GLTFRegistry() {

            var objects = {};

            return {

                get: function(key) {

                    return objects[key];

                },

                add: function(key, object) {

                    objects[key] = object;

                },

                remove: function(key) {

                    delete objects[key];

                },

                removeAll: function() {

                    objects = {};

                }

            };

        }

        /*********************************/
        /********** EXTENSIONS ***********/
        /*********************************/

        var EXTENSIONS = {
            KHR_BINARY_GLTF: 'KHR_binary_glTF',
            KHR_DRACO_MESH_COMPRESSION: 'KHR_draco_mesh_compression',
            KHR_LIGHTS_PUNCTUAL: 'KHR_lights_punctual',
            KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS: 'KHR_materials_pbrSpecularGlossiness',
            KHR_MATERIALS_UNLIT: 'KHR_materials_unlit',
            KHR_TEXTURE_TRANSFORM: 'KHR_texture_transform',
            MSFT_TEXTURE_DDS: 'MSFT_texture_dds'
        };

        /**
         * DDS Texture Extension
         *
         * Specification:
         * https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/MSFT_texture_dds
         *
         */
        function GLTFTextureDDSExtension() {

            if (!THREE.DDSLoader) {

                throw new Error('THREE.GLTFLoader: Attempting to load .dds texture without importing THREE.DDSLoader');

            }

            this.name = EXTENSIONS.MSFT_TEXTURE_DDS;
            this.ddsLoader = new THREE.DDSLoader();

        }

        /**
         * Lights Extension
         *
         * Specification: PENDING
         */
        function GLTFLightsExtension(json) {

            this.name = EXTENSIONS.KHR_LIGHTS_PUNCTUAL;

            var extension = (json.extensions && json.extensions[EXTENSIONS.KHR_LIGHTS_PUNCTUAL]) || {};
            this.lightDefs = extension.lights || [];

        }

        GLTFLightsExtension.prototype.loadLight = function(lightIndex) {

            var lightDef = this.lightDefs[lightIndex];
            var lightNode;

            var color = new THREE.Color(0xffffff);
            if (lightDef.color !== undefined) color.fromArray(lightDef.color);

            var range = lightDef.range !== undefined ? lightDef.range : 0;

            switch (lightDef.type) {

                case 'directional':
                    lightNode = new THREE.DirectionalLight(color);
                    lightNode.target.position.set(0, 0, -1);
                    lightNode.add(lightNode.target);
                    break;

                case 'point':
                    lightNode = new THREE.PointLight(color);
                    lightNode.distance = range;
                    break;

                case 'spot':
                    lightNode = new THREE.SpotLight(color);
                    lightNode.distance = range;
                    // Handle spotlight properties.
                    lightDef.spot = lightDef.spot || {};
                    lightDef.spot.innerConeAngle = lightDef.spot.innerConeAngle !== undefined ? lightDef.spot.innerConeAngle : 0;
                    lightDef.spot.outerConeAngle = lightDef.spot.outerConeAngle !== undefined ? lightDef.spot.outerConeAngle : Math.PI / 4.0;
                    lightNode.angle = lightDef.spot.outerConeAngle;
                    lightNode.penumbra = 1.0 - lightDef.spot.innerConeAngle / lightDef.spot.outerConeAngle;
                    lightNode.target.position.set(0, 0, -1);
                    lightNode.add(lightNode.target);
                    break;

                default:
                    throw new Error('THREE.GLTFLoader: Unexpected light type, "' + lightDef.type + '".');

            }

            lightNode.decay = 2;

            if (lightDef.intensity !== undefined) lightNode.intensity = lightDef.intensity;

            lightNode.name = lightDef.name || ('light_' + lightIndex);

            return Promise.resolve(lightNode);

        };

        /**
         * Unlit Materials Extension (pending)
         *
         * PR: https://github.com/KhronosGroup/glTF/pull/1163
         */
        function GLTFMaterialsUnlitExtension(json) {

            this.name = EXTENSIONS.KHR_MATERIALS_UNLIT;

        }

        GLTFMaterialsUnlitExtension.prototype.getMaterialType = function(material) {

            return THREE.MeshBasicMaterial;

        };

        GLTFMaterialsUnlitExtension.prototype.extendParams = function(materialParams, material, parser) {

            var pending = [];

            materialParams.color = new THREE.Color(1.0, 1.0, 1.0);
            materialParams.opacity = 1.0;

            var metallicRoughness = material.pbrMetallicRoughness;

            if (metallicRoughness) {

                if (Array.isArray(metallicRoughness.baseColorFactor)) {

                    var array = metallicRoughness.baseColorFactor;

                    materialParams.color.fromArray(array);
                    materialParams.opacity = array[3];

                }

                if (metallicRoughness.baseColorTexture !== undefined) {

                    pending.push(parser.assignTexture(materialParams, 'map', metallicRoughness.baseColorTexture));

                }

            }

            return Promise.all(pending);

        };

        /* BINARY EXTENSION */

        var BINARY_EXTENSION_BUFFER_NAME = 'binary_glTF';
        var BINARY_EXTENSION_HEADER_MAGIC = 'glTF';
        var BINARY_EXTENSION_HEADER_LENGTH = 12;
        var BINARY_EXTENSION_CHUNK_TYPES = { JSON: 0x4E4F534A, BIN: 0x004E4942 };

        function GLTFBinaryExtension(data) {

            this.name = EXTENSIONS.KHR_BINARY_GLTF;
            this.content = null;
            this.body = null;

            var headerView = new DataView(data, 0, BINARY_EXTENSION_HEADER_LENGTH);

            this.header = {
                magic: THREE.LoaderUtils.decodeText(new Uint8Array(data.slice(0, 4))),
                version: headerView.getUint32(4, true),
                length: headerView.getUint32(8, true)
            };

            if (this.header.magic !== BINARY_EXTENSION_HEADER_MAGIC) {

                throw new Error('THREE.GLTFLoader: Unsupported glTF-Binary header.');

            } else if (this.header.version < 2.0) {

                throw new Error('THREE.GLTFLoader: Legacy binary file detected. Use LegacyGLTFLoader instead.');

            }

            var chunkView = new DataView(data, BINARY_EXTENSION_HEADER_LENGTH);
            var chunkIndex = 0;

            while (chunkIndex < chunkView.byteLength) {

                var chunkLength = chunkView.getUint32(chunkIndex, true);
                chunkIndex += 4;

                var chunkType = chunkView.getUint32(chunkIndex, true);
                chunkIndex += 4;

                if (chunkType === BINARY_EXTENSION_CHUNK_TYPES.JSON) {

                    var contentArray = new Uint8Array(data, BINARY_EXTENSION_HEADER_LENGTH + chunkIndex, chunkLength);
                    this.content = THREE.LoaderUtils.decodeText(contentArray);

                } else if (chunkType === BINARY_EXTENSION_CHUNK_TYPES.BIN) {

                    var byteOffset = BINARY_EXTENSION_HEADER_LENGTH + chunkIndex;
                    this.body = data.slice(byteOffset, byteOffset + chunkLength);

                }

                // Clients must ignore chunks with unknown types.

                chunkIndex += chunkLength;

            }

            if (this.content === null) {

                throw new Error('THREE.GLTFLoader: JSON content not found.');

            }

        }

        /**
         * DRACO Mesh Compression Extension
         *
         * Specification: https://github.com/KhronosGroup/glTF/pull/874
         */
        function GLTFDracoMeshCompressionExtension(json, dracoLoader) {

            if (!dracoLoader) {

                throw new Error('THREE.GLTFLoader: No DRACOLoader instance provided.');

            }

            this.name = EXTENSIONS.KHR_DRACO_MESH_COMPRESSION;
            this.json = json;
            this.dracoLoader = dracoLoader;
            THREE.DRACOLoader.getDecoderModule();

        }

        GLTFDracoMeshCompressionExtension.prototype.decodePrimitive = function(primitive, parser) {

            var json = this.json;
            var dracoLoader = this.dracoLoader;
            var bufferViewIndex = primitive.extensions[this.name].bufferView;
            var gltfAttributeMap = primitive.extensions[this.name].attributes;
            var threeAttributeMap = {};
            var attributeNormalizedMap = {};
            var attributeTypeMap = {};

            for (var attributeName in gltfAttributeMap) {

                if (!(attributeName in ATTRIBUTES)) continue;

                threeAttributeMap[ATTRIBUTES[attributeName]] = gltfAttributeMap[attributeName];

            }

            for (attributeName in primitive.attributes) {

                if (ATTRIBUTES[attributeName] !== undefined && gltfAttributeMap[attributeName] !== undefined) {

                    var accessorDef = json.accessors[primitive.attributes[attributeName]];
                    var componentType = WEBGL_COMPONENT_TYPES[accessorDef.componentType];

                    attributeTypeMap[ATTRIBUTES[attributeName]] = componentType;
                    attributeNormalizedMap[ATTRIBUTES[attributeName]] = accessorDef.normalized === true;

                }

            }

            return parser.getDependency('bufferView', bufferViewIndex).then(function(bufferView) {

                return new Promise(function(resolve) {

                    dracoLoader.decodeDracoFile(bufferView, function(geometry) {

                        for (var attributeName in geometry.attributes) {

                            var attribute = geometry.attributes[attributeName];
                            var normalized = attributeNormalizedMap[attributeName];

                            if (normalized !== undefined) attribute.normalized = normalized;

                        }

                        resolve(geometry);

                    }, threeAttributeMap, attributeTypeMap);

                });

            });

        };

        /**
         * Texture Transform Extension
         *
         * Specification:
         */
        function GLTFTextureTransformExtension(json) {

            this.name = EXTENSIONS.KHR_TEXTURE_TRANSFORM;

        }

        GLTFTextureTransformExtension.prototype.extendTexture = function(texture, transform) {

            texture = texture.clone();

            if (transform.offset !== undefined) {

                texture.offset.fromArray(transform.offset);

            }

            if (transform.rotation !== undefined) {

                texture.rotation = transform.rotation;

            }

            if (transform.scale !== undefined) {

                texture.repeat.fromArray(transform.scale);

            }

            if (transform.texCoord !== undefined) {

                console.warn('THREE.GLTFLoader: Custom UV sets in "' + this.name + '" extension not yet supported.');

            }

            texture.needsUpdate = true;

            return texture;

        };

        /**
         * Specular-Glossiness Extension
         *
         * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_pbrSpecularGlossiness
         */
        function GLTFMaterialsPbrSpecularGlossinessExtension() {

            return {

                name: EXTENSIONS.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS,

                specularGlossinessParams: [
                    'color',
                    'map',
                    'lightMap',
                    'lightMapIntensity',
                    'aoMap',
                    'aoMapIntensity',
                    'emissive',
                    'emissiveIntensity',
                    'emissiveMap',
                    'bumpMap',
                    'bumpScale',
                    'normalMap',
                    'displacementMap',
                    'displacementScale',
                    'displacementBias',
                    'specularMap',
                    'specular',
                    'glossinessMap',
                    'glossiness',
                    'alphaMap',
                    'envMap',
                    'envMapIntensity',
                    'refractionRatio',
                ],

                getMaterialType: function() {

                    return THREE.ShaderMaterial;

                },

                extendParams: function(params, material, parser) {

                    var pbrSpecularGlossiness = material.extensions[this.name];

                    var shader = THREE.ShaderLib['standard'];

                    var uniforms = THREE.UniformsUtils.clone(shader.uniforms);

                    var specularMapParsFragmentChunk = [
                        '#ifdef USE_SPECULARMAP',
                        '   uniform sampler2D specularMap;',
                        '#endif'
                    ].join('\n');

                    var glossinessMapParsFragmentChunk = [
                        '#ifdef USE_GLOSSINESSMAP',
                        '   uniform sampler2D glossinessMap;',
                        '#endif'
                    ].join('\n');

                    var specularMapFragmentChunk = [
                        'vec3 specularFactor = specular;',
                        '#ifdef USE_SPECULARMAP',
                        '   vec4 texelSpecular = texture2D( specularMap, vUv );',
                        '   texelSpecular = sRGBToLinear( texelSpecular );',
                        '   // reads channel RGB, compatible with a glTF Specular-Glossiness (RGBA) texture',
                        '   specularFactor *= texelSpecular.rgb;',
                        '#endif'
                    ].join('\n');

                    var glossinessMapFragmentChunk = [
                        'float glossinessFactor = glossiness;',
                        '#ifdef USE_GLOSSINESSMAP',
                        '   vec4 texelGlossiness = texture2D( glossinessMap, vUv );',
                        '   // reads channel A, compatible with a glTF Specular-Glossiness (RGBA) texture',
                        '   glossinessFactor *= texelGlossiness.a;',
                        '#endif'
                    ].join('\n');

                    var lightPhysicalFragmentChunk = [
                        'PhysicalMaterial material;',
                        'material.diffuseColor = diffuseColor.rgb;',
                        'material.specularRoughness = clamp( 1.0 - glossinessFactor, 0.04, 1.0 );',
                        'material.specularColor = specularFactor.rgb;',
                    ].join('\n');

                    var fragmentShader = shader.fragmentShader
                        .replace('uniform float roughness;', 'uniform vec3 specular;')
                        .replace('uniform float metalness;', 'uniform float glossiness;')
                        .replace('#include <roughnessmap_pars_fragment>', specularMapParsFragmentChunk)
                        .replace('#include <metalnessmap_pars_fragment>', glossinessMapParsFragmentChunk)
                        .replace('#include <roughnessmap_fragment>', specularMapFragmentChunk)
                        .replace('#include <metalnessmap_fragment>', glossinessMapFragmentChunk)
                        .replace('#include <lights_physical_fragment>', lightPhysicalFragmentChunk);

                    delete uniforms.roughness;
                    delete uniforms.metalness;
                    delete uniforms.roughnessMap;
                    delete uniforms.metalnessMap;

                    uniforms.specular = { value: new THREE.Color().setHex(0x111111) };
                    uniforms.glossiness = { value: 0.5 };
                    uniforms.specularMap = { value: null };
                    uniforms.glossinessMap = { value: null };

                    params.vertexShader = shader.vertexShader;
                    params.fragmentShader = fragmentShader;
                    params.uniforms = uniforms;
                    params.defines = { 'STANDARD': '' };

                    params.color = new THREE.Color(1.0, 1.0, 1.0);
                    params.opacity = 1.0;

                    var pending = [];

                    if (Array.isArray(pbrSpecularGlossiness.diffuseFactor)) {

                        var array = pbrSpecularGlossiness.diffuseFactor;

                        params.color.fromArray(array);
                        params.opacity = array[3];

                    }

                    if (pbrSpecularGlossiness.diffuseTexture !== undefined) {

                        pending.push(parser.assignTexture(params, 'map', pbrSpecularGlossiness.diffuseTexture));

                    }

                    params.emissive = new THREE.Color(0.0, 0.0, 0.0);
                    params.glossiness = pbrSpecularGlossiness.glossinessFactor !== undefined ? pbrSpecularGlossiness.glossinessFactor : 1.0;
                    params.specular = new THREE.Color(1.0, 1.0, 1.0);

                    if (Array.isArray(pbrSpecularGlossiness.specularFactor)) {

                        params.specular.fromArray(pbrSpecularGlossiness.specularFactor);

                    }

                    if (pbrSpecularGlossiness.specularGlossinessTexture !== undefined) {

                        var specGlossMapDef = pbrSpecularGlossiness.specularGlossinessTexture;
                        pending.push(parser.assignTexture(params, 'glossinessMap', specGlossMapDef));
                        pending.push(parser.assignTexture(params, 'specularMap', specGlossMapDef));

                    }

                    return Promise.all(pending);

                },

                createMaterial: function(params) {

                    // setup material properties based on MeshStandardMaterial for Specular-Glossiness

                    var material = new THREE.ShaderMaterial({
                        defines: params.defines,
                        vertexShader: params.vertexShader,
                        fragmentShader: params.fragmentShader,
                        uniforms: params.uniforms,
                        fog: true,
                        lights: true,
                        opacity: params.opacity,
                        transparent: params.transparent
                    });

                    material.isGLTFSpecularGlossinessMaterial = true;

                    material.color = params.color;

                    material.map = params.map === undefined ? null : params.map;

                    material.lightMap = null;
                    material.lightMapIntensity = 1.0;

                    material.aoMap = params.aoMap === undefined ? null : params.aoMap;
                    material.aoMapIntensity = 1.0;

                    material.emissive = params.emissive;
                    material.emissiveIntensity = 1.0;
                    material.emissiveMap = params.emissiveMap === undefined ? null : params.emissiveMap;

                    material.bumpMap = params.bumpMap === undefined ? null : params.bumpMap;
                    material.bumpScale = 1;

                    material.normalMap = params.normalMap === undefined ? null : params.normalMap;
                    if (params.normalScale) material.normalScale = params.normalScale;

                    material.displacementMap = null;
                    material.displacementScale = 1;
                    material.displacementBias = 0;

                    material.specularMap = params.specularMap === undefined ? null : params.specularMap;
                    material.specular = params.specular;

                    material.glossinessMap = params.glossinessMap === undefined ? null : params.glossinessMap;
                    material.glossiness = params.glossiness;

                    material.alphaMap = null;

                    material.envMap = params.envMap === undefined ? null : params.envMap;
                    material.envMapIntensity = 1.0;

                    material.refractionRatio = 0.98;

                    material.extensions.derivatives = true;

                    return material;

                },

                /**
                 * Clones a GLTFSpecularGlossinessMaterial instance. The ShaderMaterial.copy() method can
                 * copy only properties it knows about or inherits, and misses many properties that would
                 * normally be defined by MeshStandardMaterial.
                 *
                 * This method allows GLTFSpecularGlossinessMaterials to be cloned in the process of
                 * loading a glTF model, but cloning later (e.g. by the user) would require these changes
                 * AND also updating `.onBeforeRender` on the parent mesh.
                 *
                 * @param  {THREE.ShaderMaterial} source
                 * @return {THREE.ShaderMaterial}
                 */
                cloneMaterial: function(source) {

                    var target = source.clone();

                    target.isGLTFSpecularGlossinessMaterial = true;

                    var params = this.specularGlossinessParams;

                    for (var i = 0, il = params.length; i < il; i++) {

                        target[params[i]] = source[params[i]];

                    }

                    return target;

                },

                // Here's based on refreshUniformsCommon() and refreshUniformsStandard() in WebGLRenderer.
                refreshUniforms: function(renderer, scene, camera, geometry, material, group) {

                    if (material.isGLTFSpecularGlossinessMaterial !== true) {

                        return;

                    }

                    var uniforms = material.uniforms;
                    var defines = material.defines;

                    uniforms.opacity.value = material.opacity;

                    uniforms.diffuse.value.copy(material.color);
                    uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);

                    uniforms.map.value = material.map;
                    uniforms.specularMap.value = material.specularMap;
                    uniforms.alphaMap.value = material.alphaMap;

                    uniforms.lightMap.value = material.lightMap;
                    uniforms.lightMapIntensity.value = material.lightMapIntensity;

                    uniforms.aoMap.value = material.aoMap;
                    uniforms.aoMapIntensity.value = material.aoMapIntensity;

                    // uv repeat and offset setting priorities
                    // 1. color map
                    // 2. specular map
                    // 3. normal map
                    // 4. bump map
                    // 5. alpha map
                    // 6. emissive map

                    var uvScaleMap;

                    if (material.map) {

                        uvScaleMap = material.map;

                    } else if (material.specularMap) {

                        uvScaleMap = material.specularMap;

                    } else if (material.displacementMap) {

                        uvScaleMap = material.displacementMap;

                    } else if (material.normalMap) {

                        uvScaleMap = material.normalMap;

                    } else if (material.bumpMap) {

                        uvScaleMap = material.bumpMap;

                    } else if (material.glossinessMap) {

                        uvScaleMap = material.glossinessMap;

                    } else if (material.alphaMap) {

                        uvScaleMap = material.alphaMap;

                    } else if (material.emissiveMap) {

                        uvScaleMap = material.emissiveMap;

                    }

                    if (uvScaleMap !== undefined) {

                        // backwards compatibility
                        if (uvScaleMap.isWebGLRenderTarget) {

                            uvScaleMap = uvScaleMap.texture;

                        }

                        if (uvScaleMap.matrixAutoUpdate === true) {

                            uvScaleMap.updateMatrix();

                        }

                        uniforms.uvTransform.value.copy(uvScaleMap.matrix);

                    }

                    if (material.envMap) {

                        uniforms.envMap.value = material.envMap;
                        uniforms.envMapIntensity.value = material.envMapIntensity;

                        // don't flip CubeTexture envMaps, flip everything else:
                        //  WebGLRenderTargetCube will be flipped for backwards compatibility
                        //  WebGLRenderTargetCube.texture will be flipped because it's a Texture and NOT a CubeTexture
                        // this check must be handled differently, or removed entirely, if WebGLRenderTargetCube uses a CubeTexture in the future
                        uniforms.flipEnvMap.value = material.envMap.isCubeTexture ? -1 : 1;

                        uniforms.reflectivity.value = material.reflectivity;
                        uniforms.refractionRatio.value = material.refractionRatio;

                        uniforms.maxMipLevel.value = renderer.properties.get(material.envMap).__maxMipLevel;
                    }

                    uniforms.specular.value.copy(material.specular);
                    uniforms.glossiness.value = material.glossiness;

                    uniforms.glossinessMap.value = material.glossinessMap;

                    uniforms.emissiveMap.value = material.emissiveMap;
                    uniforms.bumpMap.value = material.bumpMap;
                    uniforms.normalMap.value = material.normalMap;

                    uniforms.displacementMap.value = material.displacementMap;
                    uniforms.displacementScale.value = material.displacementScale;
                    uniforms.displacementBias.value = material.displacementBias;

                    if (uniforms.glossinessMap.value !== null && defines.USE_GLOSSINESSMAP === undefined) {

                        defines.USE_GLOSSINESSMAP = '';
                        // set USE_ROUGHNESSMAP to enable vUv
                        defines.USE_ROUGHNESSMAP = '';

                    }

                    if (uniforms.glossinessMap.value === null && defines.USE_GLOSSINESSMAP !== undefined) {

                        delete defines.USE_GLOSSINESSMAP;
                        delete defines.USE_ROUGHNESSMAP;

                    }

                }

            };

        }

        /*********************************/
        /********** INTERPOLATION ********/
        /*********************************/

        // Spline Interpolation
        // Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#appendix-c-spline-interpolation
        function GLTFCubicSplineInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {

            THREE.Interpolant.call(this, parameterPositions, sampleValues, sampleSize, resultBuffer);

        }

        GLTFCubicSplineInterpolant.prototype = Object.create(THREE.Interpolant.prototype);
        GLTFCubicSplineInterpolant.prototype.constructor = GLTFCubicSplineInterpolant;

        GLTFCubicSplineInterpolant.prototype.copySampleValue_ = function(index) {

            // Copies a sample value to the result buffer. See description of glTF
            // CUBICSPLINE values layout in interpolate_() function below.

            var result = this.resultBuffer,
                values = this.sampleValues,
                valueSize = this.valueSize,
                offset = index * valueSize * 3 + valueSize;

            for (var i = 0; i !== valueSize; i++) {

                result[i] = values[offset + i];

            }

            return result;

        };

        GLTFCubicSplineInterpolant.prototype.beforeStart_ = GLTFCubicSplineInterpolant.prototype.copySampleValue_;

        GLTFCubicSplineInterpolant.prototype.afterEnd_ = GLTFCubicSplineInterpolant.prototype.copySampleValue_;

        GLTFCubicSplineInterpolant.prototype.interpolate_ = function(i1, t0, t, t1) {

            var result = this.resultBuffer;
            var values = this.sampleValues;
            var stride = this.valueSize;

            var stride2 = stride * 2;
            var stride3 = stride * 3;

            var td = t1 - t0;

            var p = (t - t0) / td;
            var pp = p * p;
            var ppp = pp * p;

            var offset1 = i1 * stride3;
            var offset0 = offset1 - stride3;

            var s2 = -2 * ppp + 3 * pp;
            var s3 = ppp - pp;
            var s0 = 1 - s2;
            var s1 = s3 - pp + p;

            // Layout of keyframe output values for CUBICSPLINE animations:
            //   [ inTangent_1, splineVertex_1, outTangent_1, inTangent_2, splineVertex_2, ... ]
            for (var i = 0; i !== stride; i++) {

                var p0 = values[offset0 + i + stride]; // splineVertex_k
                var m0 = values[offset0 + i + stride2] * td; // outTangent_k * (t_k+1 - t_k)
                var p1 = values[offset1 + i + stride]; // splineVertex_k+1
                var m1 = values[offset1 + i] * td; // inTangent_k+1 * (t_k+1 - t_k)

                result[i] = s0 * p0 + s1 * m0 + s2 * p1 + s3 * m1;

            }

            return result;

        };

        /*********************************/
        /********** INTERNALS ************/
        /*********************************/

        /* CONSTANTS */

        var WEBGL_CONSTANTS = {
            FLOAT: 5126,
            //FLOAT_MAT2: 35674,
            FLOAT_MAT3: 35675,
            FLOAT_MAT4: 35676,
            FLOAT_VEC2: 35664,
            FLOAT_VEC3: 35665,
            FLOAT_VEC4: 35666,
            LINEAR: 9729,
            REPEAT: 10497,
            SAMPLER_2D: 35678,
            POINTS: 0,
            LINES: 1,
            LINE_LOOP: 2,
            LINE_STRIP: 3,
            TRIANGLES: 4,
            TRIANGLE_STRIP: 5,
            TRIANGLE_FAN: 6,
            UNSIGNED_BYTE: 5121,
            UNSIGNED_SHORT: 5123
        };

        var WEBGL_TYPE = {
            5126: Number,
            //35674: THREE.Matrix2,
            35675: THREE.Matrix3,
            35676: THREE.Matrix4,
            35664: THREE.Vector2,
            35665: THREE.Vector3,
            35666: THREE.Vector4,
            35678: THREE.Texture
        };

        var WEBGL_COMPONENT_TYPES = {
            5120: Int8Array,
            5121: Uint8Array,
            5122: Int16Array,
            5123: Uint16Array,
            5125: Uint32Array,
            5126: Float32Array
        };

        var WEBGL_FILTERS = {
            9728: THREE.NearestFilter,
            9729: THREE.LinearFilter,
            9984: THREE.NearestMipMapNearestFilter,
            9985: THREE.LinearMipMapNearestFilter,
            9986: THREE.NearestMipMapLinearFilter,
            9987: THREE.LinearMipMapLinearFilter
        };

        var WEBGL_WRAPPINGS = {
            33071: THREE.ClampToEdgeWrapping,
            33648: THREE.MirroredRepeatWrapping,
            10497: THREE.RepeatWrapping
        };

        var WEBGL_SIDES = {
            1028: THREE.BackSide, // Culling front
            1029: THREE.FrontSide // Culling back
            //1032: THREE.NoSide   // Culling front and back, what to do?
        };

        var WEBGL_DEPTH_FUNCS = {
            512: THREE.NeverDepth,
            513: THREE.LessDepth,
            514: THREE.EqualDepth,
            515: THREE.LessEqualDepth,
            516: THREE.GreaterEqualDepth,
            517: THREE.NotEqualDepth,
            518: THREE.GreaterEqualDepth,
            519: THREE.AlwaysDepth
        };

        var WEBGL_BLEND_EQUATIONS = {
            32774: THREE.AddEquation,
            32778: THREE.SubtractEquation,
            32779: THREE.ReverseSubtractEquation
        };

        var WEBGL_BLEND_FUNCS = {
            0: THREE.ZeroFactor,
            1: THREE.OneFactor,
            768: THREE.SrcColorFactor,
            769: THREE.OneMinusSrcColorFactor,
            770: THREE.SrcAlphaFactor,
            771: THREE.OneMinusSrcAlphaFactor,
            772: THREE.DstAlphaFactor,
            773: THREE.OneMinusDstAlphaFactor,
            774: THREE.DstColorFactor,
            775: THREE.OneMinusDstColorFactor,
            776: THREE.SrcAlphaSaturateFactor
            // The followings are not supported by Three.js yet
            //32769: CONSTANT_COLOR,
            //32770: ONE_MINUS_CONSTANT_COLOR,
            //32771: CONSTANT_ALPHA,
            //32772: ONE_MINUS_CONSTANT_COLOR
        };

        var WEBGL_TYPE_SIZES = {
            'SCALAR': 1,
            'VEC2': 2,
            'VEC3': 3,
            'VEC4': 4,
            'MAT2': 4,
            'MAT3': 9,
            'MAT4': 16
        };

        var ATTRIBUTES = {
            POSITION: 'position',
            NORMAL: 'normal',
            TEXCOORD_0: 'uv',
            TEXCOORD_1: 'uv2',
            COLOR_0: 'color',
            WEIGHTS_0: 'skinWeight',
            JOINTS_0: 'skinIndex',
        };

        var PATH_PROPERTIES = {
            scale: 'scale',
            translation: 'position',
            rotation: 'quaternion',
            weights: 'morphTargetInfluences'
        };

        var INTERPOLATION = {
            CUBICSPLINE: THREE.InterpolateSmooth, // We use custom interpolation GLTFCubicSplineInterpolation for CUBICSPLINE.
            // KeyframeTrack.optimize() can't handle glTF Cubic Spline output values layout,
            // using THREE.InterpolateSmooth for KeyframeTrack instantiation to prevent optimization.
            // See KeyframeTrack.optimize() for the detail.
            LINEAR: THREE.InterpolateLinear,
            STEP: THREE.InterpolateDiscrete
        };

        var STATES_ENABLES = {
            2884: 'CULL_FACE',
            2929: 'DEPTH_TEST',
            3042: 'BLEND',
            3089: 'SCISSOR_TEST',
            32823: 'POLYGON_OFFSET_FILL',
            32926: 'SAMPLE_ALPHA_TO_COVERAGE'
        };

        var ALPHA_MODES = {
            OPAQUE: 'OPAQUE',
            MASK: 'MASK',
            BLEND: 'BLEND'
        };

        var MIME_TYPE_FORMATS = {
            'image/png': THREE.RGBAFormat,
            'image/jpeg': THREE.RGBFormat
        };

        /* UTILITY FUNCTIONS */

        function resolveURL(url, path) {

            // Invalid URL
            if (typeof url !== 'string' || url === '') return '';

            // Absolute URL http://,https://,//
            if (/^(https?:)?\/\//i.test(url)) return url;

            // Data URI
            if (/^data:.*,.*$/i.test(url)) return url;

            // Blob URL
            if (/^blob:.*$/i.test(url)) return url;

            // Relative URL
            return path + url;

        }

        /**
         * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#default-material
         */
        function createDefaultMaterial() {

            return new THREE.MeshStandardMaterial({
                color: 0xFFFFFF,
                emissive: 0x000000,
                metalness: 1,
                roughness: 1,
                transparent: false,
                depthTest: true,
                side: THREE.FrontSide
            });

        }

        function addUnknownExtensionsToUserData(knownExtensions, object, objectDef) {

            // Add unknown glTF extensions to an object's userData.

            for (var name in objectDef.extensions) {

                if (knownExtensions[name] === undefined) {

                    object.userData.gltfExtensions = object.userData.gltfExtensions || {};
                    object.userData.gltfExtensions[name] = objectDef.extensions[name];

                }

            }

        }

        /**
         * @param {THREE.Object3D|THREE.Material|THREE.BufferGeometry} object
         * @param {GLTF.definition} gltfDef
         */
        function assignExtrasToUserData(object, gltfDef) {

            if (gltfDef.extras !== undefined) {

                if (typeof gltfDef.extras === 'object') {

                    object.userData = gltfDef.extras;

                } else {

                    console.warn('THREE.GLTFLoader: Ignoring primitive type .extras, ' + gltfDef.extras);

                }

            }

        }

        /**
         * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#morph-targets
         *
         * @param {THREE.BufferGeometry} geometry
         * @param {Array<GLTF.Target>} targets
         * @param {GLTFParser} parser
         * @return {Promise<THREE.BufferGeometry>}
         */
        function addMorphTargets(geometry, targets, parser) {

            var hasMorphPosition = false;
            var hasMorphNormal = false;

            for (var i = 0, il = targets.length; i < il; i++) {

                var target = targets[i];

                if (target.POSITION !== undefined) hasMorphPosition = true;
                if (target.NORMAL !== undefined) hasMorphNormal = true;

                if (hasMorphPosition && hasMorphNormal) break;

            }

            if (!hasMorphPosition && !hasMorphNormal) return Promise.resolve(geometry);

            var pendingPositionAccessors = [];
            var pendingNormalAccessors = [];

            for (var i = 0, il = targets.length; i < il; i++) {

                var target = targets[i];

                if (hasMorphPosition) {

                    // TODO: Error-prone use of a callback inside a loop.
                    var accessor = target.POSITION !== undefined ?
                        parser.getDependency('accessor', target.POSITION)
                        .then(function(accessor) {
                            // Cloning not to pollute original accessor below
                            return cloneBufferAttribute(accessor);
                        }) :
                        geometry.attributes.position;

                    pendingPositionAccessors.push(accessor);

                }

                if (hasMorphNormal) {

                    // TODO: Error-prone use of a callback inside a loop.
                    var accessor = target.NORMAL !== undefined ?
                        parser.getDependency('accessor', target.NORMAL)
                        .then(function(accessor) {
                            return cloneBufferAttribute(accessor);
                        }) :
                        geometry.attributes.normal;

                    pendingNormalAccessors.push(accessor);

                }

            }

            return Promise.all([
                Promise.all(pendingPositionAccessors),
                Promise.all(pendingNormalAccessors)
            ]).then(function(accessors) {

                var morphPositions = accessors[0];
                var morphNormals = accessors[1];

                for (var i = 0, il = targets.length; i < il; i++) {

                    var target = targets[i];
                    var attributeName = 'morphTarget' + i;

                    if (hasMorphPosition) {

                        // Three.js morph position is absolute value. The formula is
                        //   basePosition
                        //     + weight0 * ( morphPosition0 - basePosition )
                        //     + weight1 * ( morphPosition1 - basePosition )
                        //     ...
                        // while the glTF one is relative
                        //   basePosition
                        //     + weight0 * glTFmorphPosition0
                        //     + weight1 * glTFmorphPosition1
                        //     ...
                        // then we need to convert from relative to absolute here.

                        if (target.POSITION !== undefined) {

                            var positionAttribute = morphPositions[i];
                            positionAttribute.name = attributeName;

                            var position = geometry.attributes.position;

                            for (var j = 0, jl = positionAttribute.count; j < jl; j++) {

                                positionAttribute.setXYZ(
                                    j,
                                    positionAttribute.getX(j) + position.getX(j),
                                    positionAttribute.getY(j) + position.getY(j),
                                    positionAttribute.getZ(j) + position.getZ(j)
                                );

                            }

                        }

                    }

                    if (hasMorphNormal) {

                        // see target.POSITION's comment

                        if (target.NORMAL !== undefined) {

                            var normalAttribute = morphNormals[i];
                            normalAttribute.name = attributeName;

                            var normal = geometry.attributes.normal;

                            for (var j = 0, jl = normalAttribute.count; j < jl; j++) {

                                normalAttribute.setXYZ(
                                    j,
                                    normalAttribute.getX(j) + normal.getX(j),
                                    normalAttribute.getY(j) + normal.getY(j),
                                    normalAttribute.getZ(j) + normal.getZ(j)
                                );

                            }

                        }

                    }

                }

                if (hasMorphPosition) geometry.morphAttributes.position = morphPositions;
                if (hasMorphNormal) geometry.morphAttributes.normal = morphNormals;

                return geometry;

            });

        }

        /**
         * @param {THREE.Mesh} mesh
         * @param {GLTF.Mesh} meshDef
         */
        function updateMorphTargets(mesh, meshDef) {

            mesh.updateMorphTargets();

            if (meshDef.weights !== undefined) {

                for (var i = 0, il = meshDef.weights.length; i < il; i++) {

                    mesh.morphTargetInfluences[i] = meshDef.weights[i];

                }

            }

            // .extras has user-defined data, so check that .extras.targetNames is an array.
            if (meshDef.extras && Array.isArray(meshDef.extras.targetNames)) {

                var targetNames = meshDef.extras.targetNames;

                if (mesh.morphTargetInfluences.length === targetNames.length) {

                    mesh.morphTargetDictionary = {};

                    for (var i = 0, il = targetNames.length; i < il; i++) {

                        mesh.morphTargetDictionary[targetNames[i]] = i;

                    }

                } else {

                    console.warn('THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.');

                }

            }

        }

        function isPrimitiveEqual(a, b) {

            var dracoExtA = a.extensions ? a.extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION] : undefined;
            var dracoExtB = b.extensions ? b.extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION] : undefined;

            if (dracoExtA && dracoExtB) {

                if (dracoExtA.bufferView !== dracoExtB.bufferView) return false;

                return isObjectEqual(dracoExtA.attributes, dracoExtB.attributes);

            }

            if (a.indices !== b.indices) {

                return false;

            }

            return isObjectEqual(a.attributes, b.attributes);

        }

        function isObjectEqual(a, b) {

            if (Object.keys(a).length !== Object.keys(b).length) return false;

            for (var key in a) {

                if (a[key] !== b[key]) return false;

            }

            return true;

        }

        function isArrayEqual(a, b) {

            if (a.length !== b.length) return false;

            for (var i = 0, il = a.length; i < il; i++) {

                if (a[i] !== b[i]) return false;

            }

            return true;

        }

        function getCachedGeometry(cache, newPrimitive) {

            for (var i = 0, il = cache.length; i < il; i++) {

                var cached = cache[i];

                if (isPrimitiveEqual(cached.primitive, newPrimitive)) return cached.promise;

            }

            return null;

        }

        function getCachedCombinedGeometry(cache, geometries) {

            for (var i = 0, il = cache.length; i < il; i++) {

                var cached = cache[i];

                if (isArrayEqual(geometries, cached.baseGeometries)) return cached.geometry;

            }

            return null;

        }

        function getCachedMultiPassGeometry(cache, geometry, primitives) {

            for (var i = 0, il = cache.length; i < il; i++) {

                var cached = cache[i];

                if (geometry === cached.baseGeometry && isArrayEqual(primitives, cached.primitives)) return cached.geometry;

            }

            return null;

        }

        function cloneBufferAttribute(attribute) {

            if (attribute.isInterleavedBufferAttribute) {

                var count = attribute.count;
                var itemSize = attribute.itemSize;
                var array = attribute.array.slice(0, count * itemSize);

                for (var i = 0; i < count; ++i) {

                    array[i] = attribute.getX(i);
                    if (itemSize >= 2) array[i + 1] = attribute.getY(i);
                    if (itemSize >= 3) array[i + 2] = attribute.getZ(i);
                    if (itemSize >= 4) array[i + 3] = attribute.getW(i);

                }

                return new THREE.BufferAttribute(array, itemSize, attribute.normalized);

            }

            return attribute.clone();

        }

        /**
         * Checks if we can build a single Mesh with MultiMaterial from multiple primitives.
         * Returns true if all primitives use the same attributes/morphAttributes/mode
         * and also have index. Otherwise returns false.
         *
         * @param {Array<GLTF.Primitive>} primitives
         * @return {Boolean}
         */
        function isMultiPassGeometry(primitives) {

            if (primitives.length < 2) return false;

            var primitive0 = primitives[0];
            var targets0 = primitive0.targets || [];

            if (primitive0.indices === undefined) return false;

            for (var i = 1, il = primitives.length; i < il; i++) {

                var primitive = primitives[i];

                if (primitive0.mode !== primitive.mode) return false;
                if (primitive.indices === undefined) return false;
                if (primitive.extensions && primitive.extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION]) return false;
                if (!isObjectEqual(primitive0.attributes, primitive.attributes)) return false;

                var targets = primitive.targets || [];

                if (targets0.length !== targets.length) return false;

                for (var j = 0, jl = targets0.length; j < jl; j++) {

                    if (!isObjectEqual(targets0[j], targets[j])) return false;

                }

            }

            return true;

        }

        /* GLTF PARSER */

        function GLTFParser(json, extensions, options) {

            this.json = json || {};
            this.extensions = extensions || {};
            this.options = options || {};

            // loader object cache
            this.cache = new GLTFRegistry();

            // BufferGeometry caching
            this.primitiveCache = [];
            this.multiplePrimitivesCache = [];
            this.multiPassGeometryCache = [];

            this.textureLoader = new THREE.TextureLoader(this.options.manager);
            this.textureLoader.setCrossOrigin(this.options.crossOrigin);

            this.fileLoader = new THREE.FileLoader(this.options.manager);
            this.fileLoader.setResponseType('arraybuffer');

        }

        GLTFParser.prototype.parse = function(onLoad, onError) {

            var json = this.json;

            // Clear the loader cache
            this.cache.removeAll();

            // Mark the special nodes/meshes in json for efficient parse
            this.markDefs();

            // Fire the callback on complete
            this.getMultiDependencies([

                'scene',
                'animation',
                'camera'

            ]).then(function(dependencies) {

                var scenes = dependencies.scenes || [];
                var scene = scenes[json.scene || 0];
                var animations = dependencies.animations || [];
                var cameras = dependencies.cameras || [];

                onLoad(scene, scenes, cameras, animations, json);

            }).catch(onError);

        };

        /**
         * Marks the special nodes/meshes in json for efficient parse.
         */
        GLTFParser.prototype.markDefs = function() {

            var nodeDefs = this.json.nodes || [];
            var skinDefs = this.json.skins || [];
            var meshDefs = this.json.meshes || [];

            var meshReferences = {};
            var meshUses = {};

            // Nothing in the node definition indicates whether it is a Bone or an
            // Object3D. Use the skins' joint references to mark bones.
            for (var skinIndex = 0, skinLength = skinDefs.length; skinIndex < skinLength; skinIndex++) {

                var joints = skinDefs[skinIndex].joints;

                for (var i = 0, il = joints.length; i < il; i++) {

                    nodeDefs[joints[i]].isBone = true;

                }

            }

            // Meshes can (and should) be reused by multiple nodes in a glTF asset. To
            // avoid having more than one THREE.Mesh with the same name, count
            // references and rename instances below.
            //
            // Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
            for (var nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++) {

                var nodeDef = nodeDefs[nodeIndex];

                if (nodeDef.mesh !== undefined) {

                    if (meshReferences[nodeDef.mesh] === undefined) {

                        meshReferences[nodeDef.mesh] = meshUses[nodeDef.mesh] = 0;

                    }

                    meshReferences[nodeDef.mesh]++;

                    // Nothing in the mesh definition indicates whether it is
                    // a SkinnedMesh or Mesh. Use the node's mesh reference
                    // to mark SkinnedMesh if node has skin.
                    if (nodeDef.skin !== undefined) {

                        meshDefs[nodeDef.mesh].isSkinnedMesh = true;

                    }

                }

            }

            this.json.meshReferences = meshReferences;
            this.json.meshUses = meshUses;

        };

        /**
         * Requests the specified dependency asynchronously, with caching.
         * @param {string} type
         * @param {number} index
         * @return {Promise<THREE.Object3D|THREE.Material|THREE.Texture|THREE.AnimationClip|ArrayBuffer|Object>}
         */
        GLTFParser.prototype.getDependency = function(type, index) {

            var cacheKey = type + ':' + index;
            var dependency = this.cache.get(cacheKey);

            if (!dependency) {

                switch (type) {

                    case 'scene':
                        dependency = this.loadScene(index);
                        break;

                    case 'node':
                        dependency = this.loadNode(index);
                        break;

                    case 'mesh':
                        dependency = this.loadMesh(index);
                        break;

                    case 'accessor':
                        dependency = this.loadAccessor(index);
                        break;

                    case 'bufferView':
                        dependency = this.loadBufferView(index);
                        break;

                    case 'buffer':
                        dependency = this.loadBuffer(index);
                        break;

                    case 'material':
                        dependency = this.loadMaterial(index);
                        break;

                    case 'texture':
                        dependency = this.loadTexture(index);
                        break;

                    case 'skin':
                        dependency = this.loadSkin(index);
                        break;

                    case 'animation':
                        dependency = this.loadAnimation(index);
                        break;

                    case 'camera':
                        dependency = this.loadCamera(index);
                        break;

                    case 'light':
                        dependency = this.extensions[EXTENSIONS.KHR_LIGHTS_PUNCTUAL].loadLight(index);
                        break

                    default:
                        throw new Error('Unknown type: ' + type);

                }

                this.cache.add(cacheKey, dependency);

            }

            return dependency;

        };

        /**
         * Requests all dependencies of the specified type asynchronously, with caching.
         * @param {string} type
         * @return {Promise<Array<Object>>}
         */
        GLTFParser.prototype.getDependencies = function(type) {

            var dependencies = this.cache.get(type);

            if (!dependencies) {

                var parser = this;
                var defs = this.json[type + (type === 'mesh' ? 'es' : 's')] || [];

                dependencies = Promise.all(defs.map(function(def, index) {

                    return parser.getDependency(type, index);

                }));

                this.cache.add(type, dependencies);

            }

            return dependencies;

        };

        /**
         * Requests all multiple dependencies of the specified types asynchronously, with caching.
         * @param {Array<string>} types
         * @return {Promise<Object<Array<Object>>>}
         */
        GLTFParser.prototype.getMultiDependencies = function(types) {

            var results = {};
            var pending = [];

            for (var i = 0, il = types.length; i < il; i++) {

                var type = types[i];
                var value = this.getDependencies(type);

                // TODO: Error-prone use of a callback inside a loop.
                value = value.then(function(key, value) {

                    results[key] = value;

                }.bind(this, type + (type === 'mesh' ? 'es' : 's')));

                pending.push(value);

            }

            return Promise.all(pending).then(function() {

                return results;

            });

        };

        /**
         * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
         * @param {number} bufferIndex
         * @return {Promise<ArrayBuffer>}
         */
        GLTFParser.prototype.loadBuffer = function(bufferIndex) {

            var bufferDef = this.json.buffers[bufferIndex];
            var loader = this.fileLoader;

            if (bufferDef.type && bufferDef.type !== 'arraybuffer') {

                throw new Error('THREE.GLTFLoader: ' + bufferDef.type + ' buffer type is not supported.');

            }

            // If present, GLB container is required to be the first buffer.
            if (bufferDef.uri === undefined && bufferIndex === 0) {

                return Promise.resolve(this.extensions[EXTENSIONS.KHR_BINARY_GLTF].body);

            }

            var options = this.options;

            return new Promise(function(resolve, reject) {

                loader.load(resolveURL(bufferDef.uri, options.path), resolve, undefined, function() {

                    reject(new Error('THREE.GLTFLoader: Failed to load buffer "' + bufferDef.uri + '".'));

                });

            });

        };

        /**
         * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
         * @param {number} bufferViewIndex
         * @return {Promise<ArrayBuffer>}
         */
        GLTFParser.prototype.loadBufferView = function(bufferViewIndex) {

            var bufferViewDef = this.json.bufferViews[bufferViewIndex];

            return this.getDependency('buffer', bufferViewDef.buffer).then(function(buffer) {

                var byteLength = bufferViewDef.byteLength || 0;
                var byteOffset = bufferViewDef.byteOffset || 0;
                return buffer.slice(byteOffset, byteOffset + byteLength);

            });

        };

        /**
         * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
         * @param {number} accessorIndex
         * @return {Promise<THREE.BufferAttribute|THREE.InterleavedBufferAttribute>}
         */
        GLTFParser.prototype.loadAccessor = function(accessorIndex) {

            var parser = this;
            var json = this.json;

            var accessorDef = this.json.accessors[accessorIndex];

            if (accessorDef.bufferView === undefined && accessorDef.sparse === undefined) {

                // Ignore empty accessors, which may be used to declare runtime
                // information about attributes coming from another source (e.g. Draco
                // compression extension).
                return Promise.resolve(null);

            }

            var pendingBufferViews = [];

            if (accessorDef.bufferView !== undefined) {

                pendingBufferViews.push(this.getDependency('bufferView', accessorDef.bufferView));

            } else {

                pendingBufferViews.push(null);

            }

            if (accessorDef.sparse !== undefined) {

                pendingBufferViews.push(this.getDependency('bufferView', accessorDef.sparse.indices.bufferView));
                pendingBufferViews.push(this.getDependency('bufferView', accessorDef.sparse.values.bufferView));

            }

            return Promise.all(pendingBufferViews).then(function(bufferViews) {

                var bufferView = bufferViews[0];

                var itemSize = WEBGL_TYPE_SIZES[accessorDef.type];
                var TypedArray = WEBGL_COMPONENT_TYPES[accessorDef.componentType];

                // For VEC3: itemSize is 3, elementBytes is 4, itemBytes is 12.
                var elementBytes = TypedArray.BYTES_PER_ELEMENT;
                var itemBytes = elementBytes * itemSize;
                var byteOffset = accessorDef.byteOffset || 0;
                var byteStride = accessorDef.bufferView !== undefined ? json.bufferViews[accessorDef.bufferView].byteStride : undefined;
                var normalized = accessorDef.normalized === true;
                var array, bufferAttribute;

                // The buffer is not interleaved if the stride is the item size in bytes.
                if (byteStride && byteStride !== itemBytes) {

                    var ibCacheKey = 'InterleavedBuffer:' + accessorDef.bufferView + ':' + accessorDef.componentType;
                    var ib = parser.cache.get(ibCacheKey);

                    if (!ib) {

                        // Use the full buffer if it's interleaved.
                        array = new TypedArray(bufferView);

                        // Integer parameters to IB/IBA are in array elements, not bytes.
                        ib = new THREE.InterleavedBuffer(array, byteStride / elementBytes);

                        parser.cache.add(ibCacheKey, ib);

                    }

                    bufferAttribute = new THREE.InterleavedBufferAttribute(ib, itemSize, byteOffset / elementBytes, normalized);

                } else {

                    if (bufferView === null) {

                        array = new TypedArray(accessorDef.count * itemSize);

                    } else {

                        array = new TypedArray(bufferView, byteOffset, accessorDef.count * itemSize);

                    }

                    bufferAttribute = new THREE.BufferAttribute(array, itemSize, normalized);

                }

                // https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#sparse-accessors
                if (accessorDef.sparse !== undefined) {

                    var itemSizeIndices = WEBGL_TYPE_SIZES.SCALAR;
                    var TypedArrayIndices = WEBGL_COMPONENT_TYPES[accessorDef.sparse.indices.componentType];

                    var byteOffsetIndices = accessorDef.sparse.indices.byteOffset || 0;
                    var byteOffsetValues = accessorDef.sparse.values.byteOffset || 0;

                    var sparseIndices = new TypedArrayIndices(bufferViews[1], byteOffsetIndices, accessorDef.sparse.count * itemSizeIndices);
                    var sparseValues = new TypedArray(bufferViews[2], byteOffsetValues, accessorDef.sparse.count * itemSize);

                    if (bufferView !== null) {

                        // Avoid modifying the original ArrayBuffer, if the bufferView wasn't initialized with zeroes.
                        bufferAttribute.setArray(bufferAttribute.array.slice());

                    }

                    for (var i = 0, il = sparseIndices.length; i < il; i++) {

                        var index = sparseIndices[i];

                        bufferAttribute.setX(index, sparseValues[i * itemSize]);
                        if (itemSize >= 2) bufferAttribute.setY(index, sparseValues[i * itemSize + 1]);
                        if (itemSize >= 3) bufferAttribute.setZ(index, sparseValues[i * itemSize + 2]);
                        if (itemSize >= 4) bufferAttribute.setW(index, sparseValues[i * itemSize + 3]);
                        if (itemSize >= 5) throw new Error('THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.');

                    }

                }

                return bufferAttribute;

            });

        };

        /**
         * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
         * @param {number} textureIndex
         * @return {Promise<THREE.Texture>}
         */
        GLTFParser.prototype.loadTexture = function(textureIndex) {

            var parser = this;
            var json = this.json;
            var options = this.options;
            var textureLoader = this.textureLoader;

            var URL = window.URL || window.webkitURL;

            var textureDef = json.textures[textureIndex];

            var textureExtensions = textureDef.extensions || {};

            var source;

            if (textureExtensions[EXTENSIONS.MSFT_TEXTURE_DDS]) {

                source = json.images[textureExtensions[EXTENSIONS.MSFT_TEXTURE_DDS].source];

            } else {

                source = json.images[textureDef.source];

            }

            var sourceURI = source.uri;
            var isObjectURL = false;

            if (source.bufferView !== undefined) {

                // Load binary image data from bufferView, if provided.

                sourceURI = parser.getDependency('bufferView', source.bufferView).then(function(bufferView) {

                    isObjectURL = true;
                    var blob = new Blob([bufferView], { type: source.mimeType });
                    sourceURI = URL.createObjectURL(blob);
                    return sourceURI;

                });

            }

            return Promise.resolve(sourceURI).then(function(sourceURI) {

                // Load Texture resource.

                var loader = THREE.Loader.Handlers.get(sourceURI);

                if (!loader) {

                    loader = textureExtensions[EXTENSIONS.MSFT_TEXTURE_DDS] ?
                        parser.extensions[EXTENSIONS.MSFT_TEXTURE_DDS].ddsLoader :
                        textureLoader;

                }

                return new Promise(function(resolve, reject) {

                    loader.load(resolveURL(sourceURI, options.path), resolve, undefined, reject);

                });

            }).then(function(texture) {

                // Clean up resources and configure Texture.

                if (isObjectURL === true) {

                    URL.revokeObjectURL(sourceURI);

                }

                texture.flipY = false;

                if (textureDef.name !== undefined) texture.name = textureDef.name;

                // Ignore unknown mime types, like DDS files.
                if (source.mimeType in MIME_TYPE_FORMATS) {

                    texture.format = MIME_TYPE_FORMATS[source.mimeType];

                }

                var samplers = json.samplers || {};
                var sampler = samplers[textureDef.sampler] || {};

                texture.magFilter = WEBGL_FILTERS[sampler.magFilter] || THREE.LinearFilter;
                texture.minFilter = WEBGL_FILTERS[sampler.minFilter] || THREE.LinearMipMapLinearFilter;
                texture.wrapS = WEBGL_WRAPPINGS[sampler.wrapS] || THREE.RepeatWrapping;
                texture.wrapT = WEBGL_WRAPPINGS[sampler.wrapT] || THREE.RepeatWrapping;

                return texture;

            });

        };

        /**
         * Asynchronously assigns a texture to the given material parameters.
         * @param {Object} materialParams
         * @param {string} mapName
         * @param {Object} mapDef
         * @return {Promise}
         */
        GLTFParser.prototype.assignTexture = function(materialParams, mapName, mapDef) {

            var parser = this;

            return this.getDependency('texture', mapDef.index).then(function(texture) {

                if (parser.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM]) {

                    var transform = mapDef.extensions !== undefined ? mapDef.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM] : undefined;

                    if (transform) {

                        texture = parser.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM].extendTexture(texture, transform);

                    }

                }

                materialParams[mapName] = texture;

            });

        };

        /**
         * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
         * @param {number} materialIndex
         * @return {Promise<THREE.Material>}
         */
        GLTFParser.prototype.loadMaterial = function(materialIndex) {

            var parser = this;
            var json = this.json;
            var extensions = this.extensions;
            var materialDef = json.materials[materialIndex];

            var materialType;
            var materialParams = {};
            var materialExtensions = materialDef.extensions || {};

            var pending = [];

            if (materialExtensions[EXTENSIONS.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS]) {

                var sgExtension = extensions[EXTENSIONS.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS];
                materialType = sgExtension.getMaterialType(materialDef);
                pending.push(sgExtension.extendParams(materialParams, materialDef, parser));

            } else if (materialExtensions[EXTENSIONS.KHR_MATERIALS_UNLIT]) {

                var kmuExtension = extensions[EXTENSIONS.KHR_MATERIALS_UNLIT];
                materialType = kmuExtension.getMaterialType(materialDef);
                pending.push(kmuExtension.extendParams(materialParams, materialDef, parser));

            } else {

                // Specification:
                // https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#metallic-roughness-material

                materialType = THREE.MeshStandardMaterial;

                var metallicRoughness = materialDef.pbrMetallicRoughness || {};

                materialParams.color = new THREE.Color(1.0, 1.0, 1.0);
                materialParams.opacity = 1.0;

                if (Array.isArray(metallicRoughness.baseColorFactor)) {

                    var array = metallicRoughness.baseColorFactor;

                    materialParams.color.fromArray(array);
                    materialParams.opacity = array[3];

                }

                if (metallicRoughness.baseColorTexture !== undefined) {

                    pending.push(parser.assignTexture(materialParams, 'map', metallicRoughness.baseColorTexture));

                }

                materialParams.metalness = metallicRoughness.metallicFactor !== undefined ? metallicRoughness.metallicFactor : 1.0;
                materialParams.roughness = metallicRoughness.roughnessFactor !== undefined ? metallicRoughness.roughnessFactor : 1.0;

                if (metallicRoughness.metallicRoughnessTexture !== undefined) {

                    pending.push(parser.assignTexture(materialParams, 'metalnessMap', metallicRoughness.metallicRoughnessTexture));
                    pending.push(parser.assignTexture(materialParams, 'roughnessMap', metallicRoughness.metallicRoughnessTexture));

                }

            }

            if (materialDef.doubleSided === true) {

                materialParams.side = THREE.DoubleSide;

            }

            var alphaMode = materialDef.alphaMode || ALPHA_MODES.OPAQUE;

            if (alphaMode === ALPHA_MODES.BLEND) {

                materialParams.transparent = true;

            } else {

                materialParams.transparent = false;

                if (alphaMode === ALPHA_MODES.MASK) {

                    materialParams.alphaTest = materialDef.alphaCutoff !== undefined ? materialDef.alphaCutoff : 0.5;

                }

            }

            if (materialDef.normalTexture !== undefined && materialType !== THREE.MeshBasicMaterial) {

                pending.push(parser.assignTexture(materialParams, 'normalMap', materialDef.normalTexture));

                materialParams.normalScale = new THREE.Vector2(1, 1);

                if (materialDef.normalTexture.scale !== undefined) {

                    materialParams.normalScale.set(materialDef.normalTexture.scale, materialDef.normalTexture.scale);

                }

            }

            if (materialDef.occlusionTexture !== undefined && materialType !== THREE.MeshBasicMaterial) {

                pending.push(parser.assignTexture(materialParams, 'aoMap', materialDef.occlusionTexture));

                if (materialDef.occlusionTexture.strength !== undefined) {

                    materialParams.aoMapIntensity = materialDef.occlusionTexture.strength;

                }

            }

            if (materialDef.emissiveFactor !== undefined && materialType !== THREE.MeshBasicMaterial) {

                materialParams.emissive = new THREE.Color().fromArray(materialDef.emissiveFactor);

            }

            if (materialDef.emissiveTexture !== undefined && materialType !== THREE.MeshBasicMaterial) {

                pending.push(parser.assignTexture(materialParams, 'emissiveMap', materialDef.emissiveTexture));

            }

            return Promise.all(pending).then(function() {

                var material;

                if (materialType === THREE.ShaderMaterial) {

                    material = extensions[EXTENSIONS.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS].createMaterial(materialParams);

                } else {

                    material = new materialType(materialParams);

                }

                if (materialDef.name !== undefined) material.name = materialDef.name;

                // Normal map textures use OpenGL conventions:
                // https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#materialnormaltexture
                if (material.normalScale) {

                    material.normalScale.y = -material.normalScale.y;

                }

                // baseColorTexture, emissiveTexture, and specularGlossinessTexture use sRGB encoding.
                if (material.map) material.map.encoding = THREE.sRGBEncoding;
                if (material.emissiveMap) material.emissiveMap.encoding = THREE.sRGBEncoding;
                if (material.specularMap) material.specularMap.encoding = THREE.sRGBEncoding;

                assignExtrasToUserData(material, materialDef);

                if (materialDef.extensions) addUnknownExtensionsToUserData(extensions, material, materialDef);

                return material;

            });

        };

        /**
         * @param {THREE.BufferGeometry} geometry
         * @param {GLTF.Primitive} primitiveDef
         * @param {GLTFParser} parser
         * @return {Promise<THREE.BufferGeometry>}
         */
        function addPrimitiveAttributes(geometry, primitiveDef, parser) {

            var attributes = primitiveDef.attributes;

            var pending = [];

            function assignAttributeAccessor(accessorIndex, attributeName) {

                return parser.getDependency('accessor', accessorIndex)
                    .then(function(accessor) {

                        geometry.addAttribute(attributeName, accessor);

                    });

            }

            for (var gltfAttributeName in attributes) {

                var threeAttributeName = ATTRIBUTES[gltfAttributeName];

                if (!threeAttributeName) continue;

                // Skip attributes already provided by e.g. Draco extension.
                if (threeAttributeName in geometry.attributes) continue;

                pending.push(assignAttributeAccessor(attributes[gltfAttributeName], threeAttributeName));

            }

            if (primitiveDef.indices !== undefined && !geometry.index) {

                var accessor = parser.getDependency('accessor', primitiveDef.indices).then(function(accessor) {

                    geometry.setIndex(accessor);

                });

                pending.push(accessor);

            }

            assignExtrasToUserData(geometry, primitiveDef);

            return Promise.all(pending).then(function() {

                return primitiveDef.targets !== undefined ?
                    addMorphTargets(geometry, primitiveDef.targets, parser) :
                    geometry;

            });

        }

        /**
         * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
         *
         * Creates BufferGeometries from primitives.
         * If we can build a single BufferGeometry with .groups from multiple primitives, returns one BufferGeometry.
         * Otherwise, returns BufferGeometries without .groups as many as primitives.
         *
         * @param {Array<GLTF.Primitive>} primitives
         * @return {Promise<Array<THREE.BufferGeometry>>}
         */
        GLTFParser.prototype.loadGeometries = function(primitives) {

            var parser = this;
            var extensions = this.extensions;
            var cache = this.primitiveCache;

            var isMultiPass = isMultiPassGeometry(primitives);
            var originalPrimitives;

            if (isMultiPass) {

                originalPrimitives = primitives; // save original primitives and use later

                // We build a single BufferGeometry with .groups from multiple primitives
                // because all primitives share the same attributes/morph/mode and have indices.

                primitives = [primitives[0]];

                // Sets .groups and combined indices to a geometry later in this method.

            }

            function createDracoPrimitive(primitive) {

                return extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION]
                    .decodePrimitive(primitive, parser)
                    .then(function(geometry) {

                        return addPrimitiveAttributes(geometry, primitive, parser);

                    });

            }

            var pending = [];

            for (var i = 0, il = primitives.length; i < il; i++) {

                var primitive = primitives[i];

                // See if we've already created this geometry
                var cached = getCachedGeometry(cache, primitive);

                if (cached) {

                    // Use the cached geometry if it exists
                    pending.push(cached);

                } else {

                    var geometryPromise;

                    if (primitive.extensions && primitive.extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION]) {

                        // Use DRACO geometry if available
                        geometryPromise = createDracoPrimitive(primitive);

                    } else {

                        // Otherwise create a new geometry
                        geometryPromise = addPrimitiveAttributes(new THREE.BufferGeometry(), primitive, parser);

                    }

                    // Cache this geometry
                    cache.push({ primitive: primitive, promise: geometryPromise });

                    pending.push(geometryPromise);

                }

            }

            return Promise.all(pending).then(function(geometries) {

                if (isMultiPass) {

                    var baseGeometry = geometries[0];

                    // See if we've already created this combined geometry
                    var cache = parser.multiPassGeometryCache;
                    var cached = getCachedMultiPassGeometry(cache, baseGeometry, originalPrimitives);

                    if (cached !== null) return [cached.geometry];

                    // Cloning geometry because of index override.
                    // Attributes can be reused so cloning by myself here.
                    var geometry = new THREE.BufferGeometry();

                    geometry.name = baseGeometry.name;
                    geometry.userData = baseGeometry.userData;

                    for (var key in baseGeometry.attributes) geometry.addAttribute(key, baseGeometry.attributes[key]);
                    for (var key in baseGeometry.morphAttributes) geometry.morphAttributes[key] = baseGeometry.morphAttributes[key];

                    var pendingIndices = [];

                    for (var i = 0, il = originalPrimitives.length; i < il; i++) {

                        pendingIndices.push(parser.getDependency('accessor', originalPrimitives[i].indices));

                    }

                    return Promise.all(pendingIndices).then(function(accessors) {

                        var indices = [];
                        var offset = 0;

                        for (var i = 0, il = originalPrimitives.length; i < il; i++) {

                            var accessor = accessors[i];

                            for (var j = 0, jl = accessor.count; j < jl; j++) indices.push(accessor.array[j]);

                            geometry.addGroup(offset, accessor.count, i);

                            offset += accessor.count;

                        }

                        geometry.setIndex(indices);

                        cache.push({ geometry: geometry, baseGeometry: baseGeometry, primitives: originalPrimitives });

                        return [geometry];

                    });

                } else if (geometries.length > 1 && THREE.BufferGeometryUtils !== undefined) {

                    // Tries to merge geometries with BufferGeometryUtils if possible

                    for (var i = 1, il = primitives.length; i < il; i++) {

                        // can't merge if draw mode is different
                        if (primitives[0].mode !== primitives[i].mode) return geometries;

                    }

                    // See if we've already created this combined geometry
                    var cache = parser.multiplePrimitivesCache;
                    var cached = getCachedCombinedGeometry(cache, geometries);

                    if (cached) {

                        if (cached.geometry !== null) return [cached.geometry];

                    } else {

                        var geometry = THREE.BufferGeometryUtils.mergeBufferGeometries(geometries, true);

                        cache.push({ geometry: geometry, baseGeometries: geometries });

                        if (geometry !== null) return [geometry];

                    }

                }

                return geometries;

            });

        };

        /**
         * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
         * @param {number} meshIndex
         * @return {Promise<THREE.Group|THREE.Mesh|THREE.SkinnedMesh>}
         */
        GLTFParser.prototype.loadMesh = function(meshIndex) {

            var parser = this;
            var json = this.json;
            var extensions = this.extensions;

            var meshDef = json.meshes[meshIndex];
            var primitives = meshDef.primitives;

            var pending = [];

            for (var i = 0, il = primitives.length; i < il; i++) {

                var material = primitives[i].material === undefined ?
                    createDefaultMaterial() :
                    this.getDependency('material', primitives[i].material);

                pending.push(material);

            }

            return Promise.all(pending).then(function(originalMaterials) {

                return parser.loadGeometries(primitives).then(function(geometries) {

                    var isMultiMaterial = geometries.length === 1 && geometries[0].groups.length > 0;

                    var meshes = [];

                    for (var i = 0, il = geometries.length; i < il; i++) {

                        var geometry = geometries[i];
                        var primitive = primitives[i];

                        // 1. create Mesh

                        var mesh;

                        var material = isMultiMaterial ? originalMaterials : originalMaterials[i];

                        if (primitive.mode === WEBGL_CONSTANTS.TRIANGLES ||
                            primitive.mode === WEBGL_CONSTANTS.TRIANGLE_STRIP ||
                            primitive.mode === WEBGL_CONSTANTS.TRIANGLE_FAN ||
                            primitive.mode === undefined) {

                            // .isSkinnedMesh isn't in glTF spec. See .markDefs()
                            mesh = meshDef.isSkinnedMesh === true ?
                                new THREE.SkinnedMesh(geometry, material) :
                                new THREE.Mesh(geometry, material);

                            if (primitive.mode === WEBGL_CONSTANTS.TRIANGLE_STRIP) {

                                mesh.drawMode = THREE.TriangleStripDrawMode;

                            } else if (primitive.mode === WEBGL_CONSTANTS.TRIANGLE_FAN) {

                                mesh.drawMode = THREE.TriangleFanDrawMode;

                            }

                        } else if (primitive.mode === WEBGL_CONSTANTS.LINES) {

                            mesh = new THREE.LineSegments(geometry, material);

                        } else if (primitive.mode === WEBGL_CONSTANTS.LINE_STRIP) {

                            mesh = new THREE.Line(geometry, material);

                        } else if (primitive.mode === WEBGL_CONSTANTS.LINE_LOOP) {

                            mesh = new THREE.LineLoop(geometry, material);

                        } else if (primitive.mode === WEBGL_CONSTANTS.POINTS) {

                            mesh = new THREE.Points(geometry, material);

                        } else {

                            throw new Error('THREE.GLTFLoader: Primitive mode unsupported: ' + primitive.mode);

                        }

                        if (Object.keys(mesh.geometry.morphAttributes).length > 0) {

                            updateMorphTargets(mesh, meshDef);

                        }

                        mesh.name = meshDef.name || ('mesh_' + meshIndex);

                        if (geometries.length > 1) mesh.name += '_' + i;

                        assignExtrasToUserData(mesh, meshDef);

                        meshes.push(mesh);

                        // 2. update Material depending on Mesh and BufferGeometry

                        var materials = isMultiMaterial ? mesh.material : [mesh.material];

                        var useVertexColors = geometry.attributes.color !== undefined;
                        var useFlatShading = geometry.attributes.normal === undefined;
                        var useSkinning = mesh.isSkinnedMesh === true;
                        var useMorphTargets = Object.keys(geometry.morphAttributes).length > 0;
                        var useMorphNormals = useMorphTargets && geometry.morphAttributes.normal !== undefined;

                        for (var j = 0, jl = materials.length; j < jl; j++) {

                            var material = materials[j];

                            if (mesh.isPoints) {

                                var cacheKey = 'PointsMaterial:' + material.uuid;

                                var pointsMaterial = parser.cache.get(cacheKey);

                                if (!pointsMaterial) {

                                    pointsMaterial = new THREE.PointsMaterial();
                                    THREE.Material.prototype.copy.call(pointsMaterial, material);
                                    pointsMaterial.color.copy(material.color);
                                    pointsMaterial.map = material.map;
                                    pointsMaterial.lights = false; // PointsMaterial doesn't support lights yet

                                    parser.cache.add(cacheKey, pointsMaterial);

                                }

                                material = pointsMaterial;

                            } else if (mesh.isLine) {

                                var cacheKey = 'LineBasicMaterial:' + material.uuid;

                                var lineMaterial = parser.cache.get(cacheKey);

                                if (!lineMaterial) {

                                    lineMaterial = new THREE.LineBasicMaterial();
                                    THREE.Material.prototype.copy.call(lineMaterial, material);
                                    lineMaterial.color.copy(material.color);
                                    lineMaterial.lights = false; // LineBasicMaterial doesn't support lights yet

                                    parser.cache.add(cacheKey, lineMaterial);

                                }

                                material = lineMaterial;

                            }

                            // Clone the material if it will be modified
                            if (useVertexColors || useFlatShading || useSkinning || useMorphTargets) {

                                var cacheKey = 'ClonedMaterial:' + material.uuid + ':';

                                if (material.isGLTFSpecularGlossinessMaterial) cacheKey += 'specular-glossiness:';
                                if (useSkinning) cacheKey += 'skinning:';
                                if (useVertexColors) cacheKey += 'vertex-colors:';
                                if (useFlatShading) cacheKey += 'flat-shading:';
                                if (useMorphTargets) cacheKey += 'morph-targets:';
                                if (useMorphNormals) cacheKey += 'morph-normals:';

                                var cachedMaterial = parser.cache.get(cacheKey);

                                if (!cachedMaterial) {

                                    cachedMaterial = material.isGLTFSpecularGlossinessMaterial ?
                                        extensions[EXTENSIONS.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS].cloneMaterial(material) :
                                        material.clone();

                                    if (useSkinning) cachedMaterial.skinning = true;
                                    if (useVertexColors) cachedMaterial.vertexColors = THREE.VertexColors;
                                    if (useFlatShading) cachedMaterial.flatShading = true;
                                    if (useMorphTargets) cachedMaterial.morphTargets = true;
                                    if (useMorphNormals) cachedMaterial.morphNormals = true;

                                    parser.cache.add(cacheKey, cachedMaterial);

                                }

                                material = cachedMaterial;

                            }

                            materials[j] = material;

                            // workarounds for mesh and geometry

                            if (material.aoMap && geometry.attributes.uv2 === undefined && geometry.attributes.uv !== undefined) {

                                console.log('THREE.GLTFLoader: Duplicating UVs to support aoMap.');
                                geometry.addAttribute('uv2', new THREE.BufferAttribute(geometry.attributes.uv.array, 2));

                            }

                            if (material.isGLTFSpecularGlossinessMaterial) {

                                // for GLTFSpecularGlossinessMaterial(ShaderMaterial) uniforms runtime update
                                mesh.onBeforeRender = extensions[EXTENSIONS.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS].refreshUniforms;

                            }

                        }

                        mesh.material = isMultiMaterial ? materials : materials[0];

                    }

                    if (meshes.length === 1) {

                        return meshes[0];

                    }

                    var group = new THREE.Group();

                    for (var i = 0, il = meshes.length; i < il; i++) {

                        group.add(meshes[i]);

                    }

                    return group;

                });

            });

        };

        /**
         * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
         * @param {number} cameraIndex
         * @return {Promise<THREE.Camera>}
         */
        GLTFParser.prototype.loadCamera = function(cameraIndex) {

            var camera;
            var cameraDef = this.json.cameras[cameraIndex];
            var params = cameraDef[cameraDef.type];

            if (!params) {

                console.warn('THREE.GLTFLoader: Missing camera parameters.');
                return;

            }

            if (cameraDef.type === 'perspective') {

                camera = new THREE.PerspectiveCamera(THREE.Math.radToDeg(params.yfov), params.aspectRatio || 1, params.znear || 1, params.zfar || 2e6);

            } else if (cameraDef.type === 'orthographic') {

                camera = new THREE.OrthographicCamera(params.xmag / -2, params.xmag / 2, params.ymag / 2, params.ymag / -2, params.znear, params.zfar);

            }

            if (cameraDef.name !== undefined) camera.name = cameraDef.name;

            assignExtrasToUserData(camera, cameraDef);

            return Promise.resolve(camera);

        };

        /**
         * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
         * @param {number} skinIndex
         * @return {Promise<Object>}
         */
        GLTFParser.prototype.loadSkin = function(skinIndex) {

            var skinDef = this.json.skins[skinIndex];

            var skinEntry = { joints: skinDef.joints };

            if (skinDef.inverseBindMatrices === undefined) {

                return Promise.resolve(skinEntry);

            }

            return this.getDependency('accessor', skinDef.inverseBindMatrices).then(function(accessor) {

                skinEntry.inverseBindMatrices = accessor;

                return skinEntry;

            });

        };

        /**
         * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
         * @param {number} animationIndex
         * @return {Promise<THREE.AnimationClip>}
         */
        GLTFParser.prototype.loadAnimation = function(animationIndex) {

            var json = this.json;

            var animationDef = json.animations[animationIndex];

            var pendingNodes = [];
            var pendingInputAccessors = [];
            var pendingOutputAccessors = [];
            var pendingSamplers = [];
            var pendingTargets = [];

            for (var i = 0, il = animationDef.channels.length; i < il; i++) {

                var channel = animationDef.channels[i];
                var sampler = animationDef.samplers[channel.sampler];
                var target = channel.target;
                var name = target.node !== undefined ? target.node : target.id; // NOTE: target.id is deprecated.
                var input = animationDef.parameters !== undefined ? animationDef.parameters[sampler.input] : sampler.input;
                var output = animationDef.parameters !== undefined ? animationDef.parameters[sampler.output] : sampler.output;

                pendingNodes.push(this.getDependency('node', name));
                pendingInputAccessors.push(this.getDependency('accessor', input));
                pendingOutputAccessors.push(this.getDependency('accessor', output));
                pendingSamplers.push(sampler);
                pendingTargets.push(target);

            }

            return Promise.all([

                Promise.all(pendingNodes),
                Promise.all(pendingInputAccessors),
                Promise.all(pendingOutputAccessors),
                Promise.all(pendingSamplers),
                Promise.all(pendingTargets)

            ]).then(function(dependencies) {

                var nodes = dependencies[0];
                var inputAccessors = dependencies[1];
                var outputAccessors = dependencies[2];
                var samplers = dependencies[3];
                var targets = dependencies[4];

                var tracks = [];

                for (var i = 0, il = nodes.length; i < il; i++) {

                    var node = nodes[i];
                    var inputAccessor = inputAccessors[i];
                    var outputAccessor = outputAccessors[i];
                    var sampler = samplers[i];
                    var target = targets[i];

                    if (node === undefined) continue;

                    node.updateMatrix();
                    node.matrixAutoUpdate = true;

                    var TypedKeyframeTrack;

                    switch (PATH_PROPERTIES[target.path]) {

                        case PATH_PROPERTIES.weights:

                            TypedKeyframeTrack = THREE.NumberKeyframeTrack;
                            break;

                        case PATH_PROPERTIES.rotation:

                            TypedKeyframeTrack = THREE.QuaternionKeyframeTrack;
                            break;

                        case PATH_PROPERTIES.position:
                        case PATH_PROPERTIES.scale:
                        default:

                            TypedKeyframeTrack = THREE.VectorKeyframeTrack;
                            break;

                    }

                    var targetName = node.name ? node.name : node.uuid;

                    var interpolation = sampler.interpolation !== undefined ? INTERPOLATION[sampler.interpolation] : THREE.InterpolateLinear;

                    var targetNames = [];

                    if (PATH_PROPERTIES[target.path] === PATH_PROPERTIES.weights) {

                        // node can be THREE.Group here but
                        // PATH_PROPERTIES.weights(morphTargetInfluences) should be
                        // the property of a mesh object under group.

                        node.traverse(function(object) {

                            if (object.isMesh === true && object.morphTargetInfluences) {

                                targetNames.push(object.name ? object.name : object.uuid);

                            }

                        });

                    } else {

                        targetNames.push(targetName);

                    }

                    // KeyframeTrack.optimize() will modify given 'times' and 'values'
                    // buffers before creating a truncated copy to keep. Because buffers may
                    // be reused by other tracks, make copies here.
                    for (var j = 0, jl = targetNames.length; j < jl; j++) {

                        var track = new TypedKeyframeTrack(
                            targetNames[j] + '.' + PATH_PROPERTIES[target.path],
                            THREE.AnimationUtils.arraySlice(inputAccessor.array, 0),
                            THREE.AnimationUtils.arraySlice(outputAccessor.array, 0),
                            interpolation
                        );

                        // Here is the trick to enable custom interpolation.
                        // Overrides .createInterpolant in a factory method which creates custom interpolation.
                        if (sampler.interpolation === 'CUBICSPLINE') {

                            track.createInterpolant = function InterpolantFactoryMethodGLTFCubicSpline(result) {

                                // A CUBICSPLINE keyframe in glTF has three output values for each input value,
                                // representing inTangent, splineVertex, and outTangent. As a result, track.getValueSize()
                                // must be divided by three to get the interpolant's sampleSize argument.

                                return new GLTFCubicSplineInterpolant(this.times, this.values, this.getValueSize() / 3, result);

                            };

                            // Workaround, provide an alternate way to know if the interpolant type is cubis spline to track.
                            // track.getInterpolation() doesn't return valid value for custom interpolant.
                            track.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = true;

                        }

                        tracks.push(track);

                    }

                }

                var name = animationDef.name !== undefined ? animationDef.name : 'animation_' + animationIndex;

                return new THREE.AnimationClip(name, undefined, tracks);

            });

        };

        /**
         * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
         * @param {number} nodeIndex
         * @return {Promise<THREE.Object3D>}
         */
        GLTFParser.prototype.loadNode = function(nodeIndex) {

            var json = this.json;
            var extensions = this.extensions;
            var parser = this;

            var meshReferences = json.meshReferences;
            var meshUses = json.meshUses;

            var nodeDef = json.nodes[nodeIndex];

            return new Promise(function(resolve) {

                // .isBone isn't in glTF spec. See .markDefs
                if (nodeDef.isBone === true) {

                    resolve(new THREE.Bone());

                } else if (nodeDef.mesh !== undefined) {

                    parser.getDependency('mesh', nodeDef.mesh).then(function(mesh) {

                        var node;

                        if (meshReferences[nodeDef.mesh] > 1) {

                            var instanceNum = meshUses[nodeDef.mesh]++;

                            node = mesh.clone();
                            node.name += '_instance_' + instanceNum;

                            // onBeforeRender copy for Specular-Glossiness
                            node.onBeforeRender = mesh.onBeforeRender;

                            for (var i = 0, il = node.children.length; i < il; i++) {

                                node.children[i].name += '_instance_' + instanceNum;
                                node.children[i].onBeforeRender = mesh.children[i].onBeforeRender;

                            }

                        } else {

                            node = mesh;

                        }

                        resolve(node);

                    });

                } else if (nodeDef.camera !== undefined) {

                    parser.getDependency('camera', nodeDef.camera).then(resolve);

                } else if (nodeDef.extensions &&
                    nodeDef.extensions[EXTENSIONS.KHR_LIGHTS_PUNCTUAL] &&
                    nodeDef.extensions[EXTENSIONS.KHR_LIGHTS_PUNCTUAL].light !== undefined) {

                    parser.getDependency('light', nodeDef.extensions[EXTENSIONS.KHR_LIGHTS_PUNCTUAL].light).then(resolve);

                } else {

                    resolve(new THREE.Object3D());

                }

            }).then(function(node) {

                if (nodeDef.name !== undefined) {

                    node.name = THREE.PropertyBinding.sanitizeNodeName(nodeDef.name);

                }

                assignExtrasToUserData(node, nodeDef);

                if (nodeDef.extensions) addUnknownExtensionsToUserData(extensions, node, nodeDef);

                if (nodeDef.matrix !== undefined) {

                    var matrix = new THREE.Matrix4();
                    matrix.fromArray(nodeDef.matrix);
                    node.applyMatrix(matrix);

                } else {

                    if (nodeDef.translation !== undefined) {

                        node.position.fromArray(nodeDef.translation);

                    }

                    if (nodeDef.rotation !== undefined) {

                        node.quaternion.fromArray(nodeDef.rotation);

                    }

                    if (nodeDef.scale !== undefined) {

                        node.scale.fromArray(nodeDef.scale);

                    }

                }

                return node;

            });

        };

        /**
         * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
         * @param {number} sceneIndex
         * @return {Promise<THREE.Scene>}
         */
        GLTFParser.prototype.loadScene = function() {

            // scene node hierachy builder

            function buildNodeHierachy(nodeId, parentObject, json, parser) {

                var nodeDef = json.nodes[nodeId];

                return parser.getDependency('node', nodeId).then(function(node) {

                    if (nodeDef.skin === undefined) return node;

                    // build skeleton here as well

                    var skinEntry;

                    return parser.getDependency('skin', nodeDef.skin).then(function(skin) {

                        skinEntry = skin;

                        var pendingJoints = [];

                        for (var i = 0, il = skinEntry.joints.length; i < il; i++) {

                            pendingJoints.push(parser.getDependency('node', skinEntry.joints[i]));

                        }

                        return Promise.all(pendingJoints);

                    }).then(function(jointNodes) {

                        var meshes = node.isGroup === true ? node.children : [node];

                        for (var i = 0, il = meshes.length; i < il; i++) {

                            var mesh = meshes[i];

                            var bones = [];
                            var boneInverses = [];

                            for (var j = 0, jl = jointNodes.length; j < jl; j++) {

                                var jointNode = jointNodes[j];

                                if (jointNode) {

                                    bones.push(jointNode);

                                    var mat = new THREE.Matrix4();

                                    if (skinEntry.inverseBindMatrices !== undefined) {

                                        mat.fromArray(skinEntry.inverseBindMatrices.array, j * 16);

                                    }

                                    boneInverses.push(mat);

                                } else {

                                    console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', skinEntry.joints[j]);

                                }

                            }

                            mesh.bind(new THREE.Skeleton(bones, boneInverses), mesh.matrixWorld);

                        };

                        return node;

                    });

                }).then(function(node) {

                    // build node hierachy

                    parentObject.add(node);

                    var pending = [];

                    if (nodeDef.children) {

                        var children = nodeDef.children;

                        for (var i = 0, il = children.length; i < il; i++) {

                            var child = children[i];
                            pending.push(buildNodeHierachy(child, node, json, parser));

                        }

                    }

                    return Promise.all(pending);

                });

            }

            return function loadScene(sceneIndex) {

                var json = this.json;
                var extensions = this.extensions;
                var sceneDef = this.json.scenes[sceneIndex];
                var parser = this;

                var scene = new THREE.Scene();
                if (sceneDef.name !== undefined) scene.name = sceneDef.name;

                assignExtrasToUserData(scene, sceneDef);

                if (sceneDef.extensions) addUnknownExtensionsToUserData(extensions, scene, sceneDef);

                var nodeIds = sceneDef.nodes || [];

                var pending = [];

                for (var i = 0, il = nodeIds.length; i < il; i++) {

                    pending.push(buildNodeHierachy(nodeIds[i], scene, json, parser));

                }

                return Promise.all(pending).then(function() {

                    return scene;

                });

            };

        }();

        return GLTFLoader;

    })();
}


// WEBPACK FOOTER //
// ./src/pages/webgl/src/GLTFLoader.js